import { useEffect, useMemo, useState, useCallback } from 'react';
import * as anchor from '@project-serum/anchor';

import styled from 'styled-components';
import { Snackbar } from '@material-ui/core';

import { MintCountdown } from './MintCountdown';
import { ProgressBar } from './ProgressBar';

// import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import { PublicKey } from '@solana/web3.js';
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletDialogButton } from '@solana/wallet-adapter-material-ui';
import {
  awaitTransactionSignatureConfirmation,
  CandyMachineAccount,
  CANDY_MACHINE_PROGRAM,
  getCandyMachineState,
  mintOneToken,
} from './candy-machine';
import { AlertState, toDate } from './utils';
// import { Header } from './Header';
// import { Price } from './Price';
import { MintButton } from './MintButton';
import { GatewayProvider } from '@civic/solana-gateway-react';

// const ConnectButton = styled(WalletDialogButton)`
//   width: 100%;
//   height: 60px;
//   margin-top: 10px;
//   margin-bottom: 5px;
//   background: linear-gradient(180deg, #604ae5 0%, #813eee 100%);
//   color: white;
//   font-size: 16px;
//   font-weight: bold;
// `;

const MintContainer = styled.div`
// position: absolute;
// bottom: 100%;
// background: linear-gradient(-180deg, #8bffc5, #36cdd9);
// border-radius: 17px 17px 0 0;
// padding: 5px 10px;
// border: 7px solid #000;
// border-bottom: 0;
// width: 200px;

// @media (max-width: 800px) {
//   width: 100px;
// }
`; // add your owns styles here

export interface HomeProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  txTimeout: number;
  rpcHost: string;
}


const Home = (props: HomeProps) => {
  const [isUserMinting, setIsUserMinting] = useState(false);
  const [candyMachine, setCandyMachine] = useState<CandyMachineAccount>();
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: '',
    severity: undefined,
  });

  const rpcUrl = props.rpcHost;
  const wallet = useWallet();

  const anchorWallet = useMemo(() => {
    if (
      !wallet ||
      !wallet.publicKey ||
      !wallet.signAllTransactions ||
      !wallet.signTransaction
    ) {
      return;
    }

    return {
      publicKey: wallet.publicKey,
      signAllTransactions: wallet.signAllTransactions,
      signTransaction: wallet.signTransaction,
    } as anchor.Wallet;
  }, [wallet]);

  const refreshCandyMachineState = useCallback(async () => {
    if (!anchorWallet) {
      return;
    }

    if (props.candyMachineId) {
      try {
        const cndy = await getCandyMachineState(
          anchorWallet,
          props.candyMachineId,
          props.connection,
        );
        setCandyMachine(cndy);
      } catch (e) {
        console.log('There was a problem fetching Candy Machine state');
        console.log(e);
      }
    }
  }, [anchorWallet, props.candyMachineId, props.connection]);

  const onMint = async () => {
    try {
      setIsUserMinting(true);
      document.getElementById('#identity')?.click();
      if (wallet.connected && candyMachine?.program && wallet.publicKey) {
        const mintTxId = (
          await mintOneToken(candyMachine, wallet.publicKey)
        )[0];

        let status: any = { err: true };
        if (mintTxId) {
          status = await awaitTransactionSignatureConfirmation(
            mintTxId,
            props.txTimeout,
            props.connection,
            true,
          );
        }

        if (status && !status.err) {
          setAlertState({
            open: true,
            message: 'Congratulations! Mint succeeded!',
            severity: 'success',
          });
        } else {
          setAlertState({
            open: true,
            message: 'Mint failed! Please try again!',
            severity: 'error',
          });
        }
      }
    } catch (error: any) {
      let message = error.msg || 'Minting failed! Please try again!';
      if (!error.msg) {
        if (!error.message) {
          message = 'Transaction Timeout! Please try again.';
        } else if (error.message.indexOf('0x137')) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf('0x135')) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          window.location.reload();
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: 'error',
      });
    } finally {
      setIsUserMinting(false);
    }
  };

  useEffect(() => {
    refreshCandyMachineState();
  }, [
    anchorWallet,
    props.candyMachineId,
    props.connection,
    refreshCandyMachineState,
  ]);

  // cm states
  //console.log("isActive", candyMachine)
  // console.log("isActive", candyMachine?.state?.isActive)
  // console.log("goLiveDate", candyMachine?.state?.goLiveDate)
  // console.log("isPresale", candyMachine?.state?.isPresale)
  // console.log("isPresaleExist", new anchor.BN(new Date().getTime() / 1000))
  // console.log("isSoldOut", candyMachine?.state?.isSoldOut)
  
  return (
    <div className="wrapper">
    <nav>
      <a href={"#top"} className="logo">
        <svg viewBox="0 0 490 315" fill="none">
          <path
            d="M219.985 156.324c6.1 0 12.1 0 18 1.6.4.1.8.3 1.2.4 5 1.2 8.1 4.6 9.4 9.3 1.5 5.6 2.6 11.2 3.6 16.9 1.8 11 3.4 22.1 5.2 33.1.3 2.1 1 4.2 1.8 6.2 1.1 2.6 2.8 2.7 4.5.5 2.7-3.5 4.3-7.6 5.7-11.7 1.3-3.7 2.2-7.4 3.4-11.1 1-2.8 2.3-5.5 3.4-8.2 2.5-6.7 5-13.3 7.5-20 .6-1.6 1.3-3.1 2-4.6 2.1-4.1 5.5-6 10-6.1 6.5-.2 12.9.7 19.4 1.5 2.1.3 4.1.8 5.9 1.9 2.7 1.7 3.9 4.3 3.8 7.5-.3 7.2-3.4 13.6-6.2 20-2.8 6.5-6.2 12.7-9.2 19.1-5.3 10.9-10.6 21.7-15.7 32.7-3.8 8.3-7.2 16.9-11 25.2-1.2 2.7-3.3 5.1-5.2 7.3-.8.9-2.4 1.7-3.7 1.7-9.2.1-18.5-.1-27.6-1.5-4.2-.6-7.3-2.7-8.9-7-1.9-5.2-4.2-10.2-6.1-15.3-3.5-9.4-6.9-18.8-10.1-28.3-3.3-9.8-6.4-19.7-9.2-29.6-3.2-11.1-5.9-22.3-8.8-33.4-.8-3.2.6-5.2 3.7-6.3 4.3-1.9 8.8-1.8 13.2-1.8ZM88.685 146.124c1.3.1 2.6 0 3.9.3 3.1.7 5.3 2.7 6 5.8 1.3 5.8 2.5 11.7 3.4 17.6.9 5.8-1.2 8.9-6.9 10.5-4.1 1.1-8.3 1.8-12.5 2.6-5.2 1-8.1 5.9-6.4 10.9.9 2.6 3.1 4.3 6.3 4.1 3.4-.2 6.8-.8 10.2-1.5 2.9-.5 5.7-1.4 8.5-2 6.6-1.4 10.3.9 11.7 7.5 1 4.9 1.7 9.9 2.6 14.8.3 1.6.7 3.3 1.1 4.9 1 4.6-.6 7.6-5.2 8.6-3.5.8-7 .9-10.6 1.4-1.3.2-2.7.3-4 .7-3.7 1.3-5.8 5.5-4.9 9.3.5 2.1 2.4 3.7 5 3.5 3.5-.2 6.9-.8 10.4-1.5 3.3-.6 6.5-1.5 9.8-2.2 1.1-.2 2.4-.2 3.5-.2 1.4.1 2.5.8 2.8 2.3 1.5 6.6 3.1 13.1 4.5 19.7.2 1.1.3 2.3.3 3.4.2 4.9-1.7 8-6.3 9.5-3.7 1.2-7.6 2-11.5 2.6-6 .9-12 1.3-18 2.4-5.2 1-10.2 2.7-15.3 4-2.9.7-5.8 1.2-8.8.5-3.5-.8-5.7-2.8-6.2-6.4-2.3-17.9-7.9-34.9-13.2-52-4-12.9-8-25.9-11.7-38.9-2.3-8.3-3.8-16.7-4.2-25.3-.2-4.6 2.6-7.8 7.1-8.6 11.1-2.1 22.1-4.4 33.2-6.5 5-.9 10.1-1.5 15.2-2.3.2.4.2.4.2.5ZM113.285 135.624c-20.3-.4-35.9-9.5-47.6-25.9-6.5-9.1-10.4-19.3-11.9-30.3-.9-7-1.7-14.1-.3-21.1 2-10.1 7.6-18 15.4-24.4 8.8-7.2 19-11.9 30-14.8 6.2-1.7 12.5-2.8 18.8-3.8 5.3-.9 9.2 2.3 10.1 8.3.7 4.4.9 8.8 1.4 13.2.3 2.2.6 4.5 1.1 6.7.6 2.8-.2 5.3-2.6 6.9-2.7 1.8-5.9 2.3-9.1 2.7-4.9.7-9.9.8-14.6 2.1-6.8 1.7-12.3 5.5-14.2 12.8-1.4 5-.2 9.9 1.8 14.5 3.4 7.9 8.7 14.2 15.7 19.2.5.3 1 .6 1.6.8 2.3.6 4.2-1.2 3.6-3.5-1.4-5.3-2.9-10.6-4.2-16-.9-3.9-1.7-7.8-2.1-11.8-.5-5.1 2-8.5 7-9.5 5.7-1.1 11.5-2.3 17.2-2.7 6.8-.5 9.6 2 10.8 8.7 1.2 6.5 2 13 3.2 19.5 1.3 7.1 2.7 14.1 4.1 21.1.9 4.4 1.7 8.7.9 13.2-.8 4.2-3 7.3-6.9 8.8-3.5 1.3-7.2 2.1-10.9 2.8-6 1.3-12 2.7-18.3 2.5ZM367.585 314.024c-5.9-.2-11.5-1.9-17-3.8-7.5-2.6-15-5.4-22.6-7.9-2.7-.9-5.5-1.4-8.3-1.9-4-.6-6.9-3.8-7.2-8-.2-3.9.6-7.6 1.8-11.3 1.6-4.8 3.2-9.6 5-14.4 1.9-5.1 2.1-10.5 3.2-15.8 2.4-11.1 5.3-22 8-33 1.4-5.8 2.8-11.7 3.9-17.5.7-4 .8-8.1 1.6-12 .9-5 2.5-9.7 6.2-13.5 3.1-3.1 6.9-4.5 11.1-3.4 13.6 3.2 27.2 6.4 40.1 11.9 1.8.8 3.6 1.7 5.3 2.8 2.3 1.4 3.4 4.1 2.7 6.7-1.4 5.4-2.7 10.9-4.2 16.3-2 7.3-5.4 9.5-12.8 7.9-3.9-.9-7.8-2.2-11.6-3.6-4.1-1.6-7-.3-8.2 3.9l-.9 3.6c-.7 3.2.9 5.7 4.1 6.5 4 1 8 1.9 11.9 3 2.2.6 4.4 1.3 6.4 2.2 5.3 2.3 7 5.2 5.7 10.8-1.7 7.4-3.7 14.6-5.8 21.9-.8 2.9-3.4 4.3-6.6 3.5-3.5-.9-6.8-2.3-10.3-3.5-2.8-1-5.6-1.9-8.4-2.9-1.2-.4-2 0-2.4 1.2-.5 1.5-1 3.1-1.4 4.6-.9 3.7.3 6.6 3.7 8.4 3.6 2 7.6 2.6 11.6 3.3 2.1.4 4.3.7 6.4 1.2 2.8.6 4.5 2.4 4.1 5.3-.4 3.2-1.3 6.3-2.3 9.4-1 3.2-2.4 6.2-3.6 9.4-.4 1-.6 2.1-.8 3.1-.6 3.7-2.4 5.4-6.2 5.7-.6-.1-1.4-.1-2.2-.1ZM189.585 303.124c-11-.4-21.9-.6-32.9-1.1-4.7-.2-9.5-.7-14-2.5-3.2-1.3-4.8-3.8-4.9-6.8-.2-5.9-.3-11.8.1-17.6.7-10.3 1.7-20.5 2.7-30.8.4-4.5.9-8.9 1.4-13.4.8-6.6 1.2-13.2 1-19.9-.3-8.9-.5-17.8-.5-26.7 0-2.4.6-4.9 1.1-7.3 1.1-5 4.7-7.7 9.4-8.5 4.7-.7 9.6-.8 14.4-1 6.4-.3 12.7 0 19.1.9 4.5.7 7.2 3.4 7.7 8 .8 7 .2 14-.7 21-1 8.3-2 16.5-3.2 24.7-1.1 7.6-2.4 15.3-3.6 22.9-.7 4.5-1.7 8.9-2.1 13.4-.4 3.5.9 6.7 3.9 8.8 1.2.8 3 1.1 4.5 1.2 3.7.2 7.4.4 11 1.8 4.2 1.7 7.2 7.1 6.4 11.6-.8 4.7-1.6 9.5-2.2 14.2-.5 4.3-3.3 7.1-7.7 7.2-3.6-.1-7.2-.2-10.9-.1 0 0 0-.1 0 0ZM440.485 142.624c2.8.3 4.6.4 6.5.6 8.1 1 16.3 2 24.5 1.7h2.9c4.1.1 5.9 3.2 4.2 6.9-2.3 5-5.7 9.3-8.9 13.7-3.5 4.8-6.7 9.8-8.8 15.4-1.5 3.8-2.3 7.8-1.7 11.9.2 1.3.6 2.6 1 3.9 2.3 7.9 6.8 14.6 11.4 21.3 2.9 4.2 5.5 8.6 7.9 13.2 4.1 7.9 2.7 15.3-2.6 22.3-3.3 4.4-5.9 9.4-8.6 14.3-3.7 6.6-7.7 12.9-15.2 16-2 .8-4.1.9-6.3.4-3.3-.8-6.7-1.5-10.2-1.7-7.9-.4-15.7-.4-23.6-.8-3.3-.1-6.1-1.4-7.6-4.6-.2-.5-.1-1.2.1-1.7 2-4.9 6.3-8 9.9-11.7 2.4-2.5 5.1-4.7 7.6-7 3.9-3.6 7.1-7.8 9.4-12.7 2.5-5.6 1.8-11.1-.6-16.5-2.7-6.1-7.1-11.1-10.8-16.5-3.6-5.1-7.1-10.3-9.2-16.3-2-6-1.7-12-.2-18 1.8-7.6 5.5-14.2 10-20.4 1.7-2.3 3.1-5 5.2-7 4.1-3.7 8.9-6.2 13.7-6.7ZM403.685 113.124c-.2 6.4-.3 12.9-.5 19.3-.1 2.4-.2 4.9-.5 7.3-.4 3.5-3.9 7.3-8.1 7.2-7.5-.2-14.9.2-22.3-1.2-1.9-.3-3.8-.7-5.7-1.4-3.9-1.5-5.4-4.7-5.6-8.5-.1-2.4-.1-4.8.2-7.1 1.5-13.4 3-26.9 2.7-40.4-.1-4.3-.1-8.6-.9-12.7-.8-4.5-4.1-7-8.5-8.1-4.1-1-8.2-.9-12.4-.5-1 .1-1.9-.1-2.9-.2-1.2-.2-1.8-.9-2.3-2-1.2-3.3-1.3-6.7-1.1-10.1.2-5.4.7-10.9 1-16.3.1-.9 0-1.7 0-2.6-.2-2.9 1.3-4.6 4.3-4.6 2.7 0 5.4.2 8.1.1 11.4-.4 22.9-1 34.3-1.3 10.5-.3 21-.5 31.5-.2 5 .1 10.2.7 14.9 2.6.7.3 1.6.9 1.8 1.6.6 1.5 1.2 3.1 1.1 4.7-.5 7.1-1.1 14.1-1.9 21.1-.2 1.7-.9 3.3-1.7 4.8-1.1 2.3-3.1 3.3-5.5 3.5-2.1.2-4.3.1-6.5.1-4.9 0-9 3.7-10.3 8.4-3.1 10.9-3.1 22.1-3.1 33.3.1 1 0 2.1-.1 3.2 0 0 .1 0 0 0ZM250.785 74.924c-.1 8.4-1.4 16.6-5.2 24.2-6.8 13.5-18 21.2-32.7 23.6-15.3 2.4-29.3-1.1-41.3-10.9-12.4-10.1-17.4-23.7-16.8-39.3.8-20.2 14-35.6 34.3-40.3 13.2-3.1 26.1-2.1 38.2 4 15.9 7.9 23.6 21 23.5 38.7Zm-36.1 1.2v-1.6c-.4-6.9-4.4-11.8-10.4-13-8.2-1.6-13.6.8-16.9 7.6-2.2 4.6-2.9 9.5-1.7 14.5 1.2 5.5 4.1 9.6 9.8 10.9 6 1.3 11-.4 14.8-5.3 3-3.8 4.3-8.2 4.4-13.1ZM246.585 143.324c.9-4.8 1.6-9.7 2.8-14.4 1.6-6.6 3.5-13.1 5.4-19.6 1.5-5.1 3.2-10.2 4.6-15.3 1.1-3.9 1.9-7.9 2.9-11.9.3-1.4.8-2.8 1-4.2.9-5.1 1.7-10.3 2.6-15.4.8-4.3 1.4-8.6 2.5-12.8 1.6-6.2 7.5-10.6 13.6-10.4 3.5.1 6.2 1.9 8.3 4.5 2.4 3 4.4 6.3 6.7 9.5 1.3 1.8 2.7 3.6 4 5.4 1.2 1.7 2.4 3.5 3.6 5.1 2.1 2.8 4.3 5.5 6.5 8.2 2.1 2.6 4.3 5.2 6.5 7.8 2.1 2.5 4.2 4.9 6.3 7.4 2.1 2.5 4.2 4.9 6.2 7.4 3.1 3.7 6.3 7.4 9.1 11.3 3.9 5.4 7.5 11 11 16.7 1.5 2.3 2.2 5.1 0 7.5-.7.8-1.6 1.6-2.5 1.8-6.9 1.6-13.8 3.1-20.7 4.7-3.4.7-6.4-.2-9.2-2.1-4.4-3.1-8-6.9-11-11.3-1.3-2-2.6-4-4-5.9-1.9-2.6-5.5-3.6-8.8-2.6-2.5.8-4.1 3.2-4.4 6.4-.1 1.6-.4 3.1-.7 4.6-.9 4.5-2 8.9-2.8 13.5-.7 4.1-3.6 6-7.2 6.8-5.9 1.2-11.8 2-17.7 2.9-3.1.5-6.2.7-9.3 1.1-2.9.4-4.6-.8-4.9-3.7-.1-1-.1-1.9-.2-2.9 0-.1-.1-.1-.2-.1ZM31.885 63.624c-1.1-.3-2.2-.5-3.2-.9-7.4-3.1-13.3-8-18.3-14.3-4.7-5.8-8-12.3-10.1-19.4-.8-2.8.1-5.1 2.5-6.7.4-.2.7-.5 1-.8 1.3-1.2 2.3-1.2 3.7-.1 5.2 3.9 10.7 7.1 17.6 6.6 4.1-.3 8.3-.2 12.5-.1 1.4 0 2.8.3 4.1.8 3.8 1.5 5 5.3 3.1 8.8-3.3 6-5.6 12.2-6.7 19-.2 1-.5 1.9-.7 2.8-.9 3.1-2.2 4.1-5.5 4.3ZM459.285 51.724c-4 .1-7.4-1.8-7.8-5.9-.2-3.3-.8-6.6-1.1-10-.3-2.8-1.3-5.3-2.8-7.7-1.9-3.1-1.9-6 .3-7.8 1.2-1 2.8-2 4.4-2.2 4.1-.6 8.3-1 12.4-1.2 5.6-.2 10.3-2.2 14.5-5.9 1-.9 2.4-1.6 3.7-1.8 3.7-.8 7 2.4 6.3 6.1-2.7 13.4-9.1 24.5-20.2 32.6-3.1 2.3-6.4 4.1-9.7 3.8ZM449.485 100.024c0 8.9-5.7 14.7-14.1 14.7-8.5 0-15-6.4-15-14.8 0-7.7 6.2-13.4 14.6-13.4 8.5.1 14.5 5.7 14.5 13.5ZM182.785 142.424c-.2 5-2.1 9.7-7.6 12-5.8 2.5-11.3 1.6-16-2.5-4.3-3.7-5.4-8.7-3.9-14.1 1-3.5 3.3-6 6.7-7.5 4.9-2.2 9.8-2 14.5.4 4.3 2.3 6.3 6.1 6.3 11.7ZM260.985 29.224c0 5.6-3.8 9.3-9.3 9.3-5.7 0-9.9-4.2-9.8-9.7.1-4.9 4.1-8.5 9.6-8.5 5.7.1 9.5 3.7 9.5 8.9ZM352.085 152.524c0 5.6-3.8 9.4-9.4 9.3-5.6-.1-9.7-4.2-9.7-9.6 0-5 4.2-8.6 9.7-8.5 5.7.1 9.5 3.6 9.4 8.8Z"
            fill="#5543DB"
          />
          <path
            d="M219.985 147.224c6.1 0 12.1 0 18 1.6.4.1.8.3 1.2.4 5 1.2 8.1 4.6 9.4 9.3 1.5 5.6 2.6 11.2 3.6 16.9 1.8 11 3.4 22.1 5.2 33.1.3 2.1 1 4.2 1.8 6.2 1.1 2.6 2.8 2.7 4.5.5 2.7-3.5 4.3-7.6 5.7-11.7 1.3-3.7 2.2-7.4 3.4-11.1 1-2.8 2.3-5.5 3.4-8.2 2.5-6.7 5-13.3 7.5-20 .6-1.6 1.3-3.1 2-4.6 2.1-4.1 5.5-6 10-6.1 6.5-.2 12.9.7 19.4 1.5 2.1.3 4.1.8 5.9 1.9 2.7 1.7 3.9 4.3 3.8 7.5-.3 7.2-3.4 13.6-6.2 20-2.8 6.5-6.2 12.7-9.2 19.1-5.3 10.9-10.6 21.7-15.7 32.7-3.8 8.3-7.2 16.9-11 25.2-1.2 2.7-3.3 5.1-5.2 7.3-.8.9-2.4 1.7-3.7 1.7-9.2.1-18.5-.1-27.6-1.5-4.2-.6-7.3-2.7-8.9-7-1.9-5.2-4.2-10.2-6.1-15.3-3.5-9.4-6.9-18.8-10.1-28.3-3.3-9.8-6.4-19.7-9.2-29.6-3.2-11.1-5.9-22.3-8.8-33.4-.8-3.2.6-5.2 3.7-6.3 4.3-1.9 8.8-1.8 13.2-1.8ZM88.685 137.024c1.3.1 2.6 0 3.9.3 3.1.7 5.3 2.7 6 5.8 1.3 5.8 2.5 11.7 3.4 17.6.9 5.8-1.2 8.9-6.9 10.5-4.1 1.1-8.3 1.8-12.5 2.6-5.2 1-8.1 5.9-6.4 10.9.9 2.6 3.1 4.3 6.3 4.1 3.4-.2 6.8-.8 10.2-1.5 2.9-.5 5.7-1.4 8.5-2 6.6-1.4 10.3.9 11.7 7.5 1 4.9 1.7 9.9 2.6 14.8.3 1.6.7 3.3 1.1 4.9 1 4.6-.6 7.6-5.2 8.6-3.5.8-7 .9-10.6 1.4-1.3.2-2.7.3-4 .7-3.7 1.3-5.8 5.5-4.9 9.3.5 2.1 2.4 3.7 5 3.5 3.5-.2 6.9-.8 10.4-1.5 3.3-.6 6.5-1.5 9.8-2.2 1.1-.2 2.4-.2 3.5-.2 1.4.1 2.5.8 2.8 2.3 1.5 6.6 3.1 13.1 4.5 19.7.2 1.1.3 2.3.3 3.4.2 4.9-1.7 8-6.3 9.5-3.7 1.2-7.6 2-11.5 2.6-6 .9-12 1.3-18 2.4-5.2 1-10.2 2.7-15.3 4-2.9.7-5.8 1.2-8.8.5-3.5-.8-5.7-2.8-6.2-6.4-2.3-17.9-7.9-34.9-13.2-52-4-12.9-8-25.9-11.7-38.9-2.3-8.3-3.8-16.7-4.2-25.3-.2-4.6 2.6-7.8 7.1-8.6 11.1-2.1 22.1-4.4 33.2-6.5 5-.9 10.1-1.5 15.2-2.3.2.4.2.5.2.5ZM113.285 126.624c-20.3-.4-35.9-9.5-47.6-25.9-6.5-9.1-10.4-19.3-11.9-30.3-.9-7-1.7-14.1-.3-21.1 2-10.1 7.6-18 15.4-24.4 8.8-7.2 19-11.9 30-14.8 6.2-1.7 12.5-2.8 18.8-3.8 5.3-.9 9.2 2.3 10.1 8.3.7 4.4.9 8.8 1.4 13.2.3 2.2.6 4.5 1.1 6.7.6 2.8-.2 5.3-2.6 6.9-2.7 1.8-5.9 2.3-9.1 2.7-4.9.7-9.9.8-14.6 2.1-6.8 1.7-12.3 5.5-14.2 12.8-1.4 5-.2 9.9 1.8 14.5 3.4 7.9 8.7 14.2 15.7 19.2.5.3 1 .6 1.6.8 2.3.6 4.2-1.2 3.6-3.5-1.4-5.3-2.9-10.6-4.2-16-.9-3.9-1.7-7.8-2.1-11.8-.5-5.1 2-8.5 7-9.5 5.7-1.1 11.5-2.3 17.2-2.7 6.8-.5 9.6 2 10.8 8.7 1.2 6.5 2 13 3.2 19.5 1.3 7.1 2.7 14.1 4.1 21.1.9 4.4 1.7 8.7.9 13.2-.8 4.2-3 7.3-6.9 8.8-3.5 1.3-7.2 2.1-10.9 2.8-6 1.2-12 2.7-18.3 2.5ZM367.585 304.924c-5.9-.2-11.5-1.9-17-3.8-7.5-2.6-15-5.4-22.6-7.9-2.7-.9-5.5-1.4-8.3-1.9-4-.6-6.9-3.8-7.2-8-.2-3.9.6-7.6 1.8-11.3 1.6-4.8 3.2-9.6 5-14.4 1.9-5.1 2.1-10.5 3.2-15.8 2.4-11.1 5.3-22 8-33 1.4-5.8 2.8-11.7 3.9-17.5.7-4 .8-8.1 1.6-12 .9-5 2.5-9.7 6.2-13.5 3.1-3.1 6.9-4.5 11.1-3.4 13.6 3.2 27.2 6.4 40.1 11.9 1.8.8 3.6 1.7 5.3 2.8 2.3 1.4 3.4 4.1 2.7 6.7-1.4 5.4-2.7 10.9-4.2 16.3-2 7.3-5.4 9.5-12.8 7.9-3.9-.9-7.8-2.2-11.6-3.6-4.1-1.6-7-.3-8.2 3.9l-.9 3.6c-.7 3.2.9 5.7 4.1 6.5 4 1 8 1.9 11.9 3 2.2.6 4.4 1.3 6.4 2.2 5.3 2.3 7 5.2 5.7 10.8-1.7 7.4-3.7 14.6-5.8 21.9-.8 2.9-3.4 4.3-6.6 3.5-3.5-.9-6.8-2.3-10.3-3.5-2.8-1-5.6-1.9-8.4-2.9-1.2-.4-2 0-2.4 1.2-.5 1.5-1 3.1-1.4 4.6-.9 3.7.3 6.6 3.7 8.4 3.6 2 7.6 2.6 11.6 3.3 2.1.4 4.3.7 6.4 1.2 2.8.6 4.5 2.4 4.1 5.3-.4 3.2-1.3 6.3-2.3 9.4-1 3.2-2.4 6.2-3.6 9.4-.4 1-.6 2.1-.8 3.1-.6 3.7-2.4 5.4-6.2 5.7-.6-.1-1.4-.1-2.2-.1ZM189.585 294.024c-11-.4-21.9-.6-32.9-1.1-4.7-.2-9.5-.7-14-2.5-3.2-1.3-4.8-3.8-4.9-6.8-.2-5.9-.3-11.8.1-17.6.7-10.3 1.7-20.6 2.7-30.8.4-4.5.9-8.9 1.4-13.4.8-6.6 1.2-13.2 1-19.9-.3-8.9-.5-17.8-.5-26.7 0-2.4.6-4.9 1.1-7.3 1.1-5 4.7-7.7 9.4-8.5 4.7-.7 9.6-.8 14.4-1 6.4-.3 12.7 0 19.1.9 4.5.7 7.2 3.4 7.7 8 .8 7 .2 14-.7 21-1 8.3-2 16.5-3.2 24.7-1.1 7.6-2.4 15.3-3.6 22.9-.7 4.5-1.7 8.9-2.1 13.4-.4 3.5.9 6.7 3.9 8.8 1.2.8 3 1.1 4.5 1.2 3.7.2 7.4.4 11 1.8 4.2 1.7 7.2 7.1 6.4 11.6-.8 4.7-1.6 9.5-2.2 14.2-.5 4.3-3.3 7.1-7.7 7.2-3.6-.1-7.2-.2-10.9-.1ZM440.485 133.524c2.8.3 4.6.4 6.5.6 8.1 1 16.3 2 24.5 1.7h2.9c4.1.1 5.9 3.2 4.2 6.9-2.3 5-5.7 9.3-8.9 13.7-3.5 4.8-6.7 9.8-8.8 15.4-1.5 3.8-2.3 7.8-1.7 11.9.2 1.3.6 2.6 1 3.9 2.3 7.9 6.8 14.6 11.4 21.3 2.9 4.2 5.5 8.6 7.9 13.2 4.1 7.9 2.7 15.3-2.6 22.3-3.3 4.4-5.9 9.4-8.6 14.3-3.7 6.6-7.7 12.9-15.2 16-2 .8-4.1.9-6.3.4-3.3-.8-6.7-1.5-10.2-1.7-7.9-.4-15.7-.4-23.6-.8-3.3-.1-6.1-1.4-7.6-4.6-.2-.5-.1-1.2.1-1.7 2-4.9 6.3-8 9.9-11.7 2.4-2.5 5.1-4.7 7.6-7 3.9-3.6 7.1-7.8 9.4-12.7 2.5-5.6 1.8-11.1-.6-16.5-2.7-6.1-7.1-11.1-10.8-16.5-3.6-5.1-7.1-10.3-9.2-16.3-2-6-1.7-12-.2-18 1.8-7.6 5.5-14.2 10-20.4 1.7-2.3 3.1-5 5.2-7 4.1-3.7 8.9-6.2 13.7-6.7ZM403.685 104.124c-.2 6.4-.3 12.9-.5 19.3-.1 2.4-.2 4.9-.5 7.3-.4 3.5-3.9 7.3-8.1 7.2-7.5-.2-14.9.2-22.3-1.2-1.9-.3-3.8-.7-5.7-1.4-3.9-1.5-5.4-4.7-5.6-8.5-.1-2.4-.1-4.8.2-7.1 1.5-13.4 3-26.9 2.7-40.4-.1-4.3-.1-8.6-.9-12.7-.8-4.5-4.1-7-8.5-8.1-4.1-1-8.2-.9-12.4-.5-1 .1-1.9-.1-2.9-.2-1.2-.2-1.8-.9-2.3-2-1.2-3.3-1.3-6.7-1.1-10.1.2-5.4.7-10.9 1-16.3.1-.9 0-1.7 0-2.6-.2-2.9 1.3-4.6 4.3-4.6 2.7 0 5.4.2 8.1.1 11.4-.4 22.9-1 34.3-1.3 10.5-.3 21-.5 31.5-.2 5 .1 10.2.7 14.9 2.6.7.3 1.6.9 1.8 1.6.6 1.5 1.2 3.1 1.1 4.7-.5 7.1-1.1 14.1-1.9 21.1-.2 1.7-.9 3.3-1.7 4.8-1.1 2.3-3.1 3.3-5.5 3.5-2.1.2-4.3.1-6.5.1-4.9 0-9 3.7-10.3 8.4-3.1 10.9-3.1 22.1-3.1 33.3.1.9 0 2-.1 3.2 0 0 .1 0 0 0ZM250.785 65.824c-.1 8.4-1.4 16.6-5.2 24.2-6.8 13.5-18 21.2-32.7 23.6-15.3 2.4-29.3-1.1-41.3-10.9-12.4-10.1-17.4-23.7-16.8-39.3.8-20.2 14-35.6 34.3-40.3 13.2-3.1 26.1-2.1 38.2 4 15.9 7.9 23.6 21 23.5 38.7Zm-36.1 1.2v-1.6c-.4-6.9-4.4-11.8-10.4-13-8.2-1.6-13.6.8-16.9 7.6-2.2 4.6-2.9 9.5-1.7 14.5 1.2 5.5 4.1 9.6 9.8 10.9 6 1.3 11-.4 14.8-5.3 3-3.8 4.3-8.2 4.4-13.1ZM246.585 134.224c.9-4.8 1.6-9.7 2.8-14.4 1.6-6.6 3.5-13.1 5.4-19.6 1.5-5.1 3.2-10.2 4.6-15.3 1.1-3.9 1.9-7.9 2.9-11.9.3-1.4.8-2.8 1-4.2.9-5.1 1.7-10.3 2.6-15.4.8-4.3 1.4-8.6 2.5-12.8 1.6-6.2 7.5-10.6 13.6-10.4 3.5.1 6.2 1.9 8.3 4.5 2.4 3 4.4 6.3 6.7 9.5 1.3 1.8 2.7 3.6 4 5.4 1.2 1.7 2.4 3.5 3.6 5.1 2.1 2.8 4.3 5.5 6.5 8.2 2.1 2.6 4.3 5.2 6.5 7.8 2.1 2.5 4.2 4.9 6.3 7.4 2.1 2.5 4.2 4.9 6.2 7.4 3.1 3.7 6.3 7.4 9.1 11.3 3.9 5.4 7.5 11 11 16.7 1.5 2.3 2.2 5.1 0 7.5-.7.8-1.6 1.6-2.5 1.8-6.9 1.6-13.8 3.1-20.7 4.7-3.4.7-6.4-.2-9.2-2.1-4.4-3.1-8-6.9-11-11.3-1.3-2-2.6-4-4-5.9-1.9-2.6-5.5-3.6-8.8-2.6-2.5.8-4.1 3.2-4.4 6.4-.1 1.6-.4 3.1-.7 4.6-.9 4.5-2 8.9-2.8 13.5-.7 4.1-3.6 6-7.2 6.8-5.9 1.2-11.8 2-17.7 2.9-3.1.5-6.2.7-9.3 1.1-2.9.4-4.6-.8-4.9-3.7-.1-1-.1-1.9-.2-2.9l-.2-.1ZM31.885 54.524c-1.1-.3-2.2-.5-3.2-.9-7.4-3.1-13.3-8-18.3-14.3-4.7-5.8-8-12.3-10.1-19.4-.8-2.8.1-5.1 2.5-6.7.4-.2.7-.5 1-.8 1.3-1.2 2.3-1.2 3.7-.1 5.2 3.9 10.7 7.1 17.6 6.6 4.1-.3 8.3-.2 12.5-.1 1.4 0 2.8.3 4.1.8 3.8 1.5 5 5.3 3.1 8.8-3.3 6-5.6 12.2-6.7 19-.2 1-.5 1.9-.7 2.8-.9 3.1-2.2 4.1-5.5 4.3ZM459.285 42.624c-4 .1-7.4-1.8-7.8-5.9-.2-3.3-.8-6.6-1.1-10-.3-2.8-1.3-5.3-2.8-7.7-1.9-3.1-1.9-6 .3-7.8 1.2-1 2.8-2 4.4-2.2 4.1-.6 8.3-1 12.4-1.2 5.6-.2 10.3-2.2 14.5-5.9 1-.9 2.4-1.6 3.7-1.8 3.7-.8 7 2.4 6.3 6.1-2.7 13.4-9.1 24.5-20.2 32.6-3.1 2.3-6.4 4.1-9.7 3.8ZM449.485 91.024c0 8.9-5.7 14.7-14.1 14.7-8.5 0-15-6.4-15-14.8 0-7.7 6.2-13.4 14.6-13.4 8.5 0 14.5 5.6 14.5 13.5ZM182.785 133.324c-.2 5-2.1 9.7-7.6 12-5.8 2.5-11.3 1.6-16-2.5-4.3-3.7-5.4-8.7-3.9-14.1 1-3.5 3.3-6 6.7-7.5 4.9-2.2 9.8-2 14.5.4 4.3 2.3 6.3 6.1 6.3 11.7ZM260.985 20.124c0 5.6-3.8 9.3-9.3 9.3-5.7 0-9.9-4.2-9.8-9.7.1-4.9 4.1-8.5 9.6-8.5 5.7.1 9.5 3.7 9.5 8.9ZM352.085 143.424c0 5.6-3.8 9.4-9.4 9.3-5.6-.1-9.7-4.2-9.7-9.6 0-5 4.2-8.6 9.7-8.5 5.7.1 9.5 3.6 9.4 8.8Z"
            fill="#B0FEFE"
          />
          <path
            d="M443.585 181.124c.1-8 1.9-14.6 5.2-20.7 1.9-3.5 4.3-6.9 6.8-10 2.2-2.7 5.2-3 7.5-1.3 2.5 1.9 2.8 4.8.6 7.4-2.8 3.3-5.2 6.9-6.9 10.9-3.9 9-4.3 17.7 1.1 26.3 1.1 1.7 2 3.6 2.7 5.5 1 2.7 0 5.3-2.4 6.5-2.2 1.1-4.9.5-6.4-1.9-3.3-5.3-6.6-10.7-7.6-17-.3-2.2-.5-4.5-.6-5.7ZM241.985 64.824c.1 4.6-3.7 7.4-7.2 5.6-2-1-2.9-2.8-3.1-5-.5-5.6-2-10.9-4.9-15.8-2.2-3.7-5.2-6.6-9.2-8.3-1.3-.6-2.7-1.5-3.6-2.6-2.2-3 .2-7.5 4-7.4 2 .1 4.1.8 6 1.7 6.4 3.3 10.7 8.7 13.6 15.1 2.5 5.3 3.9 11 4.4 16.7ZM188.185 182.524c-.4 4.6-.9 11.1-1.5 17.6-.1 1.3-.6 2.7-1.4 3.7-1.1 1.7-2.9 2.5-5 1.9-2.1-.6-3.4-2-3.8-4.2-.2-.9-.1-1.9-.1-2.9.5-6.2 1.2-12.5 1.6-18.7.1-2.1-.2-4.2-.6-6.2-.1-.7-1-1.5-1.7-1.9-2.6-1.4-3.9-3.5-3.3-5.9.6-2.5 2.9-4.1 5.8-3.8 4.2.4 6.8 2.9 8.4 6.6 1.7 3.9 1.7 7.9 1.6 13.8ZM307.085 69.524c-.2 2.2-1.6 4.2-3.5 4.9-2 .8-4.2.2-5.6-1.7-1.7-2.3-3.2-4.9-4.9-7.3-4.8-7-9.8-14-15.6-20.2-2.2-2.3-2.4-4.9-.5-7.1 1.8-2.1 4.9-2.4 7.3-.3 2.1 1.8 4 3.8 5.6 6 5.3 7.3 10.5 14.6 15.6 22 .8 1.1 1.1 2.5 1.6 3.7ZM298.585 191.924c.7-1.6 1.8-3.8 2.8-6 2.6-5.6 5.1-11.2 7.7-16.7.5-1 1-2 1.8-2.9 1.6-1.8 3.9-2.3 5.8-1.3 2 1 3.3 3.3 2.6 5.6-.6 2.3-1.6 4.6-2.6 6.8-2.6 5.6-5.2 11.1-7.9 16.6-.5 1-1.2 1.9-2.1 2.7-1.5 1.4-3.3 1.7-5.1.9-1.9-1-2.9-2.7-3-5.7ZM246.685 175.424c0 2.9-1.8 5.2-4.3 5.5-2.4.4-4.9-1.2-5.6-3.9-1.1-3.9-1.9-7.8-2.9-11.6-.5-1.7-1.1-3.4-1.6-5.1-1-3-.6-5.3 1.3-6.9 2.8-2.4 6.8-1.4 8.1 2.5 1.9 6.1 3.4 12.3 5 18.4v1.1ZM77.285 75.424c0-2.7 1.7-4.9 4.3-5.3 2.3-.4 4.7 1.1 5.7 3.8 1.5 4.4 4.2 7.8 7.5 11 .7.7 1.4 1.3 2 2.1 1.6 2.2 1.5 4.6-.3 6.5-1.7 1.8-4.4 2.1-6.5.7-4-2.7-7-6.4-9.5-10.5-2.5-4.2-3.2-6.2-3.2-8.3ZM21.785 32.124c-4.8-.2-9.3-1.5-13.5-3.8-2.8-1.6-3.8-4.3-2.7-6.7 1.3-2.7 4.1-3.8 7.1-2.5 3.7 1.7 7.4 2.7 11.6 2.5 2.8-.1 5 2 5.2 4.6.2 2.4-1.5 4.7-4.2 5.4-1.1.3-2.3.3-3.5.5ZM112.685 9.924c2.2 0 4.1.8 5.7 2.3 3.4 3.3 5 7.4 5.3 12 .2 2.2-1 3.9-2.9 4.9-1.7.9-3.5.8-4.8-.5-1-1-1.7-2.4-2.4-3.7-.3-.5-.3-1.2-.4-1.7-.5-1.6-1.2-2.8-3.2-3.1-2.2-.3-3.7-2.6-3.8-4.7 0-2.2 1.7-4.4 4.1-5.1.8-.2 1.6-.2 2.4-.4ZM425.685 35.724c-.8 3.2-1.5 6.5-2.6 9.6-1 2.8-4 4.1-6.6 3.1-2.4-.9-3.8-3.8-2.9-6.6 1-3.3 1.8-6.5.9-10-.6-2.5 1.3-5 3.8-5.6 2.5-.6 5.1.9 6 3.5.2.6.4 1.2.5 1.9.2 1.3.3 2.7.5 4 .1 0 .3.1.4.1ZM126.685 54.824c2.8.1 5 1.6 6.5 4.1 1.9 3.1 3 6.6 3.5 10.2.5 4.1-3.4 7-6.9 5.4-1.7-.8-2.7-2.3-3.2-4-.2-.6-.4-1.2-.5-1.9-.4-2.1-1.3-3.6-3.4-4.6-1.9-.9-2.5-3.3-2-5.2.7-2.4 3.1-4 6-4ZM461.985 11.124c2.1-.5 4.2-.8 6.2-1.5 3.7-1.2 6.4-.2 7.6 3 .7 1.8-.1 4.4-2 5.5-4.7 2.8-9.7 3.9-15.1 2.5-2.9-.8-4.5-3.4-4.1-5.8.5-2.6 2.8-4.2 5.9-4.1.4 0 .9 0 1.3.1.1 0 .1.2.2.3ZM396.685 183.824c-.4 3.2-.5 6.3-2.3 8.9-1.4 2-3.4 2.7-5.4 2.1-2-.6-3.6-2.7-3.6-4.9 0-.9.3-1.8.4-2.7.1-1.4.4-2.9.3-4.3-.2-2.9 1.2-5.4 3.7-6 2.6-.6 5.6 1.2 6.4 4 .3.9.3 2 .5 2.9ZM108.185 198.324c0 3.7-1.9 6-4.3 6.4-2.4.3-4.8-1.3-5.5-3.8-.5-1.5-.9-3.1-1.3-4.7-.7-2.7.6-5.3 3-6.3 2.3-1 5.1 0 6.3 2.5.9 2.2 1.4 4.6 1.8 5.9ZM386.385 234.024c-.5 1.3-.8 2.6-1.5 3.7-1 1.8-3.2 2.6-5 2.2-2.1-.5-3.4-2-3.9-4.1-.2-.8-.3-1.6-.6-2.3-1.3-3.4-.5-5.9 2.3-7.3 2.5-1.2 5.9.3 7.3 3.2.7 1.4 1 3 1.4 4.6ZM205.185 271.024c-.5 1.3-.9 2.8-1.7 3.9-2.1 2.8-6.2 2.4-7.9-.8-.7-1.2-1.2-2.5-1.9-3.7-1.1-2-.9-3.9.5-5.6 1.4-1.7 3.8-2.3 5.9-1.5 3 1.2 4.8 4 5.1 7.7ZM93.885 149.424c0 1.8-1 3.5-2.9 4.4-1.9.9-4 .6-5.5-1-1.3-1.4-2.5-2.9-3.3-4.5-.9-1.9-.2-4 1.3-5.3 1.7-1.4 3.6-1.7 5.6-.7 2.7 1.3 4.8 4.3 4.8 7.1ZM110.185 242.224c0-2.4 1.3-4.4 3.3-5.1 1.9-.7 3.9-.1 5.4 1.6 2.1 2.4 2.4 6 .7 8.2-1.8 2.4-4.9 2.6-7.1.6-1.6-1.5-2.2-3.4-2.3-5.3ZM370.785 285.124c-2.6 0-5.2-2.9-5.2-5.8s2.2-5.2 4.9-5.2 5.2 2.7 5.3 5.6c.1 2.6-2.5 5.4-5 5.4ZM347.885 142.024c0 2.5-2.2 4.8-4.8 4.8-2.5 0-4.8-2.3-4.8-4.8s2.2-4.6 4.7-4.7c2.6-.1 4.9 2.2 4.9 4.7ZM175.685 128.624c0 2.5-2.3 4.8-4.8 4.8-2.4 0-4.6-2.2-4.7-4.7 0-2.5 2.2-4.8 4.7-4.8 2.5-.1 4.8 2.2 4.8 4.7ZM237.785 84.024c-2.5 0-4.8-2.3-4.7-4.8.1-2.5 2.3-4.6 4.7-4.6 2.5 0 4.8 2.3 4.8 4.8 0 2.3-2.3 4.6-4.8 4.6ZM252.485 23.224c-2.5 0-4.8-2.3-4.8-4.8s2.3-4.8 4.8-4.7c2.4 0 4.6 2.2 4.6 4.7.2 2.5-2 4.8-4.6 4.8ZM295.585 211.424c-2.5 0-4.8-2.1-4.8-4.7 0-2.5 2.2-4.8 4.7-4.8s4.6 2.2 4.7 4.6c.1 2.6-2.1 4.9-4.6 4.9ZM140.385 83.024c0 2.5-2.2 4.8-4.7 4.8s-4.8-2.3-4.8-4.8c0-2.4 2.2-4.6 4.7-4.7 2.5 0 4.8 2.2 4.8 4.7ZM309.685 87.824c-2.5 0-4.8-2.2-4.7-4.8 0-2.5 2.3-4.7 4.8-4.7s4.6 2.2 4.7 4.7c0 2.6-2.2 4.8-4.8 4.8ZM436.985 81.324c2.6 0 4.8 2.2 4.8 4.7s-2.2 4.7-4.8 4.7c-2.4 0-4.6-2.2-4.7-4.7-.1-2.5 2.1-4.7 4.7-4.7ZM467.685 214.424c0 2.5-2.1 4.7-4.6 4.7-2.6 0-4.8-2.2-4.8-4.7s2.2-4.8 4.7-4.8c2.6 0 4.8 2.2 4.7 4.8Z"
            fill="#fff"
          />
        </svg>
      </a>
      <a href={"#navtoggle"} className="navtoggle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#fff"
        >
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </svg>
      </a>
      <ul>
        <li>
          <a href={"#instructions"}>
            <span>`INSTRUCTIONS´</span>
          </a>
        </li>
        <li>
          <a href={"#roadmap"}>
            <span>`G.O.A.T ROADMAP´</span>
          </a>
        </li>
        <li>
          <a href={"#team"}>
            <span>`G.O.A.T TEAM´</span>
          </a>
        </li>
        {/* <li>
          <a href={"#token"}>
            <span>`G.O.A.T TOKEN´</span>
          </a>
        </li> */}
        <li>
          <a href={"#faqs"}>
            <span>`FAQS´</span>
          </a>
        </li>
        <li>
          <a href={"https://discord.com/invite/goatelves"}
            target="_blank"
            className="social discord"
            rel="noreferrer">
            <span>
            <svg
                width={"1em"}
                height={"1em"}
                viewBox="0 0 88 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M68.813 11.7c-4.7-2.2-9.8-3.8-15.1-4.7-.6 1.2-1.4 2.7-1.9 4-5.6-.8-11.2-.8-16.7 0-.5-1.3-1.3-2.8-2-4-5.3.9-10.3 2.5-15.1 4.7-9.4 14.4-12 28.5-10.7 42.3 6.3 4.7 12.4 7.6 18.5 9.5 1.5-2 2.8-4.2 4-6.5-2.2-.8-4.3-1.8-6.2-3l1.5-1.2c12 5.6 25 5.6 36.9 0l1.5 1.2c-2 1.2-4.1 2.2-6.2 3 1.1 2.3 2.5 4.5 4 6.5 6-1.9 12.2-4.7 18.5-9.5 1.4-16-2.7-29.9-11-42.3Zm-37.4 33.8c-3.6 0-6.6-3.4-6.6-7.5s2.9-7.5 6.6-7.5c3.7 0 6.6 3.4 6.6 7.5-.1 4.1-3 7.5-6.6 7.5Zm24.2 0c-3.6 0-6.6-3.4-6.6-7.5s2.9-7.5 6.6-7.5c3.7 0 6.6 3.4 6.6 7.5s-2.9 7.5-6.6 7.5Z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </a>
        </li>
        <li>
          <a href={"https://twitter.com/goatelves"}
            target="_blank"
            className="social"
            rel="noreferrer">
            <span>
            <svg
                width={"1em"}
                height={"1em"}
                viewBox="0 0 88 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.5 71c33 0 51-27.3 51-51 0-.8 0-1.5-.1-2.3 3.5-2.5 6.5-5.7 8.9-9.3-3.2 1.4-6.7 2.4-10.3 2.8 3.8-2.2 6.6-5.7 8-9.9-3.5 2.1-7.3 3.5-11.4 4.4-3.3-3.5-8-5.7-13.1-5.7-9.9 0-17.9 8-17.9 17.9 0 1.4.2 2.8.5 4.1-15-.7-28.2-7.9-37-18.7-1.5 2.6-2.4 5.7-2.4 9 0 6.2 3.2 11.7 8 14.9-2.9-.1-5.7-.9-8.1-2.2v.2c0 8.7 6.2 15.9 14.4 17.6-1.5.4-3.1.6-4.7.6-1.2 0-2.3-.1-3.4-.3 2.3 7.1 8.9 12.3 16.7 12.4-6.1 4.8-13.9 7.7-22.3 7.7-1.4 0-2.9-.1-4.3-.2 7.9 5 17.4 8 27.5 8Z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </a>
        </li>
      </ul>
    
      <WalletDialogButton className='connect'>{!wallet.connected ? "Connect Wallet" : "Connected" }</WalletDialogButton>
    </nav>
  
              <Snackbar
        open={alertState.open}
        autoHideDuration={6000}
        onClose={() => setAlertState({ ...alertState, open: false })}
      >
        <Alert
          onClose={() => setAlertState({ ...alertState, open: false })}
          severity={alertState.severity}
        >
          {alertState.message}
        </Alert>
      </Snackbar>
    
      
    <section className={`hero ${wallet.connected ? "connected" : ""}`}>
      <div className="logo">
        <svg viewBox="0 0 490 315" fill="none">
          <path
            d="M219.985 156.324c6.1 0 12.1 0 18 1.6.4.1.8.3 1.2.4 5 1.2 8.1 4.6 9.4 9.3 1.5 5.6 2.6 11.2 3.6 16.9 1.8 11 3.4 22.1 5.2 33.1.3 2.1 1 4.2 1.8 6.2 1.1 2.6 2.8 2.7 4.5.5 2.7-3.5 4.3-7.6 5.7-11.7 1.3-3.7 2.2-7.4 3.4-11.1 1-2.8 2.3-5.5 3.4-8.2 2.5-6.7 5-13.3 7.5-20 .6-1.6 1.3-3.1 2-4.6 2.1-4.1 5.5-6 10-6.1 6.5-.2 12.9.7 19.4 1.5 2.1.3 4.1.8 5.9 1.9 2.7 1.7 3.9 4.3 3.8 7.5-.3 7.2-3.4 13.6-6.2 20-2.8 6.5-6.2 12.7-9.2 19.1-5.3 10.9-10.6 21.7-15.7 32.7-3.8 8.3-7.2 16.9-11 25.2-1.2 2.7-3.3 5.1-5.2 7.3-.8.9-2.4 1.7-3.7 1.7-9.2.1-18.5-.1-27.6-1.5-4.2-.6-7.3-2.7-8.9-7-1.9-5.2-4.2-10.2-6.1-15.3-3.5-9.4-6.9-18.8-10.1-28.3-3.3-9.8-6.4-19.7-9.2-29.6-3.2-11.1-5.9-22.3-8.8-33.4-.8-3.2.6-5.2 3.7-6.3 4.3-1.9 8.8-1.8 13.2-1.8ZM88.685 146.124c1.3.1 2.6 0 3.9.3 3.1.7 5.3 2.7 6 5.8 1.3 5.8 2.5 11.7 3.4 17.6.9 5.8-1.2 8.9-6.9 10.5-4.1 1.1-8.3 1.8-12.5 2.6-5.2 1-8.1 5.9-6.4 10.9.9 2.6 3.1 4.3 6.3 4.1 3.4-.2 6.8-.8 10.2-1.5 2.9-.5 5.7-1.4 8.5-2 6.6-1.4 10.3.9 11.7 7.5 1 4.9 1.7 9.9 2.6 14.8.3 1.6.7 3.3 1.1 4.9 1 4.6-.6 7.6-5.2 8.6-3.5.8-7 .9-10.6 1.4-1.3.2-2.7.3-4 .7-3.7 1.3-5.8 5.5-4.9 9.3.5 2.1 2.4 3.7 5 3.5 3.5-.2 6.9-.8 10.4-1.5 3.3-.6 6.5-1.5 9.8-2.2 1.1-.2 2.4-.2 3.5-.2 1.4.1 2.5.8 2.8 2.3 1.5 6.6 3.1 13.1 4.5 19.7.2 1.1.3 2.3.3 3.4.2 4.9-1.7 8-6.3 9.5-3.7 1.2-7.6 2-11.5 2.6-6 .9-12 1.3-18 2.4-5.2 1-10.2 2.7-15.3 4-2.9.7-5.8 1.2-8.8.5-3.5-.8-5.7-2.8-6.2-6.4-2.3-17.9-7.9-34.9-13.2-52-4-12.9-8-25.9-11.7-38.9-2.3-8.3-3.8-16.7-4.2-25.3-.2-4.6 2.6-7.8 7.1-8.6 11.1-2.1 22.1-4.4 33.2-6.5 5-.9 10.1-1.5 15.2-2.3.2.4.2.4.2.5ZM113.285 135.624c-20.3-.4-35.9-9.5-47.6-25.9-6.5-9.1-10.4-19.3-11.9-30.3-.9-7-1.7-14.1-.3-21.1 2-10.1 7.6-18 15.4-24.4 8.8-7.2 19-11.9 30-14.8 6.2-1.7 12.5-2.8 18.8-3.8 5.3-.9 9.2 2.3 10.1 8.3.7 4.4.9 8.8 1.4 13.2.3 2.2.6 4.5 1.1 6.7.6 2.8-.2 5.3-2.6 6.9-2.7 1.8-5.9 2.3-9.1 2.7-4.9.7-9.9.8-14.6 2.1-6.8 1.7-12.3 5.5-14.2 12.8-1.4 5-.2 9.9 1.8 14.5 3.4 7.9 8.7 14.2 15.7 19.2.5.3 1 .6 1.6.8 2.3.6 4.2-1.2 3.6-3.5-1.4-5.3-2.9-10.6-4.2-16-.9-3.9-1.7-7.8-2.1-11.8-.5-5.1 2-8.5 7-9.5 5.7-1.1 11.5-2.3 17.2-2.7 6.8-.5 9.6 2 10.8 8.7 1.2 6.5 2 13 3.2 19.5 1.3 7.1 2.7 14.1 4.1 21.1.9 4.4 1.7 8.7.9 13.2-.8 4.2-3 7.3-6.9 8.8-3.5 1.3-7.2 2.1-10.9 2.8-6 1.3-12 2.7-18.3 2.5ZM367.585 314.024c-5.9-.2-11.5-1.9-17-3.8-7.5-2.6-15-5.4-22.6-7.9-2.7-.9-5.5-1.4-8.3-1.9-4-.6-6.9-3.8-7.2-8-.2-3.9.6-7.6 1.8-11.3 1.6-4.8 3.2-9.6 5-14.4 1.9-5.1 2.1-10.5 3.2-15.8 2.4-11.1 5.3-22 8-33 1.4-5.8 2.8-11.7 3.9-17.5.7-4 .8-8.1 1.6-12 .9-5 2.5-9.7 6.2-13.5 3.1-3.1 6.9-4.5 11.1-3.4 13.6 3.2 27.2 6.4 40.1 11.9 1.8.8 3.6 1.7 5.3 2.8 2.3 1.4 3.4 4.1 2.7 6.7-1.4 5.4-2.7 10.9-4.2 16.3-2 7.3-5.4 9.5-12.8 7.9-3.9-.9-7.8-2.2-11.6-3.6-4.1-1.6-7-.3-8.2 3.9l-.9 3.6c-.7 3.2.9 5.7 4.1 6.5 4 1 8 1.9 11.9 3 2.2.6 4.4 1.3 6.4 2.2 5.3 2.3 7 5.2 5.7 10.8-1.7 7.4-3.7 14.6-5.8 21.9-.8 2.9-3.4 4.3-6.6 3.5-3.5-.9-6.8-2.3-10.3-3.5-2.8-1-5.6-1.9-8.4-2.9-1.2-.4-2 0-2.4 1.2-.5 1.5-1 3.1-1.4 4.6-.9 3.7.3 6.6 3.7 8.4 3.6 2 7.6 2.6 11.6 3.3 2.1.4 4.3.7 6.4 1.2 2.8.6 4.5 2.4 4.1 5.3-.4 3.2-1.3 6.3-2.3 9.4-1 3.2-2.4 6.2-3.6 9.4-.4 1-.6 2.1-.8 3.1-.6 3.7-2.4 5.4-6.2 5.7-.6-.1-1.4-.1-2.2-.1ZM189.585 303.124c-11-.4-21.9-.6-32.9-1.1-4.7-.2-9.5-.7-14-2.5-3.2-1.3-4.8-3.8-4.9-6.8-.2-5.9-.3-11.8.1-17.6.7-10.3 1.7-20.5 2.7-30.8.4-4.5.9-8.9 1.4-13.4.8-6.6 1.2-13.2 1-19.9-.3-8.9-.5-17.8-.5-26.7 0-2.4.6-4.9 1.1-7.3 1.1-5 4.7-7.7 9.4-8.5 4.7-.7 9.6-.8 14.4-1 6.4-.3 12.7 0 19.1.9 4.5.7 7.2 3.4 7.7 8 .8 7 .2 14-.7 21-1 8.3-2 16.5-3.2 24.7-1.1 7.6-2.4 15.3-3.6 22.9-.7 4.5-1.7 8.9-2.1 13.4-.4 3.5.9 6.7 3.9 8.8 1.2.8 3 1.1 4.5 1.2 3.7.2 7.4.4 11 1.8 4.2 1.7 7.2 7.1 6.4 11.6-.8 4.7-1.6 9.5-2.2 14.2-.5 4.3-3.3 7.1-7.7 7.2-3.6-.1-7.2-.2-10.9-.1 0 0 0-.1 0 0ZM440.485 142.624c2.8.3 4.6.4 6.5.6 8.1 1 16.3 2 24.5 1.7h2.9c4.1.1 5.9 3.2 4.2 6.9-2.3 5-5.7 9.3-8.9 13.7-3.5 4.8-6.7 9.8-8.8 15.4-1.5 3.8-2.3 7.8-1.7 11.9.2 1.3.6 2.6 1 3.9 2.3 7.9 6.8 14.6 11.4 21.3 2.9 4.2 5.5 8.6 7.9 13.2 4.1 7.9 2.7 15.3-2.6 22.3-3.3 4.4-5.9 9.4-8.6 14.3-3.7 6.6-7.7 12.9-15.2 16-2 .8-4.1.9-6.3.4-3.3-.8-6.7-1.5-10.2-1.7-7.9-.4-15.7-.4-23.6-.8-3.3-.1-6.1-1.4-7.6-4.6-.2-.5-.1-1.2.1-1.7 2-4.9 6.3-8 9.9-11.7 2.4-2.5 5.1-4.7 7.6-7 3.9-3.6 7.1-7.8 9.4-12.7 2.5-5.6 1.8-11.1-.6-16.5-2.7-6.1-7.1-11.1-10.8-16.5-3.6-5.1-7.1-10.3-9.2-16.3-2-6-1.7-12-.2-18 1.8-7.6 5.5-14.2 10-20.4 1.7-2.3 3.1-5 5.2-7 4.1-3.7 8.9-6.2 13.7-6.7ZM403.685 113.124c-.2 6.4-.3 12.9-.5 19.3-.1 2.4-.2 4.9-.5 7.3-.4 3.5-3.9 7.3-8.1 7.2-7.5-.2-14.9.2-22.3-1.2-1.9-.3-3.8-.7-5.7-1.4-3.9-1.5-5.4-4.7-5.6-8.5-.1-2.4-.1-4.8.2-7.1 1.5-13.4 3-26.9 2.7-40.4-.1-4.3-.1-8.6-.9-12.7-.8-4.5-4.1-7-8.5-8.1-4.1-1-8.2-.9-12.4-.5-1 .1-1.9-.1-2.9-.2-1.2-.2-1.8-.9-2.3-2-1.2-3.3-1.3-6.7-1.1-10.1.2-5.4.7-10.9 1-16.3.1-.9 0-1.7 0-2.6-.2-2.9 1.3-4.6 4.3-4.6 2.7 0 5.4.2 8.1.1 11.4-.4 22.9-1 34.3-1.3 10.5-.3 21-.5 31.5-.2 5 .1 10.2.7 14.9 2.6.7.3 1.6.9 1.8 1.6.6 1.5 1.2 3.1 1.1 4.7-.5 7.1-1.1 14.1-1.9 21.1-.2 1.7-.9 3.3-1.7 4.8-1.1 2.3-3.1 3.3-5.5 3.5-2.1.2-4.3.1-6.5.1-4.9 0-9 3.7-10.3 8.4-3.1 10.9-3.1 22.1-3.1 33.3.1 1 0 2.1-.1 3.2 0 0 .1 0 0 0ZM250.785 74.924c-.1 8.4-1.4 16.6-5.2 24.2-6.8 13.5-18 21.2-32.7 23.6-15.3 2.4-29.3-1.1-41.3-10.9-12.4-10.1-17.4-23.7-16.8-39.3.8-20.2 14-35.6 34.3-40.3 13.2-3.1 26.1-2.1 38.2 4 15.9 7.9 23.6 21 23.5 38.7Zm-36.1 1.2v-1.6c-.4-6.9-4.4-11.8-10.4-13-8.2-1.6-13.6.8-16.9 7.6-2.2 4.6-2.9 9.5-1.7 14.5 1.2 5.5 4.1 9.6 9.8 10.9 6 1.3 11-.4 14.8-5.3 3-3.8 4.3-8.2 4.4-13.1ZM246.585 143.324c.9-4.8 1.6-9.7 2.8-14.4 1.6-6.6 3.5-13.1 5.4-19.6 1.5-5.1 3.2-10.2 4.6-15.3 1.1-3.9 1.9-7.9 2.9-11.9.3-1.4.8-2.8 1-4.2.9-5.1 1.7-10.3 2.6-15.4.8-4.3 1.4-8.6 2.5-12.8 1.6-6.2 7.5-10.6 13.6-10.4 3.5.1 6.2 1.9 8.3 4.5 2.4 3 4.4 6.3 6.7 9.5 1.3 1.8 2.7 3.6 4 5.4 1.2 1.7 2.4 3.5 3.6 5.1 2.1 2.8 4.3 5.5 6.5 8.2 2.1 2.6 4.3 5.2 6.5 7.8 2.1 2.5 4.2 4.9 6.3 7.4 2.1 2.5 4.2 4.9 6.2 7.4 3.1 3.7 6.3 7.4 9.1 11.3 3.9 5.4 7.5 11 11 16.7 1.5 2.3 2.2 5.1 0 7.5-.7.8-1.6 1.6-2.5 1.8-6.9 1.6-13.8 3.1-20.7 4.7-3.4.7-6.4-.2-9.2-2.1-4.4-3.1-8-6.9-11-11.3-1.3-2-2.6-4-4-5.9-1.9-2.6-5.5-3.6-8.8-2.6-2.5.8-4.1 3.2-4.4 6.4-.1 1.6-.4 3.1-.7 4.6-.9 4.5-2 8.9-2.8 13.5-.7 4.1-3.6 6-7.2 6.8-5.9 1.2-11.8 2-17.7 2.9-3.1.5-6.2.7-9.3 1.1-2.9.4-4.6-.8-4.9-3.7-.1-1-.1-1.9-.2-2.9 0-.1-.1-.1-.2-.1ZM31.885 63.624c-1.1-.3-2.2-.5-3.2-.9-7.4-3.1-13.3-8-18.3-14.3-4.7-5.8-8-12.3-10.1-19.4-.8-2.8.1-5.1 2.5-6.7.4-.2.7-.5 1-.8 1.3-1.2 2.3-1.2 3.7-.1 5.2 3.9 10.7 7.1 17.6 6.6 4.1-.3 8.3-.2 12.5-.1 1.4 0 2.8.3 4.1.8 3.8 1.5 5 5.3 3.1 8.8-3.3 6-5.6 12.2-6.7 19-.2 1-.5 1.9-.7 2.8-.9 3.1-2.2 4.1-5.5 4.3ZM459.285 51.724c-4 .1-7.4-1.8-7.8-5.9-.2-3.3-.8-6.6-1.1-10-.3-2.8-1.3-5.3-2.8-7.7-1.9-3.1-1.9-6 .3-7.8 1.2-1 2.8-2 4.4-2.2 4.1-.6 8.3-1 12.4-1.2 5.6-.2 10.3-2.2 14.5-5.9 1-.9 2.4-1.6 3.7-1.8 3.7-.8 7 2.4 6.3 6.1-2.7 13.4-9.1 24.5-20.2 32.6-3.1 2.3-6.4 4.1-9.7 3.8ZM449.485 100.024c0 8.9-5.7 14.7-14.1 14.7-8.5 0-15-6.4-15-14.8 0-7.7 6.2-13.4 14.6-13.4 8.5.1 14.5 5.7 14.5 13.5ZM182.785 142.424c-.2 5-2.1 9.7-7.6 12-5.8 2.5-11.3 1.6-16-2.5-4.3-3.7-5.4-8.7-3.9-14.1 1-3.5 3.3-6 6.7-7.5 4.9-2.2 9.8-2 14.5.4 4.3 2.3 6.3 6.1 6.3 11.7ZM260.985 29.224c0 5.6-3.8 9.3-9.3 9.3-5.7 0-9.9-4.2-9.8-9.7.1-4.9 4.1-8.5 9.6-8.5 5.7.1 9.5 3.7 9.5 8.9ZM352.085 152.524c0 5.6-3.8 9.4-9.4 9.3-5.6-.1-9.7-4.2-9.7-9.6 0-5 4.2-8.6 9.7-8.5 5.7.1 9.5 3.6 9.4 8.8Z"
            fill="#5543DB"
          />
          <path
            d="M219.985 147.224c6.1 0 12.1 0 18 1.6.4.1.8.3 1.2.4 5 1.2 8.1 4.6 9.4 9.3 1.5 5.6 2.6 11.2 3.6 16.9 1.8 11 3.4 22.1 5.2 33.1.3 2.1 1 4.2 1.8 6.2 1.1 2.6 2.8 2.7 4.5.5 2.7-3.5 4.3-7.6 5.7-11.7 1.3-3.7 2.2-7.4 3.4-11.1 1-2.8 2.3-5.5 3.4-8.2 2.5-6.7 5-13.3 7.5-20 .6-1.6 1.3-3.1 2-4.6 2.1-4.1 5.5-6 10-6.1 6.5-.2 12.9.7 19.4 1.5 2.1.3 4.1.8 5.9 1.9 2.7 1.7 3.9 4.3 3.8 7.5-.3 7.2-3.4 13.6-6.2 20-2.8 6.5-6.2 12.7-9.2 19.1-5.3 10.9-10.6 21.7-15.7 32.7-3.8 8.3-7.2 16.9-11 25.2-1.2 2.7-3.3 5.1-5.2 7.3-.8.9-2.4 1.7-3.7 1.7-9.2.1-18.5-.1-27.6-1.5-4.2-.6-7.3-2.7-8.9-7-1.9-5.2-4.2-10.2-6.1-15.3-3.5-9.4-6.9-18.8-10.1-28.3-3.3-9.8-6.4-19.7-9.2-29.6-3.2-11.1-5.9-22.3-8.8-33.4-.8-3.2.6-5.2 3.7-6.3 4.3-1.9 8.8-1.8 13.2-1.8ZM88.685 137.024c1.3.1 2.6 0 3.9.3 3.1.7 5.3 2.7 6 5.8 1.3 5.8 2.5 11.7 3.4 17.6.9 5.8-1.2 8.9-6.9 10.5-4.1 1.1-8.3 1.8-12.5 2.6-5.2 1-8.1 5.9-6.4 10.9.9 2.6 3.1 4.3 6.3 4.1 3.4-.2 6.8-.8 10.2-1.5 2.9-.5 5.7-1.4 8.5-2 6.6-1.4 10.3.9 11.7 7.5 1 4.9 1.7 9.9 2.6 14.8.3 1.6.7 3.3 1.1 4.9 1 4.6-.6 7.6-5.2 8.6-3.5.8-7 .9-10.6 1.4-1.3.2-2.7.3-4 .7-3.7 1.3-5.8 5.5-4.9 9.3.5 2.1 2.4 3.7 5 3.5 3.5-.2 6.9-.8 10.4-1.5 3.3-.6 6.5-1.5 9.8-2.2 1.1-.2 2.4-.2 3.5-.2 1.4.1 2.5.8 2.8 2.3 1.5 6.6 3.1 13.1 4.5 19.7.2 1.1.3 2.3.3 3.4.2 4.9-1.7 8-6.3 9.5-3.7 1.2-7.6 2-11.5 2.6-6 .9-12 1.3-18 2.4-5.2 1-10.2 2.7-15.3 4-2.9.7-5.8 1.2-8.8.5-3.5-.8-5.7-2.8-6.2-6.4-2.3-17.9-7.9-34.9-13.2-52-4-12.9-8-25.9-11.7-38.9-2.3-8.3-3.8-16.7-4.2-25.3-.2-4.6 2.6-7.8 7.1-8.6 11.1-2.1 22.1-4.4 33.2-6.5 5-.9 10.1-1.5 15.2-2.3.2.4.2.5.2.5ZM113.285 126.624c-20.3-.4-35.9-9.5-47.6-25.9-6.5-9.1-10.4-19.3-11.9-30.3-.9-7-1.7-14.1-.3-21.1 2-10.1 7.6-18 15.4-24.4 8.8-7.2 19-11.9 30-14.8 6.2-1.7 12.5-2.8 18.8-3.8 5.3-.9 9.2 2.3 10.1 8.3.7 4.4.9 8.8 1.4 13.2.3 2.2.6 4.5 1.1 6.7.6 2.8-.2 5.3-2.6 6.9-2.7 1.8-5.9 2.3-9.1 2.7-4.9.7-9.9.8-14.6 2.1-6.8 1.7-12.3 5.5-14.2 12.8-1.4 5-.2 9.9 1.8 14.5 3.4 7.9 8.7 14.2 15.7 19.2.5.3 1 .6 1.6.8 2.3.6 4.2-1.2 3.6-3.5-1.4-5.3-2.9-10.6-4.2-16-.9-3.9-1.7-7.8-2.1-11.8-.5-5.1 2-8.5 7-9.5 5.7-1.1 11.5-2.3 17.2-2.7 6.8-.5 9.6 2 10.8 8.7 1.2 6.5 2 13 3.2 19.5 1.3 7.1 2.7 14.1 4.1 21.1.9 4.4 1.7 8.7.9 13.2-.8 4.2-3 7.3-6.9 8.8-3.5 1.3-7.2 2.1-10.9 2.8-6 1.2-12 2.7-18.3 2.5ZM367.585 304.924c-5.9-.2-11.5-1.9-17-3.8-7.5-2.6-15-5.4-22.6-7.9-2.7-.9-5.5-1.4-8.3-1.9-4-.6-6.9-3.8-7.2-8-.2-3.9.6-7.6 1.8-11.3 1.6-4.8 3.2-9.6 5-14.4 1.9-5.1 2.1-10.5 3.2-15.8 2.4-11.1 5.3-22 8-33 1.4-5.8 2.8-11.7 3.9-17.5.7-4 .8-8.1 1.6-12 .9-5 2.5-9.7 6.2-13.5 3.1-3.1 6.9-4.5 11.1-3.4 13.6 3.2 27.2 6.4 40.1 11.9 1.8.8 3.6 1.7 5.3 2.8 2.3 1.4 3.4 4.1 2.7 6.7-1.4 5.4-2.7 10.9-4.2 16.3-2 7.3-5.4 9.5-12.8 7.9-3.9-.9-7.8-2.2-11.6-3.6-4.1-1.6-7-.3-8.2 3.9l-.9 3.6c-.7 3.2.9 5.7 4.1 6.5 4 1 8 1.9 11.9 3 2.2.6 4.4 1.3 6.4 2.2 5.3 2.3 7 5.2 5.7 10.8-1.7 7.4-3.7 14.6-5.8 21.9-.8 2.9-3.4 4.3-6.6 3.5-3.5-.9-6.8-2.3-10.3-3.5-2.8-1-5.6-1.9-8.4-2.9-1.2-.4-2 0-2.4 1.2-.5 1.5-1 3.1-1.4 4.6-.9 3.7.3 6.6 3.7 8.4 3.6 2 7.6 2.6 11.6 3.3 2.1.4 4.3.7 6.4 1.2 2.8.6 4.5 2.4 4.1 5.3-.4 3.2-1.3 6.3-2.3 9.4-1 3.2-2.4 6.2-3.6 9.4-.4 1-.6 2.1-.8 3.1-.6 3.7-2.4 5.4-6.2 5.7-.6-.1-1.4-.1-2.2-.1ZM189.585 294.024c-11-.4-21.9-.6-32.9-1.1-4.7-.2-9.5-.7-14-2.5-3.2-1.3-4.8-3.8-4.9-6.8-.2-5.9-.3-11.8.1-17.6.7-10.3 1.7-20.6 2.7-30.8.4-4.5.9-8.9 1.4-13.4.8-6.6 1.2-13.2 1-19.9-.3-8.9-.5-17.8-.5-26.7 0-2.4.6-4.9 1.1-7.3 1.1-5 4.7-7.7 9.4-8.5 4.7-.7 9.6-.8 14.4-1 6.4-.3 12.7 0 19.1.9 4.5.7 7.2 3.4 7.7 8 .8 7 .2 14-.7 21-1 8.3-2 16.5-3.2 24.7-1.1 7.6-2.4 15.3-3.6 22.9-.7 4.5-1.7 8.9-2.1 13.4-.4 3.5.9 6.7 3.9 8.8 1.2.8 3 1.1 4.5 1.2 3.7.2 7.4.4 11 1.8 4.2 1.7 7.2 7.1 6.4 11.6-.8 4.7-1.6 9.5-2.2 14.2-.5 4.3-3.3 7.1-7.7 7.2-3.6-.1-7.2-.2-10.9-.1ZM440.485 133.524c2.8.3 4.6.4 6.5.6 8.1 1 16.3 2 24.5 1.7h2.9c4.1.1 5.9 3.2 4.2 6.9-2.3 5-5.7 9.3-8.9 13.7-3.5 4.8-6.7 9.8-8.8 15.4-1.5 3.8-2.3 7.8-1.7 11.9.2 1.3.6 2.6 1 3.9 2.3 7.9 6.8 14.6 11.4 21.3 2.9 4.2 5.5 8.6 7.9 13.2 4.1 7.9 2.7 15.3-2.6 22.3-3.3 4.4-5.9 9.4-8.6 14.3-3.7 6.6-7.7 12.9-15.2 16-2 .8-4.1.9-6.3.4-3.3-.8-6.7-1.5-10.2-1.7-7.9-.4-15.7-.4-23.6-.8-3.3-.1-6.1-1.4-7.6-4.6-.2-.5-.1-1.2.1-1.7 2-4.9 6.3-8 9.9-11.7 2.4-2.5 5.1-4.7 7.6-7 3.9-3.6 7.1-7.8 9.4-12.7 2.5-5.6 1.8-11.1-.6-16.5-2.7-6.1-7.1-11.1-10.8-16.5-3.6-5.1-7.1-10.3-9.2-16.3-2-6-1.7-12-.2-18 1.8-7.6 5.5-14.2 10-20.4 1.7-2.3 3.1-5 5.2-7 4.1-3.7 8.9-6.2 13.7-6.7ZM403.685 104.124c-.2 6.4-.3 12.9-.5 19.3-.1 2.4-.2 4.9-.5 7.3-.4 3.5-3.9 7.3-8.1 7.2-7.5-.2-14.9.2-22.3-1.2-1.9-.3-3.8-.7-5.7-1.4-3.9-1.5-5.4-4.7-5.6-8.5-.1-2.4-.1-4.8.2-7.1 1.5-13.4 3-26.9 2.7-40.4-.1-4.3-.1-8.6-.9-12.7-.8-4.5-4.1-7-8.5-8.1-4.1-1-8.2-.9-12.4-.5-1 .1-1.9-.1-2.9-.2-1.2-.2-1.8-.9-2.3-2-1.2-3.3-1.3-6.7-1.1-10.1.2-5.4.7-10.9 1-16.3.1-.9 0-1.7 0-2.6-.2-2.9 1.3-4.6 4.3-4.6 2.7 0 5.4.2 8.1.1 11.4-.4 22.9-1 34.3-1.3 10.5-.3 21-.5 31.5-.2 5 .1 10.2.7 14.9 2.6.7.3 1.6.9 1.8 1.6.6 1.5 1.2 3.1 1.1 4.7-.5 7.1-1.1 14.1-1.9 21.1-.2 1.7-.9 3.3-1.7 4.8-1.1 2.3-3.1 3.3-5.5 3.5-2.1.2-4.3.1-6.5.1-4.9 0-9 3.7-10.3 8.4-3.1 10.9-3.1 22.1-3.1 33.3.1.9 0 2-.1 3.2 0 0 .1 0 0 0ZM250.785 65.824c-.1 8.4-1.4 16.6-5.2 24.2-6.8 13.5-18 21.2-32.7 23.6-15.3 2.4-29.3-1.1-41.3-10.9-12.4-10.1-17.4-23.7-16.8-39.3.8-20.2 14-35.6 34.3-40.3 13.2-3.1 26.1-2.1 38.2 4 15.9 7.9 23.6 21 23.5 38.7Zm-36.1 1.2v-1.6c-.4-6.9-4.4-11.8-10.4-13-8.2-1.6-13.6.8-16.9 7.6-2.2 4.6-2.9 9.5-1.7 14.5 1.2 5.5 4.1 9.6 9.8 10.9 6 1.3 11-.4 14.8-5.3 3-3.8 4.3-8.2 4.4-13.1ZM246.585 134.224c.9-4.8 1.6-9.7 2.8-14.4 1.6-6.6 3.5-13.1 5.4-19.6 1.5-5.1 3.2-10.2 4.6-15.3 1.1-3.9 1.9-7.9 2.9-11.9.3-1.4.8-2.8 1-4.2.9-5.1 1.7-10.3 2.6-15.4.8-4.3 1.4-8.6 2.5-12.8 1.6-6.2 7.5-10.6 13.6-10.4 3.5.1 6.2 1.9 8.3 4.5 2.4 3 4.4 6.3 6.7 9.5 1.3 1.8 2.7 3.6 4 5.4 1.2 1.7 2.4 3.5 3.6 5.1 2.1 2.8 4.3 5.5 6.5 8.2 2.1 2.6 4.3 5.2 6.5 7.8 2.1 2.5 4.2 4.9 6.3 7.4 2.1 2.5 4.2 4.9 6.2 7.4 3.1 3.7 6.3 7.4 9.1 11.3 3.9 5.4 7.5 11 11 16.7 1.5 2.3 2.2 5.1 0 7.5-.7.8-1.6 1.6-2.5 1.8-6.9 1.6-13.8 3.1-20.7 4.7-3.4.7-6.4-.2-9.2-2.1-4.4-3.1-8-6.9-11-11.3-1.3-2-2.6-4-4-5.9-1.9-2.6-5.5-3.6-8.8-2.6-2.5.8-4.1 3.2-4.4 6.4-.1 1.6-.4 3.1-.7 4.6-.9 4.5-2 8.9-2.8 13.5-.7 4.1-3.6 6-7.2 6.8-5.9 1.2-11.8 2-17.7 2.9-3.1.5-6.2.7-9.3 1.1-2.9.4-4.6-.8-4.9-3.7-.1-1-.1-1.9-.2-2.9l-.2-.1ZM31.885 54.524c-1.1-.3-2.2-.5-3.2-.9-7.4-3.1-13.3-8-18.3-14.3-4.7-5.8-8-12.3-10.1-19.4-.8-2.8.1-5.1 2.5-6.7.4-.2.7-.5 1-.8 1.3-1.2 2.3-1.2 3.7-.1 5.2 3.9 10.7 7.1 17.6 6.6 4.1-.3 8.3-.2 12.5-.1 1.4 0 2.8.3 4.1.8 3.8 1.5 5 5.3 3.1 8.8-3.3 6-5.6 12.2-6.7 19-.2 1-.5 1.9-.7 2.8-.9 3.1-2.2 4.1-5.5 4.3ZM459.285 42.624c-4 .1-7.4-1.8-7.8-5.9-.2-3.3-.8-6.6-1.1-10-.3-2.8-1.3-5.3-2.8-7.7-1.9-3.1-1.9-6 .3-7.8 1.2-1 2.8-2 4.4-2.2 4.1-.6 8.3-1 12.4-1.2 5.6-.2 10.3-2.2 14.5-5.9 1-.9 2.4-1.6 3.7-1.8 3.7-.8 7 2.4 6.3 6.1-2.7 13.4-9.1 24.5-20.2 32.6-3.1 2.3-6.4 4.1-9.7 3.8ZM449.485 91.024c0 8.9-5.7 14.7-14.1 14.7-8.5 0-15-6.4-15-14.8 0-7.7 6.2-13.4 14.6-13.4 8.5 0 14.5 5.6 14.5 13.5ZM182.785 133.324c-.2 5-2.1 9.7-7.6 12-5.8 2.5-11.3 1.6-16-2.5-4.3-3.7-5.4-8.7-3.9-14.1 1-3.5 3.3-6 6.7-7.5 4.9-2.2 9.8-2 14.5.4 4.3 2.3 6.3 6.1 6.3 11.7ZM260.985 20.124c0 5.6-3.8 9.3-9.3 9.3-5.7 0-9.9-4.2-9.8-9.7.1-4.9 4.1-8.5 9.6-8.5 5.7.1 9.5 3.7 9.5 8.9ZM352.085 143.424c0 5.6-3.8 9.4-9.4 9.3-5.6-.1-9.7-4.2-9.7-9.6 0-5 4.2-8.6 9.7-8.5 5.7.1 9.5 3.6 9.4 8.8Z"
            fill="#B0FEFE"
          />
          <path
            d="M443.585 181.124c.1-8 1.9-14.6 5.2-20.7 1.9-3.5 4.3-6.9 6.8-10 2.2-2.7 5.2-3 7.5-1.3 2.5 1.9 2.8 4.8.6 7.4-2.8 3.3-5.2 6.9-6.9 10.9-3.9 9-4.3 17.7 1.1 26.3 1.1 1.7 2 3.6 2.7 5.5 1 2.7 0 5.3-2.4 6.5-2.2 1.1-4.9.5-6.4-1.9-3.3-5.3-6.6-10.7-7.6-17-.3-2.2-.5-4.5-.6-5.7ZM241.985 64.824c.1 4.6-3.7 7.4-7.2 5.6-2-1-2.9-2.8-3.1-5-.5-5.6-2-10.9-4.9-15.8-2.2-3.7-5.2-6.6-9.2-8.3-1.3-.6-2.7-1.5-3.6-2.6-2.2-3 .2-7.5 4-7.4 2 .1 4.1.8 6 1.7 6.4 3.3 10.7 8.7 13.6 15.1 2.5 5.3 3.9 11 4.4 16.7ZM188.185 182.524c-.4 4.6-.9 11.1-1.5 17.6-.1 1.3-.6 2.7-1.4 3.7-1.1 1.7-2.9 2.5-5 1.9-2.1-.6-3.4-2-3.8-4.2-.2-.9-.1-1.9-.1-2.9.5-6.2 1.2-12.5 1.6-18.7.1-2.1-.2-4.2-.6-6.2-.1-.7-1-1.5-1.7-1.9-2.6-1.4-3.9-3.5-3.3-5.9.6-2.5 2.9-4.1 5.8-3.8 4.2.4 6.8 2.9 8.4 6.6 1.7 3.9 1.7 7.9 1.6 13.8ZM307.085 69.524c-.2 2.2-1.6 4.2-3.5 4.9-2 .8-4.2.2-5.6-1.7-1.7-2.3-3.2-4.9-4.9-7.3-4.8-7-9.8-14-15.6-20.2-2.2-2.3-2.4-4.9-.5-7.1 1.8-2.1 4.9-2.4 7.3-.3 2.1 1.8 4 3.8 5.6 6 5.3 7.3 10.5 14.6 15.6 22 .8 1.1 1.1 2.5 1.6 3.7ZM298.585 191.924c.7-1.6 1.8-3.8 2.8-6 2.6-5.6 5.1-11.2 7.7-16.7.5-1 1-2 1.8-2.9 1.6-1.8 3.9-2.3 5.8-1.3 2 1 3.3 3.3 2.6 5.6-.6 2.3-1.6 4.6-2.6 6.8-2.6 5.6-5.2 11.1-7.9 16.6-.5 1-1.2 1.9-2.1 2.7-1.5 1.4-3.3 1.7-5.1.9-1.9-1-2.9-2.7-3-5.7ZM246.685 175.424c0 2.9-1.8 5.2-4.3 5.5-2.4.4-4.9-1.2-5.6-3.9-1.1-3.9-1.9-7.8-2.9-11.6-.5-1.7-1.1-3.4-1.6-5.1-1-3-.6-5.3 1.3-6.9 2.8-2.4 6.8-1.4 8.1 2.5 1.9 6.1 3.4 12.3 5 18.4v1.1ZM77.285 75.424c0-2.7 1.7-4.9 4.3-5.3 2.3-.4 4.7 1.1 5.7 3.8 1.5 4.4 4.2 7.8 7.5 11 .7.7 1.4 1.3 2 2.1 1.6 2.2 1.5 4.6-.3 6.5-1.7 1.8-4.4 2.1-6.5.7-4-2.7-7-6.4-9.5-10.5-2.5-4.2-3.2-6.2-3.2-8.3ZM21.785 32.124c-4.8-.2-9.3-1.5-13.5-3.8-2.8-1.6-3.8-4.3-2.7-6.7 1.3-2.7 4.1-3.8 7.1-2.5 3.7 1.7 7.4 2.7 11.6 2.5 2.8-.1 5 2 5.2 4.6.2 2.4-1.5 4.7-4.2 5.4-1.1.3-2.3.3-3.5.5ZM112.685 9.924c2.2 0 4.1.8 5.7 2.3 3.4 3.3 5 7.4 5.3 12 .2 2.2-1 3.9-2.9 4.9-1.7.9-3.5.8-4.8-.5-1-1-1.7-2.4-2.4-3.7-.3-.5-.3-1.2-.4-1.7-.5-1.6-1.2-2.8-3.2-3.1-2.2-.3-3.7-2.6-3.8-4.7 0-2.2 1.7-4.4 4.1-5.1.8-.2 1.6-.2 2.4-.4ZM425.685 35.724c-.8 3.2-1.5 6.5-2.6 9.6-1 2.8-4 4.1-6.6 3.1-2.4-.9-3.8-3.8-2.9-6.6 1-3.3 1.8-6.5.9-10-.6-2.5 1.3-5 3.8-5.6 2.5-.6 5.1.9 6 3.5.2.6.4 1.2.5 1.9.2 1.3.3 2.7.5 4 .1 0 .3.1.4.1ZM126.685 54.824c2.8.1 5 1.6 6.5 4.1 1.9 3.1 3 6.6 3.5 10.2.5 4.1-3.4 7-6.9 5.4-1.7-.8-2.7-2.3-3.2-4-.2-.6-.4-1.2-.5-1.9-.4-2.1-1.3-3.6-3.4-4.6-1.9-.9-2.5-3.3-2-5.2.7-2.4 3.1-4 6-4ZM461.985 11.124c2.1-.5 4.2-.8 6.2-1.5 3.7-1.2 6.4-.2 7.6 3 .7 1.8-.1 4.4-2 5.5-4.7 2.8-9.7 3.9-15.1 2.5-2.9-.8-4.5-3.4-4.1-5.8.5-2.6 2.8-4.2 5.9-4.1.4 0 .9 0 1.3.1.1 0 .1.2.2.3ZM396.685 183.824c-.4 3.2-.5 6.3-2.3 8.9-1.4 2-3.4 2.7-5.4 2.1-2-.6-3.6-2.7-3.6-4.9 0-.9.3-1.8.4-2.7.1-1.4.4-2.9.3-4.3-.2-2.9 1.2-5.4 3.7-6 2.6-.6 5.6 1.2 6.4 4 .3.9.3 2 .5 2.9ZM108.185 198.324c0 3.7-1.9 6-4.3 6.4-2.4.3-4.8-1.3-5.5-3.8-.5-1.5-.9-3.1-1.3-4.7-.7-2.7.6-5.3 3-6.3 2.3-1 5.1 0 6.3 2.5.9 2.2 1.4 4.6 1.8 5.9ZM386.385 234.024c-.5 1.3-.8 2.6-1.5 3.7-1 1.8-3.2 2.6-5 2.2-2.1-.5-3.4-2-3.9-4.1-.2-.8-.3-1.6-.6-2.3-1.3-3.4-.5-5.9 2.3-7.3 2.5-1.2 5.9.3 7.3 3.2.7 1.4 1 3 1.4 4.6ZM205.185 271.024c-.5 1.3-.9 2.8-1.7 3.9-2.1 2.8-6.2 2.4-7.9-.8-.7-1.2-1.2-2.5-1.9-3.7-1.1-2-.9-3.9.5-5.6 1.4-1.7 3.8-2.3 5.9-1.5 3 1.2 4.8 4 5.1 7.7ZM93.885 149.424c0 1.8-1 3.5-2.9 4.4-1.9.9-4 .6-5.5-1-1.3-1.4-2.5-2.9-3.3-4.5-.9-1.9-.2-4 1.3-5.3 1.7-1.4 3.6-1.7 5.6-.7 2.7 1.3 4.8 4.3 4.8 7.1ZM110.185 242.224c0-2.4 1.3-4.4 3.3-5.1 1.9-.7 3.9-.1 5.4 1.6 2.1 2.4 2.4 6 .7 8.2-1.8 2.4-4.9 2.6-7.1.6-1.6-1.5-2.2-3.4-2.3-5.3ZM370.785 285.124c-2.6 0-5.2-2.9-5.2-5.8s2.2-5.2 4.9-5.2 5.2 2.7 5.3 5.6c.1 2.6-2.5 5.4-5 5.4ZM347.885 142.024c0 2.5-2.2 4.8-4.8 4.8-2.5 0-4.8-2.3-4.8-4.8s2.2-4.6 4.7-4.7c2.6-.1 4.9 2.2 4.9 4.7ZM175.685 128.624c0 2.5-2.3 4.8-4.8 4.8-2.4 0-4.6-2.2-4.7-4.7 0-2.5 2.2-4.8 4.7-4.8 2.5-.1 4.8 2.2 4.8 4.7ZM237.785 84.024c-2.5 0-4.8-2.3-4.7-4.8.1-2.5 2.3-4.6 4.7-4.6 2.5 0 4.8 2.3 4.8 4.8 0 2.3-2.3 4.6-4.8 4.6ZM252.485 23.224c-2.5 0-4.8-2.3-4.8-4.8s2.3-4.8 4.8-4.7c2.4 0 4.6 2.2 4.6 4.7.2 2.5-2 4.8-4.6 4.8ZM295.585 211.424c-2.5 0-4.8-2.1-4.8-4.7 0-2.5 2.2-4.8 4.7-4.8s4.6 2.2 4.7 4.6c.1 2.6-2.1 4.9-4.6 4.9ZM140.385 83.024c0 2.5-2.2 4.8-4.7 4.8s-4.8-2.3-4.8-4.8c0-2.4 2.2-4.6 4.7-4.7 2.5 0 4.8 2.2 4.8 4.7ZM309.685 87.824c-2.5 0-4.8-2.2-4.7-4.8 0-2.5 2.3-4.7 4.8-4.7s4.6 2.2 4.7 4.7c0 2.6-2.2 4.8-4.8 4.8ZM436.985 81.324c2.6 0 4.8 2.2 4.8 4.7s-2.2 4.7-4.8 4.7c-2.4 0-4.6-2.2-4.7-4.7-.1-2.5 2.1-4.7 4.7-4.7ZM467.685 214.424c0 2.5-2.1 4.7-4.6 4.7-2.6 0-4.8-2.2-4.8-4.7s2.2-4.8 4.7-4.8c2.6 0 4.8 2.2 4.7 4.8Z"
            fill="#fff"
          />
        </svg>
      </div>
      <div className="object coins">
        <svg
          width={765}
          height={547}
          viewBox="0 0 765 547"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M228.807 222.008c-40.6 62.3-62.2 144.6-106.2 162.2-22.5 9-73.4-25.3-89.1-33.1-46.6-22.9-34.6-117.8 26.7-212s148.7-152 195.3-129.1c16.1 7.9 69.6 27.7 72.1 49.9 4.6 41.9-58.8 100.5-98.8 162.1Z"
            fill="#FD9843"
          />
          <path
            d="M315.607 265.808c-61.3 94.2-148.8 152-195.4 129.2-46.6-22.9-34.6-117.8 26.7-212s148.8-152 195.4-129.2c46.6 22.8 34.6 117.8-26.7 212Z"
            fill="#FDB75D"
          />
          <path
            d="M315.607 265.808c-61.3 94.2-148.8 152-195.4 129.2-46.6-22.9-34.6-117.8 26.7-212s148.8-152 195.4-129.2c46.6 22.8 34.6 117.8-26.7 212ZM33.407 351.208c-46.6-22.9-34.6-117.8 26.7-212s148.8-152.1 195.4-129.2M35.707 352.308l86.8 43.8"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M358.807 287.008c-23 35.3-35.2 81.8-60.1 91.8-12.7 5.1-41.5-14.3-50.4-18.7-26.3-12.9-19.6-66.6 15.1-119.9 34.7-53.3 84.2-86 110.5-73.1 9.1 4.5 39.4 15.7 40.8 28.3 2.6 23.6-33.3 56.7-55.9 91.6Z"
            fill="#FDC55C"
          />
          <path
            d="M407.907 311.708c-34.7 53.3-84.2 86-110.5 73.1-26.3-12.9-19.6-66.6 15.1-119.9 34.7-53.3 84.2-86 110.5-73.1 26.3 12.9 19.6 66.6-15.1 119.9Z"
            fill="#FEDB93"
          />
          <path
            d="M407.907 311.708c-34.7 53.3-84.2 86-110.5 73.1-26.3-12.9-19.6-66.6 15.1-119.9 34.7-53.3 84.2-86 110.5-73.1 26.3 12.9 19.6 66.6-15.1 119.9ZM248.207 360.008c-26.3-12.9-19.6-66.6 15.1-119.9 34.7-53.3 84.2-86 110.5-73.1M373.907 167.008l49.1 24.8M249.507 360.708l49.2 24.7"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M363.607 401.708c-13.1 20.1-20 46.6-34.2 52.3-7.3 2.9-23.7-8.2-28.7-10.7-15-7.4-11.2-38 8.6-68.3 19.8-30.4 48-49 63-41.6 5.2 2.6 22.4 8.9 23.2 16.1 1.5 13.4-19 32.3-31.9 52.2Z"
            fill="#FDC55C"
          />
          <path
            d="M391.607 415.808c-19.8 30.4-48 49-63 41.6-15-7.4-11.2-38 8.6-68.3 19.8-30.4 48-49 63-41.6 15 7.3 11.2 37.9-8.6 68.3Z"
            fill="#FEDB93"
          />
          <path
            d="M391.607 415.808c-19.8 30.4-48 49-63 41.6-15-7.4-11.2-38 8.6-68.3 19.8-30.4 48-49 63-41.6 15 7.3 11.2 37.9-8.6 68.3ZM300.607 443.308c-15-7.4-11.2-38 8.6-68.3 19.8-30.4 48-49 63-41.6M372.207 333.308l28 14.1M301.407 443.708l28 14.1"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M560.907 293.808c-14.5 22.2-22.2 51.5-37.9 57.8-8 3.2-26.2-9-31.8-11.8-16.6-8.2-12.3-42 9.5-75.6 21.9-33.6 53-54.2 69.6-46 5.8 2.8 24.8 9.9 25.7 17.8 1.7 15-20.9 35.9-35.1 57.8Z"
            fill="#FDC55C"
          />
          <path
            d="M591.807 309.408c-21.9 33.6-53 54.2-69.6 46-16.6-8.2-12.3-42 9.5-75.6 21.9-33.6 53-54.2 69.6-46 16.6 8.2 12.4 42-9.5 75.6Z"
            fill="#FEDB93"
          />
          <path
            d="M591.807 309.408c-21.9 33.6-53 54.2-69.6 46-16.6-8.2-12.3-42 9.5-75.6 21.9-33.6 53-54.2 69.6-46 16.6 8.2 12.4 42-9.5 75.6ZM491.207 339.908c-16.6-8.2-12.3-42 9.5-75.6 21.9-33.6 53-54.2 69.6-46M570.407 218.308l30.9 15.5M492.007 340.308l31 15.6"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M715.707 458.908c-10.8 16.5-16.5 38.3-28.2 43-6 2.4-19.5-6.7-23.6-8.8-12.3-6.1-9.2-31.2 7.1-56.2 16.3-25 39.4-40.3 51.8-34.2 4.3 2.1 18.5 7.4 19.1 13.2 1.3 11.1-15.5 26.7-26.2 43Z"
            fill="#FDC55C"
          />
          <path
            d="M738.807 470.508c-16.3 25-39.4 40.3-51.8 34.2-12.3-6.1-9.2-31.2 7.1-56.2 16.3-25 39.4-40.3 51.8-34.2 12.3 6.1 9.1 31.2-7.1 56.2Z"
            fill="#FEDB93"
          />
          <path
            d="M738.807 470.508c-16.3 25-39.4 40.3-51.8 34.2-12.3-6.1-9.2-31.2 7.1-56.2 16.3-25 39.4-40.3 51.8-34.2 12.3 6.1 9.1 31.2-7.1 56.2ZM663.907 493.108c-12.3-6.1-9.2-31.2 7.1-56.2 16.3-25 39.4-40.3 51.8-34.2M722.807 402.708l23 11.6M664.607 493.408l23 11.6"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M731.107 505.908c-8 12.3-12.3 28.5-21 32-4.4 1.8-14.5-5-17.6-6.5-9.2-4.5-6.8-23.2 5.3-41.8 12.1-18.6 29.4-30 38.5-25.5 3.2 1.6 13.7 5.5 14.2 9.9 1.1 8.2-11.4 19.8-19.4 31.9Z"
            fill="#FDC55C"
          />
          <path
            d="M748.307 514.608c-12.1 18.6-29.4 30-38.5 25.5-9.2-4.5-6.8-23.2 5.3-41.8 12.1-18.6 29.4-30 38.5-25.5 9.1 4.4 6.8 23.2-5.3 41.8Z"
            fill="#FEDB93"
          />
          <path
            d="M748.307 514.608c-12.1 18.6-29.4 30-38.5 25.5-9.2-4.5-6.8-23.2 5.3-41.8 12.1-18.6 29.4-30 38.5-25.5 9.1 4.4 6.8 23.2-5.3 41.8ZM692.607 531.408c-9.2-4.5-6.8-23.2 5.3-41.8 12.1-18.6 29.4-30 38.5-25.5M736.407 464.108l17.1 8.6M693.007 531.608l17.2 8.7"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="object bricks">
        <svg
          width={727}
          height={459}
          viewBox="0 0 727 459"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 305.8v77.8l81-11.7v-78.5L4 305.8Z"
            stroke="#8FFDC6"
            strokeWidth={7}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M600 336.8V405l71-10.2V326l-71 10.8Z" fill="#FC66AD" />
          <path
            d="M600 336.8V405l71-10.2V326l-71 10.8Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M93 385.8V454l71-10.2V375l-71 10.8Z" fill="#FC66AD" />
          <path
            d="M93 385.8V454l71-10.2V375l-71 10.8Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M642 87.8V156l71-10.2V77l-71 10.8Z" fill="#FC66AD" />
          <path
            d="M642 87.8V156l71-10.2V77l-71 10.8Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M66 15.8V84l71-10.2V5L66 15.8Z" fill="#FC66AD" />
          <path
            d="M66 15.8V84l71-10.2V5L66 15.8Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m608 179.8 40 17v31h34l40 17-128 72-40-22 2-21-50 9-40-17v-60l142-26Z"
            fill="#FD9FC5"
          />
          <path
            d="M648 196.8v60l74-12v49.6l-128 22.4v-50l-88 16v-60l142-26Z"
            fill="#FC66AD"
          />
          <path
            d="M648 196.8v60l74-12v49.6l-128 22.4v-50l-88 16v-60l142-26Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M466 260.8v-60l142-26 40 22v31l34-5 40 22M554 294.8v-17M722 244.8l-40-22M594 316.8l-40-22M505 282.8l-40-22"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="object saturn">
        <svg
          width={223}
          height={172}
          viewBox="0 0 223 172"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.823 111.926c-20.8 18-32.5 32-29.3 36.7 5.6 8.2 54.6-15.1 109.5-52.2s95-73.8 89.4-82c-3.1-4.6-19.9.7-43.8 12.8"
            fill="#F8267D"
          />
          <path
            d="M35.823 111.926c-20.8 18-32.5 32-29.3 36.7 5.6 8.2 54.6-15.1 109.5-52.2s95-73.8 89.4-82c-3.1-4.6-19.9.7-43.8 12.8"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
          />
          <path
            d="M169.423 38.726c-23.6-35-71.2-44.3-106.2-20.6-35 23.6-44.3 71.2-20.6 106.2 23.6 35 71.2 44.3 106.2 20.6 35-23.6 44.2-71.2 20.6-106.2Z"
            fill="#FDC55D"
          />
          <path
            d="M29.523 81.526c0 11.4 2.5 22.3 7 32 25.2 17.8 59.8 19.2 86.9.9 31.5-21.3 42.2-62 26.7-95.4-12.5-8.8-27.7-14-44.1-14-42.2 0-76.5 34.3-76.5 76.5Z"
            fill="#FEDB93"
          />
          <path
            d="M106.023 158.026c42.25 0 76.5-34.251 76.5-76.5 0-42.25-34.25-76.5-76.5-76.5s-76.5 34.25-76.5 76.5c0 42.249 34.25 76.5 76.5 76.5Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
          />
          <path
            d="M106.023 158.026c42.25 0 76.5-34.251 76.5-76.5 0-42.25-34.25-76.5-76.5-76.5s-76.5 34.25-76.5 76.5c0 42.249 34.25 76.5 76.5 76.5Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
          />
          <path
            d="m216.723 31.026-11.2-16.6c-.5-.7-1.2-1.2-2.3-1.4-.3 11.1-38.6 45.4-89.9 80-50.3 34-95.7 56.4-107.2 53.6 0 .8.1 1.5.5 2l11.2 16.6c5.6 8.2 54.6-15.1 109.5-52.2s94.9-73.8 89.4-82Z"
            fill="#FD67AE"
          />
          <path
            d="M11.723 154.226c5.6 8.2 54.6-15.1 109.5-52.2s95-73.8 89.4-82l-2.5-3.7c-.9 11.4-39 45.4-89.9 79.8-54.9 37.1-104 60.4-109.5 52.2"
            fill="#F785E6"
          />
          <path
            d="M35.823 111.926c-20.8 18-32.5 32-29.3 36.7 5.6 8.2 54.6-15.1 109.5-52.2s95-73.8 89.4-82c-3.1-4.6-19.9.7-43.8 12.8"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
          />
          <path
            d="m6.523 148.626 11.2 16.6c5.6 8.2 54.6-15.1 109.5-52.2s95-73.8 89.4-82l-11.2-16.6"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="object prisma1">
        <svg
          width={185}
          height={178}
          viewBox="0 0 185 178"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m8 108 91 65L180 5 5 39l3 69Z" fill="#89D6FD" />
          <path d="M8 108 180 5 5 39l3 69Z" fill="#29A7FC" />
          <path
            d="m8 108 91 65L180 5 5 39l3 69ZM176 9 8 108"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="object prisma2">
        <svg
          width={274}
          height={268}
          viewBox="0 0 274 268"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 169 228 5l41 258L5 169Z" fill="#8FFDC6" />
          <path d="M187 233.8 228 5l41 258-82-29.2Z" fill="#3AC8D9" />
          <path
            d="M5 169 228 5l41 258L5 169ZM187 231 228 5"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="object rainbow">
        <svg
          width={1232}
          height={526}
          viewBox="0 0 1232 526"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M663.362 166.086c130 39.3 193 108.2 221.2 151.7l261.898 50.4s-132.5-223.5-405.498-318.5c-445-146-665.6 112.5-665.6 112.5l307.6 59.2c40.4-34.4 135.6-93.7 280.4-55.3Z"
            fill="#FEDC93"
          />
          <path
            d="M663.362 166.086c200.6 60.6 241.6 191.6 241.6 191.6l-74.9-15.8 269.798 75.8c-6.1-104-187.498-325.3-478.898-375-299-51-461.3 110.9-461.3 110.9l227.8 64c42.8-34.7 136.3-88.6 275.9-51.5Z"
            fill="#FC66AD"
          />
          <path
            d="M663.362 166.086c165.9 50.1 222.6 148.4 237.3 180.9l156.598 40.2c-38.7-93.5-175.198-261.4-424.398-314.6-274.1-57.1-418.6 98.1-418.6 98.1l175.5 45.1c43.8-34.7 136.4-86.1 273.6-49.7Z"
            fill="#6957FB"
          />
          <path
            d="M663.362 166.086c112.7 34.1 175 90.3 208 133.1l101.299 19.5c-61.3-100-178.699-175-303.699-212-253-66-400.1 76.6-400.1 76.6l130.6 25.1c46.9-34 136.1-76.2 263.9-42.3Z"
            fill="#5CC7FC"
          />
          <path
            d="M663.362 166.086c164.6 49.7 221.7 146.8 236.9 180.1l50.7 11.5s-48.3-153.4-280.9-223.7c-243.1-60.3-358.1 78.6-358.1 78.6l64.4 14.6c35.9-32.8 133.6-101.8 287-61.1Z"
            fill="#8FFEC7"
          />
          <path
            d="M214.262 170.686s144.5-155.2 418.6-98.1c249.2 53.2 385.698 221.2 424.398 314.6"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M159.662 153.586s162.3-161.9 461.3-110.9c291.4 49.7 472.698 271 478.898 375"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M360.762 242.986s105.2-129.3 302.6-76.9c200.6 60.6 241.6 191.6 241.6 191.6"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M311.962 212.586s115-138.9 358.1-78.6c232.6 70.3 280.9 223.7 280.9 223.7"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M268.862 183.286s147.1-142.6 400.1-76.6c125 37 242.399 112 303.699 212"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M360.762 242.986s105.2-129.3 302.6-76.9c200.6 60.6 241.6 191.6 241.6 191.6"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M311.962 212.586s115-138.9 358.1-78.6c232.6 70.3 280.9 223.7 280.9 223.7"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M268.862 183.286s147.1-142.6 400.1-76.6c125 37 242.399 112 303.699 212"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M214.262 170.686s144.5-155.2 418.6-98.1c249.2 53.2 385.698 221.2 424.398 314.6"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M159.662 153.586s162.3-161.9 461.3-110.9c291.4 49.7 472.698 271 478.898 375"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M75.362 162.186s220.6-258.5 665.6-112.5c272.998 95 405.498 318.5 405.498 318.5"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M360.762 242.986s105.2-129.3 302.6-76.9c200.6 60.6 241.6 191.6 241.6 191.6"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M224.962 160.586s-24-39.9-78-34.9c-19 1-33.3 9.8-38.6 27.9-5.7 16.2-1.9 66.2 77.4 71.6-4.8 16.5-1.1 26.4 14.6 30.4-6.7 13.1-3.3 54 47.7 47 34-7 32-50 12-58 18 9 35 28 89 22 32-5 45.7-38.4 4.9-62.7-31.7-21.6-55.8-17.4-55.8-17.4s-23.3-36-73.2-25.9Z"
            fill="#5CC7FD"
          />
          <path
            d="M266.162 248.786c-17.3-5.5-25.8-6-32.2-6.4-6.4-.5-11.4 5.6-9.7 11.8 4.1 14.6 7.3 35.1.4 48 6.3 1.4 14 1.7 23.2.5 30.1-6.2 32.1-40.4 18.3-53.9ZM268.662 249.586c10.5 6.4 22.7 14.2 43.3 17-18.6-8.1-32.5-13.4-43.3-17Z"
            fill="#29A8FC"
          />
          <path
            d="M353.862 203.986c-31.7-21.6-55.8-17.4-55.8-17.4s-23.1-36.1-73.1-26c0 0-24-39.9-78-34.9-11.4.6-21.1 4-28.2 10.6 46.4.8 67.1 35.3 67.1 35.3 50-10.1 73.1 26 73.1 26s24.1-4.2 55.8 17.4c40.9 24.3 29.2 46.7-2.8 51.7 10.1 1.4 22.1 1.7 37 0 32-5 45.7-38.4 4.9-62.7Z"
            fill="#29A8FC"
          />
          <path
            d="M224.962 160.586s-24-39.9-78-34.9c-19 1-33.3 9.8-38.6 27.9-5.7 16.2-1.9 66.2 77.4 71.6-4.8 16.5-1.1 26.4 14.6 30.4-6.7 13.1-3.3 54 47.7 47 34-7 32-50 12-58 18 9 35 28 89 22 32-5 45.7-38.4 4.9-62.7-31.7-21.6-55.8-17.4-55.8-17.4s-23.3-36-73.2-25.9Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M401.762 168.986c-7-2.3-14.5-3-21.8-1.6-8 1.5-17.5 5.7-18 17.2-1 15 18.4 20.6 36.7 19.3 16.7-1.3 29.4-26.1 3.1-34.9Z"
            fill="#5CC7FD"
          />
          <path
            d="M401.762 168.986c-7-2.3-14.5-3-21.8-1.6-4.6.9-9.8 2.7-13.4 6.3 5.5-.3 11 .5 16.2 2.3 18.1 6 17.7 19.8 10.1 28.1 1.9 0 3.8 0 5.7-.2 16.8-1.3 29.5-26.1 3.2-34.9Z"
            fill="#29A8FC"
          />
          <path
            d="M403.762 166.386c-8.1-2.7-16.9-3.4-25.3-1.8-9.3 1.8-20.3 6.7-21 20-1.2 17.4 21.4 23.9 42.6 22.4 19.5-1.6 34.3-30.4 3.7-40.6Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M293.462 96.786c-8.1-3.1-16.7-3.9-25.1-2.1-9.2 2-20.1 7.6-20.8 22.8-1.2 19.8 21.2 27.2 42.2 25.5 19.3-1.9 34-34.7 3.7-46.2Z"
            fill="#5CC7FD"
          />
          <path
            d="M293.462 96.786c-8.1-3.1-16.7-3.9-25.1-2.1-5.4 1.2-11.3 3.6-15.5 8.4 6.3-.4 12.6.7 18.7 3 20.9 8 20.4 26.1 11.7 37.2 2.2 0 4.4 0 6.6-.2 19.2-2 33.9-34.8 3.6-46.3Z"
            fill="#29A8FC"
          />
          <path
            d="M295.862 93.186c-9.4-3.6-19.4-4.6-29.1-2.4-10.7 2.3-23.4 8.8-24.2 26.5-1.3 23 24.6 31.6 49.1 29.6 22.3-2.1 39.3-40.2 4.2-53.7Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.462 139.486c-11.7-3.8-24.2-4.8-36.2-2.6-13.3 2.5-29.1 9.4-30 28.1-1.7 24.4 30.6 33.5 61 31.4 27.7-2.3 48.8-42.7 5.2-56.9Z"
            fill="#5CC7FD"
          />
          <path
            d="M72.462 139.486c-11.7-3.8-24.2-4.8-36.2-2.6-7.7 1.4-16.3 4.4-22.3 10.3 9.1-.5 18.3.8 27 3.7 30.2 9.9 29.4 32.2 16.9 45.8 3.2 0 6.3-.1 9.5-.3 27.6-2.3 48.7-42.7 5.1-56.9Z"
            fill="#29A8FC"
          />
          <path
            d="M74.662 137.286c-12.3-4.2-25.4-5.3-38.1-2.8-13.9 2.7-30.5 10.2-31.5 30.6-1.7 26.7 32.1 36.5 64.1 34.3 29.1-2.5 51.4-46.5 5.5-62.1Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1070.26 368.486s-10.9-50.9-67.6-55.5c-20.998-2.8-38.198 6.1-46.198 28.5-7.8 18.9-8 74 64.298 86.7-7 14.3-5.6 23 6.5 27.4-7.8 10.2-11.9 41 27.1 37.6 25.5-3.7 34.8-35.3 22-42.8 11 8.2 18.2 23.3 56.3 21.4 22.1-2.1 42.4-25.7 24.1-48-14.9-21.8-34.5-20.4-34.5-20.4s-5.9-38.6-52-34.9Z"
            fill="#8FFEC6"
          />
          <path
            d="M1080.06 453.986c-11.7-5.5-18.2-6.5-23-7.3-5-.8-10.3 3.9-10.2 9 .1 11.8-1.6 27.3-9.2 36.3 4.4 1.2 9.9 1.7 16.8 1.1 22.5-3.3 32.2-27.9 25.6-39.1Z"
            fill="#3AC8D9"
          />
          <path
            d="M1081.66 454.786c6.1 5.6 12.7 12.1 26.3 15.2-10.7-7-19.3-11.8-26.3-15.2Z"
            fill="#29A8FC"
          />
          <path
            d="M1156.86 423.686c-14.9-21.8-34.6-20.4-34.6-20.4s-6-38.5-52.1-34.8c0 0-10.9-50.9-67.6-55.5-12.498-1.7-23.698.9-32.598 8.2 49.298 10.2 61.798 53.8 61.798 53.8 47.6-3.9 56.4 34.6 56.4 34.6s20.3-1.5 37.1 20.3c20.4 22.2 5.5 38.1-17.5 40.2 6.4 1.5 14.5 2.2 24.8 1.7 22.3-2.1 42.6-25.8 24.3-48.1Z"
            fill="#3AC8D9"
          />
          <path
            d="M1070.26 368.486s-10.9-50.9-67.6-55.5c-20.998-2.8-38.198 6.1-46.198 28.5-7.8 18.9-8 74 64.298 86.7-7 14.3-5.6 23 6.5 27.4-7.8 10.2-11.9 41 27.1 37.6 25.5-3.7 34.8-35.3 22-42.8 11 8.2 18.2 23.3 56.3 21.4 22.1-2.1 42.4-25.7 24.1-48-14.9-21.8-34.5-20.4-34.5-20.4s-5.9-38.6-52-34.9Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1203.56 397.986c-3.7-2.8-8.6-4.2-14.2-3.7-6.2.5-14.6 3.4-19.6 13.6-6.4 12.8 4.6 19 17.2 19.4 11.3.1 30-19.2 16.6-29.3Z"
            fill="#8FFEC6"
          />
          <path
            d="M1203.56 397.986c-3.7-2.8-8.6-4.2-14.2-3.7-3.6.3-8 1.4-12 4.3 3.9.3 7.4 1.6 10.3 3.6 9.7 7 3.7 18.5-4.5 24.7 1.2.2 2.5.3 3.8.3 11.3.2 30-19.1 16.6-29.2Z"
            fill="#3AC8D9"
          />
          <path
            d="M1206.06 395.786c-4.3-3.3-10-4.9-16.5-4.4-7.2.6-17.1 3.9-22.8 15.9-7.4 14.9 5.5 22 20.1 22.4 13 .3 34.6-22.1 19.2-33.9Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1121.56 284.586c-2.3-5.8-6.6-10.2-12.7-12.4-6.8-2.5-17.1-2.8-27.6 8.8-13 14.1-4.7 27.8 7.9 34.5 11.3 5.6 40.5-10.5 32.4-30.9Z"
            fill="#8FFEC6"
          />
          <path
            d="M1121.56 284.586c-2.3-5.8-6.6-10.2-12.7-12.4-3.9-1.4-9.1-2.1-14.9-.2 4 2.5 6.9 6 8.8 10.3 6.3 14.4-5.8 26.7-17.3 30.8 1.2.8 2.4 1.6 3.7 2.3 11.3 5.7 40.5-10.4 32.4-30.8Z"
            fill="#3AC8D9"
          />
          <path
            d="M1125.36 282.886c-2.6-6.8-7.6-11.9-14.8-14.6-7.9-2.9-20.1-3.4-32.2 10.3-15 16.5-5.2 32.3 9.4 39.9 13 6.6 46.8-11.9 37.6-35.6Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1006.86 482.586c-3.7-3.6-8.498-5.6-13.898-5.2-6 .4-14.1 3.6-18.2 16-5.2 15.2 5.8 22.9 17.7 23.7 10.598.6 27.498-21.6 14.398-34.5Z"
            fill="#8FFEC6"
          />
          <path
            d="M1006.86 482.586c-3.7-3.6-8.498-5.6-13.898-5.2-3.5.2-7.7 1.4-11.5 4.9 3.9.5 7.4 2.3 10.3 4.9 9.698 8.9 4.6 22.4-2.9 29.4 1.2.2 2.4.4 3.6.5 10.598.6 27.498-21.6 14.398-34.5Z"
            fill="#3AC8D9"
          />
          <path
            d="M1009.26 480.086c-4.3-4.3-9.898-6.6-16.298-6.2-7.1.5-16.5 4.2-21.2 18.8-5.9 17.7 6.9 26.5 20.7 27.5 12.198.5 31.798-25.1 16.798-40.1Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M916.062 315.486c-14.3-8-30.1-12.5-45.6-12.1-17.3.4-37.8 6.8-36.5 33.2 1 31.6 40.5 47.4 74.8 49.3 29.9 1.2 56.2-42.9 7.3-70.4Z"
            fill="#8FFEC6"
          />
          <path
            d="M916.062 315.486c-14.3-8-30.1-12.5-45.6-12.1-10.1.2-21.2 2.6-28.6 9.8 12 1.4 23.999 5.4 35.299 11.2 36.6 19.2 35.2 46.5 21 60.5 3.5.5 7 .8 10.5 1 30 1.2 56.301-42.9 7.401-70.4Z"
            fill="#3AC8D9"
          />
          <path
            d="M918.862 312.986c-15-8.7-31.6-13.5-48-13-18.3.6-39.9 7.7-38.3 36.7 1.3 34.4 42.6 51.2 78.3 53 31.1.9 59-47 8-76.7Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1222.56 156.186c-8-11.9-24.2-15-36.1-7-11.9 8-15 24.2-7 36.1 8 11.9 24.2 15 36.1 7 11.8-8.1 15-24.2 7-36.1Z"
            fill="#3AC8D9"
          />
          <path
            d="M1178.06 169.986c0 3.3.7 6.5 2 9.3 7.3 5.2 17.4 5.6 25.3.3 9.2-6.2 12.3-18 7.8-27.8-3.6-2.6-8.1-4.1-12.8-4.1-12.3 0-22.3 10-22.3 22.3Z"
            fill="#8FFEC6"
          />
          <path
            d="M1200.96 196.686c14.36 0 26-11.64 26-26 0-14.359-11.64-26-26-26s-26 11.641-26 26c0 14.36 11.64 26 26 26Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
          />
        </svg>
      </div>
      <div className="object crystal1 wow animate__animated animate__slideInRight">
        <svg
          width={162}
          height={151}
          viewBox="0 0 162 151"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m5 28.5 9.1 117 141.9-17L105 5 5 28.5Z" fill="#38C8D9" />
          <path d="m105 5.5-54 86 105 36-51-122Z" fill="#5AFDA5" />
          <path d="m49 87.5-45-61 97.4-21-52.4 82Z" fill="#8FFEC6" />
          <path
            d="M5 28.5 105 5l51 123.5-141.9 17L5 28.5Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105 5 51 94.5l-36.9 51L5 28.5l44 64 107 36"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="object crystal2 wow animate__animated animate__slideInLeft">
        <svg
          width={129}
          height={153}
          viewBox="0 0 129 153"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M30 5 5 108l119 40-20-117L30 5Z" fill="#FDAEE6" />
          <path d="M56.6 43 121 143 101 34l-44.4 9Z" fill="#F986E8" />
          <path d="m6 114 46-71 67 104L6 114Z" fill="#F54BD9" />
          <path
            d="M30 5 5 108l119 40-20-117L30 5Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m30 5 23 34 71 109-20-117-49 7-4 2-46 68"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="object stains">
        <svg
          width={2115}
          height={1080}
          viewBox="0 0 2115 1080"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#a)" fill="#9C8DFB">
            <path d="M738.6 667.2c-14.2.1-26.7-3.7-38.8-9-25.7-11.2-49.4-25.5-67.5-47.5-10-12.1-15.8-25.9-13.1-41.9 3.5-20.8 24.3-34.6 46.8-31.4 16.4 2.3 30.5 10.2 44 19 18.3 12 35.4 25.4 47.8 43.9 6.2 9.4 10.9 19.4 12.2 30.7 2.6 22.1-13.7 36.5-31.4 36.2ZM91 405.1c10.1 1.7 20.3 3.3 30.3 5.2 41.8 7.9 81.9 20.3 118.4 42.8 23.9 14.7 44.1 33.4 57.8 58 4.7 8.4 8 18 9.7 27.4 2.1 12.2-3.1 24.3-16.6 31.9-10.5 5.9-22.1 8-34 8.6-37.6 1.9-73.6-6.7-109.2-17-17.7-5.1-35.1-11.4-52.6-17.2-1.2-.4-2.5-.6-3.8-1C32.8 529-6.2 497 .8 456c4-23.5 15-59 90.2-50.9ZM752 529.5c-23-.3-44.6-6.9-65.7-15.3-34.7-13.7-67-32-96.7-54.3-30.6-23-64-40.4-98.8-55.9-16.2-7.2-32.2-15.1-48.1-23.1-4.6-2.3-8.7-5.5-12.7-8.8-13.1-10.9-17.2-24-10.5-39.7 15.3-35.8 41-59.7 80.3-66.7 28.6-5.2 56.2.4 83.3 9.4 21.9 7.3 42.9 16.7 62 29.6 13.7 9.2 26.2 20.4 39.4 30.4 17.3 13.2 35.1 25.9 52.2 39.3 21 16.4 39.4 35.3 53.4 58.1 9.3 15.1 15.3 31.3 15.2 49.4-.1 19.2-10.8 35.8-28.7 42.6-7.8 2.8-24.5 5.4-24.6 5ZM1529.7 637.7c-19.5-.7-37.1-2.4-52.8-11.3-14.4-8.1-22.1-21.9-20.4-37 1-8.7 4.7-16.2 10.2-22.9 10.3-12.4 23.7-20.5 37.6-28.3 20.4-11.3 42.4-16.4 65.3-17 9-.2 18.4.8 27.1 3.1 21.6 5.9 32 22.6 31.6 46.5-.3 19.2-9 33.2-24.1 43.9-17.6 12.5-37.5 19-58.8 21.6-5.8.9-11.6 1.1-15.7 1.4ZM2010 378.8c-11.1 3.5-21.7 7.5-32.6 10-20.8 4.8-41.7 9.5-62.8 12.9-38.9 6.3-78 11.6-117 17.3-20.5 3-40.9 6.2-61.4 8.9-25.7 3.4-51.6 4.9-77.5 3.8-23.6-1-46.9-4.7-69.2-12.9-14.6-5.4-28.6-11.9-38.4-24.9-10-13.3-11.6-27.8-5.8-43.2 5.2-14 15.2-24.5 26-34.1 26.2-23.2 56.4-40.3 87.2-56.4 15.3-8 30.4-16.3 46.3-23 26-11 53-19.4 80.7-25.1 23.4-4.8 46.9-8.8 70.8-9.8 17.9-.7 35.8-2 53.7-2.8 12.3-.5 24.6-1 36.9-.8 20.9.4 41.7 1.6 62.7 6.6 23.3 8.5 105.3 31.5 105.3 93.2-.1 44.5-77.1 76.5-104.9 80.3ZM1588 235.8c-8.1.8-16.3.2-24.1-2-2.3-.7-4.7-1.5-6.9-2.5-18.3-8.6-22.8-29.8-10.5-45.9 1.9-2.5 4-5 6.5-6.8 17.9-13.5 37.4-22.7 60.4-23.1 8.3-.2 16.5-2.3 24.7-3.2 9.1-1 18.1 0 26.5 3.7 19.1 8.3 23.9 32.7 9.7 47.9-7.9 8.4-17.8 13.7-28.4 17.8-17.7 7-36.2 11.9-57.9 14.1Z" />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M0 0h2114.8v1080H0z" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="object dashedcircle">
        <svg
          width={644}
          height={448}
          viewBox="0 0 644 448"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M485.32 88.7c11 0 25.2 1.9 31 10.9 8.5 13.3-2.9 40.5-30.5 72.8-30.1 35.3-75.9 73.4-129 107.3-38.2 24.3-77.3 44.6-113.3 58.7-34.6 13.5-64.4 20.7-86.3 20.7-11 0-25.2-1.9-31-10.9-8.5-13.3 2.9-40.5 30.5-72.8 30.1-35.3 75.9-73.4 129-107.3 38.2-24.3 77.3-44.6 113.3-58.7 34.5-13.6 64.4-20.7 86.3-20.7Zm0-7c-45.6 0-123.6 29.6-203.4 80.5-111 70.7-183.3 155.7-161.6 189.8 6.1 9.6 19 14.1 36.9 14.1 45.6 0 123.6-29.6 203.4-80.5 111-70.7 183.3-155.7 161.6-189.8-6.2-9.6-19.1-14.1-36.9-14.1ZM579.52 0H578.52c-6 0-12.4.4-19 1.1H559.22c-.2 0-.4 0-.6.1h-1.2c-.3 0-.5.1-.8.1h-.1c-1.3.1-2.7.3-4 .5-1.9.2-3.3 2-3 3.9.2 1.8 1.7 3.1 3.5 3.1h.4c9.3-1.2 18.1-1.8 26-1.8.7 0 1.3-.2 1.9-.5.5.3 1.2.6 1.8.6 9.5.2 17.9 1.4 24.9 3.4.3.1.6.1 1 .1 1.5 0 2.9-1 3.4-2.5.5-1.8-.5-3.8-2.4-4.3-7.8-2.2-16.7-3.4-26.8-3.7h-.1c-.7 0-1.3.2-1.9.5-.3-.4-1-.6-1.7-.6Zm-52.8 6.4c-.2 0-.5 0-.7.1l-1.5.3c-.1 0-.3.1-.4.1h-1.2c-.1 0-.2 0-.3.1h-.1c-7.3 1.6-14.9 3.6-22.7 5.7-1.9.5-2.9 2.5-2.4 4.3.4 1.5 1.8 2.6 3.4 2.6.3 0 .6 0 .9-.1 8.9-2.5 17.6-4.6 25.8-6.4 1.9-.4 3.1-2.3 2.7-4.2-.4-1.4-1.8-2.5-3.5-2.5Zm-51.6 14.3c-.4 0-.7.1-1.1.2-8.3 2.7-16.8 5.8-25.4 9-1.8.7-2.7 2.7-2 4.5.5 1.4 1.9 2.3 3.3 2.3.4 0 .8-.1 1.2-.2 8.5-3.2 17-6.2 25.2-8.9 1.8-.6 2.8-2.6 2.2-4.4-.6-1.6-1.9-2.5-3.4-2.5Zm-50.3 18.9c-.4 0-.9.1-1.3.3h-.1s-.1 0-.1.1h-.1s-.1 0-.1.1h-.1s-.1 0-.1.1c0 0-.1 0-.1.1-.1.1-.3.1-.4.2H421.32s-.1 0-.1.1c0 0-.1 0-.1.1H420.02s-.1 0-.1.1h-1.3c-.1 0-.1 0-.2.1 0 0-.1 0-.1.1H417.22c-.1 0-.1 0-.2.1h-1.2c-.1 0-.1.1-.2.1H414.72s-.1 0-.1.1c-.1.1-.3.1-.4.2 0 0-.1 0-.1.1 0 0-.1 0-.1.1 0 0-.1 0-.1.1 0 0-.1 0-.1.1-.3.1-.5.2-.8.3-.1 0-.1 0-.2.1-.1 0-.1 0-.2.1-4.6 2-9.3 4.1-13.9 6.2-1.8.8-2.5 2.9-1.7 4.6.6 1.3 1.9 2.1 3.2 2.1.5 0 1-.1 1.4-.3 8.2-3.7 16.5-7.3 24.6-10.7 1.8-.7 2.6-2.8 1.9-4.6-.6.7-1.9-.1-3.3-.1Zm-49 22.1c-.5 0-1 .1-1.5.4-8 3.9-16 7.9-24.1 12.1-1.7.9-2.4 3-1.5 4.7.6 1.2 1.8 1.9 3.1 1.9.5 0 1.1-.1 1.6-.4 8-4.1 16.1-8.2 24-12 1.7-.8 2.5-2.9 1.6-4.7-.7-1.3-1.9-2-3.2-2Zm-47.8 24.8c-.6 0-1.1.1-1.7.4-1.1.6-2.1 1.2-3.2 1.8h-.1c-.1.1-.2.1-.3.2-6.6 3.7-13.2 7.4-19.8 11.3-1.7 1-2.2 3.1-1.3 4.8.6 1.1 1.8 1.7 3 1.7.6 0 1.2-.2 1.8-.5 7.8-4.5 15.6-8.9 23.4-13.2 1.7-.9 2.3-3.1 1.4-4.8-.8-1.1-2-1.7-3.2-1.7Zm-46.6 27c-.6 0-1.3.2-1.8.5-4.6 2.8-9.2 5.6-13.8 8.5l-.1.1-.1.1-.1.1c-.1.1-.2.1-.3.2 0 0-.1 0-.1.1h-.1s-.1 0-.1.1c0 0-.1 0-.1.1h-.1s-.1 0-.1.1h-.1s-.1 0-.1.1l-.1.1c-.1.1-.2.1-.4.2l-.1.1-.1.1-.1.1c-.1 0-.1.1-.2.1-.1.1-.2.2-.4.2-.1 0-.1.1-.2.1l-.1.1c-.1 0-.1.1-.2.1-.2.2-.5.3-.7.5-.1 0-.1.1-.2.1 0 0-.1.1-.2.1 0 0-.1.1-.2.1-.2.2-.5.3-.7.5l-.1.1-.1.1-.1.1c-.1 0-.1.1-.2.1-.9.6-1.7 1.1-2.6 1.7-1.6 1-2.1 3.2-1 4.8.7 1 1.8 1.6 3 1.6.6 0 1.3-.2 1.9-.6.9-.6 1.7-1.1 2.6-1.7 6.7-4.3 13.5-8.5 20.2-12.6 1.7-1 2.2-3.2 1.2-4.8-1.5-.7-2.7-1.3-3.9-1.3Zm-45.3 29.1c-.7 0-1.3.2-1.9.6-.1 0-.1.1-.2.1s-.1.1-.2.1l-.1.1-.1.1-.1.1h-.1s-.1 0-.1.1c0 0-.1 0-.1.1 0 0-.1 0-.1.1 0 0-.1 0-.1.1-.1.1-.2.2-.3.2-7 4.7-13.8 9.4-20.6 14.2-1.6 1.1-1.9 3.3-.8 4.9.7 1 1.8 1.5 2.9 1.5.7 0 1.4-.2 2-.6 7.2-5.1 14.7-10.2 22.1-15.2 1.6-1.1 2-3.3 1-4.9-1-1.1-2.1-1.6-3.2-1.6Zm-44 31c-.7 0-1.4.2-2.1.7-.6.5-1.2.9-1.8 1.3 0 0-.1 0-.1.1l-.1.1s-.1 0-.1.1c0 0-.1 0-.1.1-.1 0-.1.1-.2.1l-.1.1c-.1 0-.1.1-.2.1-3.1 2.3-6.1 4.6-9.1 6.9-.1 0-.1.1-.2.1l-.1.1-.1.1-.1.1h-.1l-.1.1-.1.1s-.1 0-.1.1l-.1.1-.1.1h-.1s-.1 0-.1.1c-2.8 2.1-5.5 4.2-8.2 6.3-1.5 1.2-1.8 3.4-.6 4.9.7.9 1.7 1.3 2.8 1.3.8 0 1.5-.2 2.1-.7 7-5.4 14.1-10.9 21.4-16.2 1.6-1.2 1.9-3.3.7-4.9-.9-.8-1.9-1.3-3-1.3Zm-42.4 33.1c-.8 0-1.6.3-2.2.8-2.8 2.3-5.7 4.7-8.4 7-.1 0-.1.1-.2.2l-.1.1h-.1s-.1 0-.1.1h-.1l-.1.1-.1.1s-.1 0-.1.1c0 0-.1 0-.1.1 0 0-.1 0-.1.1l-.1.1h-.1l-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.3.3c-3.3 2.8-6.6 5.6-9.8 8.4-1.5 1.3-1.6 3.5-.3 4.9.7.8 1.7 1.2 2.6 1.2.8 0 1.6-.3 2.3-.9 6.6-5.8 13.5-11.6 20.5-17.3 1.5-1.2 1.7-3.4.5-4.9-1-.7-2-1.1-3-1.1Zm-40.6 35.3c-.9 0-1.7.3-2.4.9-1.1 1-2.1 2-3.2 2.9-.2.1-.3.3-.5.4-.1 0-.1.1-.2.1l-.1.1-.3.3-.1.1s-.1.1-.2.1l-.3.3-.1.1-.1.1-.3.3c-.1 0-.1.1-.2.1-4.8 4.5-9.4 9-13.8 13.4-1.4 1.4-1.4 3.6 0 4.9.7.7 1.6 1 2.5 1 .9 0 1.8-.3 2.5-1 6.1-6.1 12.6-12.3 19.3-18.5 1.4-1.3 1.5-3.5.2-4.9-.8-.3-1.7-.7-2.7-.7Zm-38 38c-.9 0-1.9.4-2.6 1.1-1.6 1.7-3.2 3.5-4.7 5.2 0 0 0 .1-.1.1 0 0 0 .1-.1.1l-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1v.7l-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1s0 .1-.1.1l-.1.1-.1.1-.1.1-.1.1-.1.1c-3.5 3.9-6.8 7.8-10 11.7-1.2 1.5-1 3.7.5 4.9.7.5 1.4.8 2.2.8 1 0 2-.4 2.7-1.3 5.5-6.5 11.4-13.3 17.6-20 1.3-1.4 1.2-3.6-.2-4.9-.5-1.2-1.3-1.5-2.2-1.5Zm-34.2 41.2c-1.1 0-2.1.5-2.8 1.4-4.8 6.6-9.1 13-13 19.2V342.1s0 .1-.1.1v.1c0 .1-.1.1-.1.2v.2c-.5.8-.9 1.5-1.4 2.3-1 1.7-.4 3.8 1.2 4.8.6.3 1.2.5 1.8.5 1.2 0 2.4-.6 3-1.7 4.2-7 9.1-14.4 14.6-21.9 1.1-1.6.8-3.8-.8-4.9-1-.4-1.7-.6-2.4-.6Zm-26.9 45.7c-1.4 0-2.7.8-3.2 2.2-1.2 2.8-2.2 5.6-3.2 8.3v.7c0 .1-.1.2-.1.3-1.3 4-2.3 7.9-3 11.6v.4c-.2 1-.3 2-.5 3-.2 1.9 1.1 3.7 3 3.9h.4c1.7 0 3.2-1.3 3.5-3.1.9-7.3 3.3-15.4 6.9-24.1.7-1.8-.1-3.8-1.9-4.6-1 1.5-1.4 1.4-1.9 1.4Zm-4.1 49.5c-.5 0-1 .1-1.5.3-1.7.8-2.5 2.9-1.7 4.6.6 1.2 1.2 2.4 1.9 3.6 0 0 0 .1.1.1v.1s0 .1.1.1c0 0 0 .1.1.1v.1s0 .1.1.1c0 0 0 .1.1.1 0 0 0 .1.1.1l.1.1.1.1.1.1c0 .1.1.1.1.2s.1.1.1.2l.1.1.1.1.3.3c0 .1.1.1.1.2s.1.1.1.2.1.1.1.2c3.6 4.1 8.1 7.5 13.5 10.1.5.2 1 .4 1.5.4 1.3 0 2.5-.7 3.1-1.9.9-1.7.1-3.8-1.6-4.7-6.1-3-10.8-7-13.9-11.9-.7-1-1.3-2.1-1.8-3.3 1.1 1-.1.2-1.4.2Zm42.1 23.5c-1.8 0-3.3 1.3-3.5 3.1-.2 1.9 1.2 3.6 3.1 3.9 4.3.5 8.8.7 13.6.8H65.12c3.2 0 6.4-.2 9.8-.4 1.9-.1 3.4-1.8 3.3-3.7-.1-1.9-1.7-3.3-3.5-3.3h-.2c-3.8.2-7.6.4-11.1.4-5.2 0-10.1-.3-14.6-.8h-.8Zm78.9-8.1c-.3 0-.6 0-.8.1-9 2.2-17.7 4-25.9 5.4-1.9.3-3.2 2.1-2.9 4 .3 1.7 1.8 2.9 3.4 2.9h.6c4.7-.8 9.6-1.7 14.6-2.8.1 0 .3-.1.4-.1h.1c.1 0 .2 0 .3-.1h.2c.1 0 .2 0 .3-.1.1 0 .3-.1.4-.1h.1c.1 0 .2 0 .3-.1h.2c.1 0 .2 0 .3-.1h.1c.1 0 .2 0 .3-.1h.2c.1 0 .2 0 .3-.1h.1c.1 0 .2 0 .3-.1h.2c.1 0 .2 0 .3-.1h.1c.1 0 .3-.1.4-.1.1 0 .3-.1.4-.1 2.1-.5 4.2-1 6.4-1.5 1.9-.5 3-2.4 2.6-4.2-.2-1.7-1.7-2.7-3.3-2.7Zm51.4-15.5c-.4 0-.8.1-1.2.2-8.6 3-17.2 5.8-25.4 8.3-1.8.6-2.9 2.5-2.3 4.4.5 1.5 1.8 2.5 3.3 2.5.3 0 .7 0 1-.1l2.1-.6c.2-.1.4-.1.6-.2.2-.1.4-.1.6-.2.2-.1.4-.1.6-.2h.1c7.1-2.2 14.3-4.6 21.7-7.2 1.8-.6 2.8-2.6 2.1-4.5-.4-1.5-1.8-2.4-3.2-2.4Zm50-19.7c-.5 0-.9.1-1.4.3-8.3 3.6-16.6 7-24.7 10.2-1.8.7-2.7 2.7-2 4.5.5 1.4 1.9 2.2 3.3 2.2.4 0 .9-.1 1.3-.2 2.9-1.2 5.9-2.3 8.9-3.6.1 0 .1 0 .2-.1 0 0 .1 0 .1-.1.1 0 .1 0 .2-.1.1 0 .1-.1.2-.1s.1 0 .2-.1H215.42c.1-.1.3-.1.4-.2h.5s.1 0 .1-.1l.6-.3c.1 0 .1 0 .2-.1.1 0 .1 0 .2-.1 1.8-.7 3.5-1.5 5.3-2.2.1 0 .1 0 .2-.1.2-.1.4-.2.7-.3 0 0 .1 0 .1-.1 0 0 .1 0 .1-.1h.5c.1 0 .1-.1.2-.1h.6s.1 0 .1-.1h.1c.1 0 .1 0 .2-.1l.6-.3c1.3-.6 2.6-1.1 3.9-1.7 1.8-.8 2.6-2.8 1.8-4.6-.8-1.6-2.1-2.4-3.5-2.4Zm48.8-22.7c-.5 0-1.1.1-1.6.4-8.1 4-16.2 8-24.1 11.7-1.8.8-2.5 2.9-1.7 4.7.6 1.3 1.9 2 3.2 2 .5 0 1-.1 1.5-.3 4.9-2.3 9.8-4.6 14.7-7 .1 0 .1-.1.2-.1s.1-.1.2-.1.1-.1.2-.1l.6-.3c.1 0 .1-.1.2-.1 0 0 .1 0 .1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1H272.22c.1 0 .1-.1.2-.1H272.72s.1 0 .1-.1H274.42s.1 0 .1-.1h.1c.1 0 .1-.1.2-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1c.1 0 .1-.1.2-.1.9-.4 1.8-.9 2.7-1.3 1.7-.9 2.4-3 1.6-4.7-1.1-2.4-2.4-3.1-3.6-3.1Zm47.5-25.3c-.6 0-1.2.1-1.7.5-7.8 4.4-15.7 8.7-23.5 12.9-1.7.9-2.4 3-1.4 4.7.6 1.2 1.8 1.9 3.1 1.9.6 0 1.1-.1 1.6-.4.9-.5 1.8-.9 2.7-1.4.1 0 .1-.1.2-.1s.1-.1.2-.1l.1-.1s.1 0 .1-.1h.1s.1 0 .1-.1c0 0 .1 0 .1-.1h.1s.1 0 .1-.1c.1 0 .1-.1.2-.1 4.9-2.6 9.8-5.3 14.8-8.1.1 0 .1-.1.2-.1 1.6-.9 3.1-1.7 4.7-2.6 1.7-1 2.3-3.1 1.3-4.8-.7-1.2-1.9-1.8-3.1-1.8Zm46.3-27.5c-.6 0-1.3.2-1.8.5-7.6 4.7-15.3 9.4-22.9 14-1.7 1-2.2 3.1-1.2 4.8.7 1.1 1.8 1.7 3 1.7.6 0 1.2-.2 1.8-.5.7-.4 1.4-.9 2.2-1.3.1-.1.2-.1.3-.2h.1l.1-.1c5.7-3.4 11.5-6.9 17.2-10.5.1 0 .1-.1.2-.1s.1-.1.2-.1l.1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1c0 0 .1 0 .1-.1h.1l.1-.1.1-.1c.6-.4 1.2-.7 1.8-1.1 1.6-1 2.1-3.2 1.1-4.8-.7-1.1-1.8-1.7-3-1.7Zm45.1-29.5c-.7 0-1.4.2-2 .6-7.3 5-14.8 10-22.3 14.9-1.6 1.1-2.1 3.2-1 4.8.7 1 1.8 1.6 2.9 1.6.7 0 1.3-.2 1.9-.6 7.6-5 15.1-10 22.5-15 1.6-1.1 2-3.3.9-4.9-.7-.8-1.8-1.4-2.9-1.4Zm43.6-31.4c-.7 0-1.5.2-2.1.7-7 5.3-14.3 10.7-21.6 15.9-1.6 1.1-1.9 3.3-.8 4.9.7 1 1.8 1.5 2.8 1.5.7 0 1.4-.2 2-.7 7.4-5.3 14.6-10.7 21.7-16 1.5-1.2 1.8-3.4.7-4.9-.6-.9-1.6-1.4-2.7-1.4Zm42.1-33.6c-.8 0-1.6.3-2.3.8-6.7 5.7-13.7 11.4-20.7 17-1.5 1.2-1.8 3.4-.6 4.9.7.9 1.7 1.3 2.7 1.3.8 0 1.5-.2 2.2-.8 3.3-2.6 6.6-5.3 9.8-7.9l.2-.2s.1 0 .1-.1c.1 0 .1-.1.2-.1.1-.1.2-.2.3-.2l.1-.1h.1l.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.3-.3c.3-.2.5-.4.8-.7 1.9-1.6 3.8-3.1 5.6-4.7 0 0 .1-.1.2-.1l.1-.1.1-.1.1-.1h.1l.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1c.3-.2.6-.5.9-.7 1.5-1.2 1.7-3.5.4-4.9-.4-.8-1.4-1.2-2.4-1.2Zm40.1-35.8c-.9 0-1.7.3-2.4 1-6.3 6-12.9 12.1-19.7 18.2-1.4 1.3-1.6 3.5-.3 4.9.7.8 1.6 1.2 2.6 1.2.8 0 1.7-.3 2.3-.9 6.9-6.1 13.5-12.2 19.8-18.3 1.4-1.3 1.4-3.6.1-4.9-.6-.9-1.5-1.2-2.4-1.2Zm37.3-38.6c-1 0-1.9.4-2.6 1.2-5.7 6.4-11.8 13-18.2 19.5-1.3 1.4-1.3 3.6.1 4.9.7.7 1.6 1 2.4 1 .9 0 1.8-.4 2.5-1.1 2.7-2.8 5.3-5.5 7.9-8.2l.1-.1.1-.1v-.1l.1-.1.1-.1.1-.1.1-.1c3.4-3.6 6.6-7.2 9.7-10.7 1.3-1.4 1.1-3.7-.3-4.9-.4-.7-1.2-1-2.1-1Zm33.1-42.1c-1.1 0-2.2.5-2.9 1.5-4.7 6.9-9.9 14.1-15.7 21.3-1.2 1.5-.9 3.7.6 4.9.6.5 1.4.8 2.2.8 1 0 2.1-.5 2.7-1.3 2-2.6 4-5.1 5.9-7.6 0 0 0-.1.1-.1 0 0 0-.1.1-.1 0 0 0-.1.1-.1.1-.1.1-.2.2-.3 0 0 0-.1.1-.1v-.5s0-.1.1-.1c0 0 0-.1.1-.1v-.2c0-.1.1-.1.1-.2s.1-.1.1-.2v-.2c0-.1.1-.1.1-.2v-.1s0-.1.1-.1v-.2c0-.1.1-.1.1-.2v-.5c.1-.1.2-.2.2-.3l.1-.1.1-.1.1-.1s0-.1.1-.1c1.9-2.6 3.7-5.2 5.4-7.7 1.1-1.6.7-3.8-.9-4.9 2.2-2.6 1.5-2.8.8-2.8Zm24.2-46.9c-1.5 0-2.9 1-3.3 2.5-2.3 7.3-5.7 15.2-10.1 23.6-.9 1.7-.3 3.8 1.5 4.7.5.3 1.1.4 1.6.4 1.3 0 2.5-.7 3.1-1.9 1.5-2.7 2.8-5.4 4-8.1 0-.1.1-.1.1-.2s.1-.1.1-.2.1-.1.1-.2.1-.1.1-.2.1-.1.1-.2V81.6c0-.1.1-.1.1-.2s.1-.1.1-.2.1-.1.1-.2.1-.1.1-.2c2-4.5 3.6-8.9 5-13.1.6-1.8-.4-3.8-2.3-4.4.3-.1-.1-.1-.4-.1Zm-5.6-47.5c-.9 0-1.7.3-2.4 1-1.4 1.3-1.5 3.5-.1 4.9 1.3 1.4 2.5 2.9 3.5 4.4 2.8 4.4 4.5 9.7 4.9 15.6.1 1.8 1.7 3.3 3.5 3.3h.2c1.9-.1 3.4-1.8 3.3-3.7l-.3-3.3v-1.6c0-.1 0-.2-.1-.2-.5-2.3-1.3-4.4-2.2-6.5 0-.1-.1-.1-.1-.2s-.1-.1-.1-.2l-.3-.6c0-.1-.1-.1-.1-.2s-.1-.1-.1-.2c0 0 0-.1-.1-.1 0-.1-.1-.1-.1-.2s-.1-.1-.1-.2v-.1s0-.1-.1-.1v-.2s0-.1-.1-.1c0 0 0-.1-.1-.1v-.7c-.4-.6-.8-1.2-1.2-1.7-.8-1.1-1.7-2.2-2.7-3.2-3.3-5.5-4.2-5.8-5.1-5.8Z"
            fill="#8FFDC6"
          />
        </svg>
      </div>
      <div className="object splash">
        <svg
          width={2140}
          height={1080}
          viewBox="0 0 2140 1080"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#a)">
            <path
              d="M2048.4 118.3S1866.5 138.9 1658 345c-54 55-40.2 103.2 39.4 61.6 79.2-41.2 234-110.6 437.3-96.6"
              fill="#F986E8"
            />
            <path
              d="M1960 251s-145-36-300 160c-21 5-56 9-28-38s206-199.6 315-227c109-26.8 13 105 13 105Z"
              fill="#FDAEE6"
            />
            <path
              d="M1701 402s221-143 336-144c111 6-46 55-46 55s-181 32-290 89Z"
              fill="#F64BD9"
            />
            <path
              d="M2048.4 118.3S1866.5 138.9 1658 345c-54 55-40.2 103.2 39.4 61.6 79.2-41.2 234-110.6 437.3-96.6"
              stroke="#000"
              strokeWidth={10}
              strokeMiterlimit={10}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1980 502.8s-224.5-38.5-562.3 281.3c-58.4 47.7-117.2 72.9-108.5 37.4 6.7-27.5 53.8-45.7 75.3-77.1 19-25.9-.5-30.4-30.5-31.4s-23.5-23.4-7.7-43.2c17.5-19.6 83.1-81.9 26.9-122.4-32.3-24.9-116.2-28.5-103.1-4.4 6.9 12.9 30.1 8.3 58 32.6 27.8 25.5 19.9 50.3-14.1 76.3s-102 108.8-52 178.9c39 49.2 88.7 36.6 176.3 7.3 89.3-30.5 193.7-84.2 313.7-56.7 112 26.9 187.6 115.5 220.3 199.5"
              fill="#F986E8"
            />
            <path
              d="M1391 732s-25 25-68 38-56 59-7 71c-7-11-6.4-35 21.8-54.5C1366 767 1390 748 1391 732ZM1354 862s66.3-26 170.1-75.5C1630.9 736.5 1785 658 1892 694c16 6 89 29 89 29l-16 188-19 24s-77-161-250-162c-38 1-113.4 11.5-235.7 58.2C1391.7 856.8 1354 862 1354 862Z"
              fill="#F54BD9"
            />
            <path
              d="M1270 538s59-3 84 33c16 26 21 46 14 68 16-19 46-67 16-87-28-19-104-27-114-14Z"
              fill="#FCADE5"
            />
            <path
              d="M1346 596s13.6 20.7-8.2 52.4C1316.2 678.6 1258 735 1274 837c-25-20-46.5-72.5-2.7-137.3 31.4-45.4 71.7-45.7 74.7-103.7Z"
              fill="#F54BD9"
            />
            <path
              d="M1333.9 685.9s-20.1 35.1 0 47.1c20.2 12 48.2 18.1 51.6 13.6 5.9-13.1 4.5-35.6-24.5-34.6s-35.2-11.3-27.1-26.1ZM1303 828s4.3 34 53.7 14c43.7-20 252.9-173.4 478.6-252.7C1920 564 1946 571.5 1946 571.5V503s-173 9-321.5 119.9C1495.5 699.1 1369 868 1303 828Z"
              fill="#FCADE5"
            />
            <path
              d="M1980 502.8s-224.5-38.5-562.3 281.3c-58.4 47.7-117.2 72.9-108.5 37.4 6.7-27.5 53.8-45.7 75.3-77.1 19-25.9-.5-30.4-30.5-31.4s-23.5-23.4-7.7-43.2c17.5-19.6 83.1-81.9 26.9-122.4-32.3-24.9-116.2-28.5-103.1-4.4 6.9 12.9 30.1 8.3 58 32.6 27.8 25.5 19.9 50.3-14.1 76.3s-102 108.8-52 178.9c39 49.2 88.7 36.6 176.3 7.3 89.3-30.5 193.7-84.2 313.7-56.7 112 26.9 187.6 115.5 220.3 199.5"
              stroke="#000"
              strokeWidth={10}
              strokeMiterlimit={10}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1834 935.5c0 53.3-54.8 96.5-122.5 96.5S1589 988.8 1589 935.5s54.8-96.5 122.5-96.5 122.5 43.2 122.5 96.5Z"
              fill="#F886E7"
            />
            <path
              d="M1604 959.5c0-53.3 54.8-96.5 122.5-96.5 42.2 0 79.3 16.8 101.4 42.3-16.1-38.5-62.1-66.3-116.4-66.3-67.7 0-122.5 43.2-122.5 96.5 0 20.1 7.8 38.7 21.1 54.2-3.9-9.5-6.1-19.7-6.1-30.2Z"
              fill="#FCADE5"
            />
            <path
              d="M1792.9 863.4c3.9 9.5 6.1 19.6 6.1 30.1 0 53.3-54.8 96.5-122.5 96.5-31.3 0-59.8-9.2-81.4-24.4 16.1 38.6 62.1 66.4 116.4 66.4 67.7 0 122.5-43.2 122.5-96.5 0-28.7-15.9-54.4-41.1-72.1Z"
              fill="#F64BD9"
            />
            <path
              d="M1711.5 1032c67.65 0 122.5-43.205 122.5-96.5s-54.85-96.5-122.5-96.5-122.5 43.205-122.5 96.5 54.85 96.5 122.5 96.5Z"
              stroke="#000"
              strokeWidth={10}
              strokeMiterlimit={10}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1200 780s-24 28-10 73c11 29 44 26 36-6s-9.7-33.8-7.8-54.9c1.6-21.2-11.2-23.1-18.2-12.1Z"
              fill="#F986E8"
            />
            <path
              d="M1226 847c-8-32-9.7-33.8-7.8-54.9.9-10.8-2.1-16.6-6-18.2.2 2.1.2 4.5 0 7.2-1.8 21.1-.2 22.9 7.8 54.9 6.9 27.5-16.5 33.6-30.2 16.4.1.2.1.4.2.6 11 29 44 26 36-6Z"
              fill="#F54BD9"
            />
            <path
              d="M1209 794c2.6-4.1 6.1-6.4 9.3-6.6-.5-16.7-11.8-17.5-18.3-7.4 0 0-24 28-10 73 2.2 5.9 5.4 10.5 8.9 13.8-13.8-44.9 10.1-72.8 10.1-72.8Z"
              fill="#FCADE5"
            />
            <path
              d="M1200 780s-24 28-10 73c11 29 44 26 36-6s-9.7-33.8-7.8-54.9c1.6-21.2-11.2-23.1-18.2-12.1Z"
              stroke="#000"
              strokeWidth={10}
              strokeMiterlimit={10}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1440.3 690.8c-1.8-1.2-3.8-2-5.8-2.5-6.6-1.7-24-4.6-22 9.8 1.3 11.3 13.9 15.5 23.2 13.9 6.1-1 10.6-6.4 10.2-12.6-.2-3.5-1.9-6.2-5.6-8.6Z"
              fill="#F986E8"
            />
            <path
              d="M1420.5 704.1c-2-14.5 15.3-11.5 22-9.8l2.1.6c-.9-1.5-2.3-2.9-4.2-4.2-1.8-1.2-3.8-2-5.9-2.5-6.6-1.7-24-4.6-22 9.8.8 6.4 5.2 10.6 10.5 12.6-1.3-1.7-2.2-3.9-2.5-6.5Z"
              fill="#FCADE5"
            />
            <path
              d="M1440.3 690.8c-1.8-1.2-3.8-2-5.8-2.5-6.6-1.7-24-4.6-22 9.8 1.3 11.3 13.9 15.5 23.2 13.9 6.1-1 10.6-6.4 10.2-12.6-.2-3.5-1.9-6.2-5.6-8.6Z"
              stroke="#000"
              strokeWidth={10}
              strokeMiterlimit={10}
            />
            <path
              d="M1414.7 665.5s-22.5 9.3-15.1-10.6c7.8-19.8 39.4-37.9 51.4-28.9s-18.6 32.9-36.3 39.5Z"
              fill="#F986E8"
            />
            <path
              d="M1408.6 660.9c6.6-16.9 30.6-32.5 44.9-31.2-.3-1.4-1.1-2.7-2.5-3.7-12-9-43.6 9.1-51.4 28.9-4.4 11.8 1.8 13.3 7.5 12.6.1-1.7.5-3.9 1.5-6.6Z"
              fill="#FCADE5"
            />
            <path
              d="M1414.7 665.5s-22.5 9.3-15.1-10.6c7.8-19.8 39.4-37.9 51.4-28.9s-18.6 32.9-36.3 39.5Z"
              stroke="#000"
              strokeWidth={10}
              strokeMiterlimit={10}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M0 0h2139.7v1080H0z" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="object ground">
        <svg
          width={2556}
          height={354}
          viewBox="0 0 2556 354"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            clipPath="url(#ground)"
            stroke="#5CC7FD"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M1281 1798c704.16 0 1275-395.33 1275-883 0-487.667-570.84-883-1275-883C576.837 32 6 427.333 6 915c0 487.67 570.837 883 1275 883Z" />
            <path d="M1281 1812c704.16 0 1275-395.33 1275-883 0-487.667-570.84-883-1275-883C576.837 46 6 441.333 6 929c0 487.67 570.837 883 1275 883Z" />
            <path d="M1281 1830c704.16 0 1275-395.33 1275-883 0-487.667-570.84-883-1275-883C576.837 64 6 459.333 6 947c0 487.67 570.837 883 1275 883Z" />
            <path d="M1281 1857c676 0 1224-395.33 1224-883 0-487.667-548-883-1224-883C605.003 91 57 486.333 57 974c0 487.67 548.003 883 1224 883Z" />
            <path d="M1281 1896c699.74 0 1267-395.33 1267-883 0-487.667-567.26-883-1267-883C581.255 130 14 525.333 14 1013c0 487.67 567.255 883 1267 883Z" />
            <path d="M1280 1974c682.62 0 1236-395.33 1236-883 0-487.667-553.38-883-1236-883C597.376 208 44 603.333 44 1091c0 487.67 553.376 883 1236 883Z" />
            <path d="M1261 32.1s-125.6 146.4-268.3 438.2M1126.8 37.9C1070.8 73.7 770 273.1 573 546M1009.4 52.1S668 189 392 491M1301 32.1s125.6 146.4 268.3 438.2M1435.1 37.9c56 35.8 356.8 235.2 553.8 508.1M1552.6 52.1S1894 189 2170 491" />
          </g>
          <defs>
            <clipPath id="ground">
              <path fill="#fff" d="M0 0h2556v354H0z" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="object cube">
        <svg
          width={99}
          height={115}
          viewBox="0 0 99 115"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 35 48 5l46 27v46.3L49.5 110 5 80.2V35Z" fill="#B0FEFE" />
          <path d="M48 8v42L5 80.2V35L48 8Z" fill="#39C7D8" />
          <path d="M48 8v42L5 80.2V35L48 8Z" fill="#39C7D8" />
          <path d="M50 8v42l43 30.2V35L50 8Z" fill="#8FFDC6" />
          <path
            d="M48 7v45.6L6 80M48 7v45.6L90 80"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 35 48 5l46 27v46.3L49.5 110 5 80.2V35Z"
            stroke="#000"
            strokeWidth={10}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="object elf animate__animated animate__slideInLeft">
        <img src="assets/images/hero/elf.png" alt="" />
      </div>
      <div className="countdown" id="countdown">


{/* {!wallet.connected && <CountDownFunc />} */}

 


{(wallet.connected && candyMachine?.state?.isActive === true) ? 

  <><ProgressBar available={candyMachine.state.itemsAvailable} redeemed={candyMachine.state.itemsRedeemed} /><MintContainer>
              {candyMachine?.state.isActive &&
                candyMachine?.state.gatekeeper &&
                wallet.publicKey &&
                wallet.signTransaction ? (
                <GatewayProvider
                  wallet={{
                    publicKey: wallet.publicKey ||
                      new PublicKey(CANDY_MACHINE_PROGRAM),
                    //@ts-ignore
                    signTransaction: wallet.signTransaction,
                  }}
                  gatekeeperNetwork={candyMachine?.state?.gatekeeper?.gatekeeperNetwork}
                  clusterUrl={rpcUrl}
                  options={{ autoShowModal: false }}
                >
                  <MintButton
                    candyMachine={candyMachine}
                    isMinting={isUserMinting}
                    onMint={onMint} />
                </GatewayProvider>
              ) : (
                <MintButton
                  candyMachine={candyMachine}
                  isMinting={isUserMinting}
                  onMint={onMint} />
              )}
            </MintContainer></>
            : 
        <MintCountdown
          candyMachine={candyMachine}
          isMinting={isUserMinting}
          onMint={onMint}

          date={toDate(
            candyMachine?.state.goLiveDate
              ? candyMachine?.state.goLiveDate
              : candyMachine?.state.isPresale
              ? new anchor.BN(new Date().getTime() / 1000)
              : undefined,
          )}
          style={{ justifyContent: 'flex-end' }}
          status={
            !candyMachine?.state?.isActive || candyMachine?.state?.isSoldOut
              ? 'COMPLETED'
              : candyMachine?.state.isPresale
              ? 'PRESALE'
              : 'LIVE'
          }
        />
}


      </div>
    </section>
    <section className="joinus">
      <div className="container">
        <div className="object wow animate__slideInUp">
          <img loading="lazy" src="assets/images/community.svg" alt="" />
        </div>
        <div className="joinbox wow animate__slideInUp">
          <a
            href={"https://discord.com/invite/goatelves"}
            className="discord"
            target="_blank"
            rel="noreferrer"
          >
            <div className="icon">
              <svg
                width={88}
                height={71}
                viewBox="0 0 88 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M68.813 11.7c-4.7-2.2-9.8-3.8-15.1-4.7-.6 1.2-1.4 2.7-1.9 4-5.6-.8-11.2-.8-16.7 0-.5-1.3-1.3-2.8-2-4-5.3.9-10.3 2.5-15.1 4.7-9.4 14.4-12 28.5-10.7 42.3 6.3 4.7 12.4 7.6 18.5 9.5 1.5-2 2.8-4.2 4-6.5-2.2-.8-4.3-1.8-6.2-3l1.5-1.2c12 5.6 25 5.6 36.9 0l1.5 1.2c-2 1.2-4.1 2.2-6.2 3 1.1 2.3 2.5 4.5 4 6.5 6-1.9 12.2-4.7 18.5-9.5 1.4-16-2.7-29.9-11-42.3Zm-37.4 33.8c-3.6 0-6.6-3.4-6.6-7.5s2.9-7.5 6.6-7.5c3.7 0 6.6 3.4 6.6 7.5-.1 4.1-3 7.5-6.6 7.5Zm24.2 0c-3.6 0-6.6-3.4-6.6-7.5s2.9-7.5 6.6-7.5c3.7 0 6.6 3.4 6.6 7.5s-2.9 7.5-6.6 7.5Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="fold" />
          </a>
          <span>
            <div className="text">
              <em>JOIN THE COMMUNITY</em>
            </div>
            <div className="fold" />
          </span>
          <a
            href={"https://twitter.com/goatelves"}
            className="twitter"
            target="_blank"
            rel="noreferrer"
          >
            <div className="icon">
              <svg
                width={88}
                height={71}
                viewBox="0 0 88 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.5 71c33 0 51-27.3 51-51 0-.8 0-1.5-.1-2.3 3.5-2.5 6.5-5.7 8.9-9.3-3.2 1.4-6.7 2.4-10.3 2.8 3.8-2.2 6.6-5.7 8-9.9-3.5 2.1-7.3 3.5-11.4 4.4-3.3-3.5-8-5.7-13.1-5.7-9.9 0-17.9 8-17.9 17.9 0 1.4.2 2.8.5 4.1-15-.7-28.2-7.9-37-18.7-1.5 2.6-2.4 5.7-2.4 9 0 6.2 3.2 11.7 8 14.9-2.9-.1-5.7-.9-8.1-2.2v.2c0 8.7 6.2 15.9 14.4 17.6-1.5.4-3.1.6-4.7.6-1.2 0-2.3-.1-3.4-.3 2.3 7.1 8.9 12.3 16.7 12.4-6.1 4.8-13.9 7.7-22.3 7.7-1.4 0-2.9-.1-4.3-.2 7.9 5 17.4 8 27.5 8Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="fold" />
          </a>
        </div>
      </div>
    </section>
    <section className="visualcharacters">
      <div className="container">
        <div className="carousel">
          <div className="item wow animate__fadeInUp">
            <img loading="lazy" data-lazy="assets/images/characters/1.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item wow animate__fadeInUp">
            <img loading="lazy" data-lazy="assets/images/characters/2.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item wow animate__fadeInUp">
            <img loading="lazy" data-lazy="assets/images/characters/3.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/4.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/5.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/6.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/7.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/8.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/9.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/10.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/11.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/12.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/13.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/14.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/15.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/16.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/17.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/18.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/19.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/20.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/21.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/22.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/23.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/24.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/25.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/26.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/27.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/28.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/29.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
          <div className="item">
            <img loading="lazy" data-lazy="assets/images/characters/30.png" alt="" />
            <img src="/assets/images/spinner.svg" className="ajax-loader" alt="" />
          </div>
        </div>
      </div>
    </section>
    <section className="instructions" id="instructions">
      <div className="container">
        <div className="object wallet wow animate__fadeInRight">
          <img src="assets/images/instructions_1.svg" alt="" />
        </div>
        <div className="object coin wow animate__slideInRight">
        <svg
      xmlns="http://www.w3.org/2000/svg"
      id="_x33_"
      x="0px"
      y="0px"
      viewBox="0 0 431 533"
      xmlSpace="preserve"
    >
      <style>
        {
          ".st1{fill:none;stroke:#000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st3{fill:#fff}"
        }
      </style>
      <switch>
        <g>
          <g id="nft">
            <path
              className="st1"
              d="M158.24 355.25L158.24 318 186.98 355.25 186.98 318"
            />
            <path
              className="st1"
              d="M201.98 355.25L201.98 336.63 201.98 318 223.81 318"
            />
            <path className="st1" d="M219 335.24L201.98 335.24" />
            <path className="st1" d="M235.18 318L246.93 318 258.68 318" />
            <path className="st1" d="M246.93 355.25L246.93 318" />
            <circle cx={207} cy={335} r={137} fill="#ffdd8f" />
            <circle className="st1" cx={207} cy={335} r={137} />
            <path
              className="st1"
              d="M181.48 425.5A94.17 94.17 0 00207 429c51.91 0 94-42.09 94-94 0-25.15-9.87-47.99-25.96-64.86M257.93 255.98C243.26 246.5 225.77 241 207 241c-51.91 0-94 42.09-94 94 0 33.17 17.18 62.33 43.13 79.06"
            />
            <path className="st1" d="M207 198L207 241" />
            <path className="st1" d="M111.08 237.19L138 267" />
            <path className="st1" d="M70 335L113 335" />
            <path className="st1" d="M138 403.06L109.66 431.4" />
            <path className="st1" d="M300.92 239.19L274 269" />
            <path className="st1" d="M343 337L302 337" />
            <path className="st1" d="M274 405.06L302.34 433.4" />
            <path className="st1" d="M207 429L207 470.3" />
            <path d="M197.03 336.75c1.76-.01 3.51 0 5.23.46.12.03.24.07.36.1 1.46.35 2.35 1.32 2.72 2.71.42 1.62.76 3.26 1.03 4.91.54 3.2.99 6.4 1.52 9.6.1.61.28 1.22.53 1.79.33.75.81.79 1.31.15.79-1.02 1.24-2.21 1.65-3.41.37-1.06.63-2.16 1-3.22.28-.81.67-1.59.97-2.39.73-1.93 1.44-3.87 2.17-5.81.17-.45.37-.9.58-1.33.6-1.2 1.59-1.74 2.91-1.79 1.89-.06 3.75.2 5.62.43.62.07 1.18.22 1.72.56.78.49 1.13 1.24 1.1 2.17-.08 2.1-.99 3.94-1.8 5.8-.82 1.88-1.79 3.69-2.68 5.54-1.53 3.16-3.08 6.3-4.55 9.48-1.11 2.41-2.08 4.89-3.2 7.3-.36.78-.95 1.47-1.52 2.13-.24.27-.7.48-1.07.48-2.68.03-5.36-.04-8.01-.44-1.22-.18-2.13-.78-2.58-2.03-.54-1.5-1.21-2.95-1.77-4.45-1.01-2.73-2.01-5.46-2.93-8.22-.95-2.85-1.85-5.71-2.68-8.6-.92-3.22-1.73-6.47-2.57-9.71-.24-.92.19-1.52 1.07-1.83 1.27-.43 2.57-.38 3.87-.38zM158.91 333.78c.37.02.76 0 1.12.08.9.2 1.53.78 1.74 1.67.38 1.69.73 3.4 1 5.12.26 1.67-.35 2.59-2 3.04-1.19.33-2.42.53-3.63.76-1.5.28-2.36 1.72-1.85 3.15.27.75.9 1.23 1.84 1.18.99-.06 1.98-.24 2.97-.42.83-.15 1.64-.39 2.47-.57 1.91-.41 3 .27 3.39 2.18.3 1.43.5 2.87.75 4.31.09.48.21.95.31 1.42.3 1.34-.17 2.2-1.51 2.5-1 .23-2.04.27-3.07.4-.39.05-.79.08-1.15.21-1.08.39-1.7 1.61-1.42 2.71.16.62.68 1.07 1.46 1.01 1.01-.07 2.02-.24 3.01-.42.95-.18 1.89-.44 2.84-.63.33-.07.69-.07 1.03-.04.41.03.71.23.81.66.44 1.91.89 3.81 1.32 5.72.07.32.08.65.1.98.07 1.42-.49 2.34-1.84 2.76-1.09.34-2.21.59-3.33.77-1.73.28-3.49.38-5.21.7-1.5.28-2.96.79-4.45 1.16-.84.21-1.69.34-2.56.15-1.03-.22-1.67-.82-1.8-1.85-.68-5.18-2.28-10.13-3.83-15.1-1.17-3.75-2.32-7.51-3.38-11.29-.68-2.4-1.1-4.86-1.23-7.36-.07-1.33.74-2.25 2.05-2.5 3.22-.61 6.42-1.28 9.64-1.88 1.46-.27 2.94-.44 4.41-.65-.01.02 0 .05 0 .07zM166.05 330.74c-5.9-.11-10.42-2.77-13.81-7.51a19.428 19.428 0 01-3.46-8.79c-.28-2.03-.49-4.08-.09-6.13.58-2.94 2.21-5.22 4.48-7.08 2.57-2.1 5.53-3.45 8.7-4.3 1.79-.48 3.64-.81 5.47-1.11 1.54-.26 2.67.68 2.94 2.41.2 1.27.25 2.56.4 3.83.07.65.17 1.31.31 1.95.18.82-.06 1.53-.76 2-.79.54-1.71.66-2.63.78-1.41.2-2.86.24-4.23.6-1.96.51-3.56 1.6-4.13 3.71-.39 1.46-.06 2.87.53 4.21.99 2.28 2.53 4.13 4.57 5.57.14.1.3.19.46.23.67.17 1.21-.34 1.04-1.01-.4-1.55-.85-3.08-1.22-4.63-.27-1.12-.5-2.27-.62-3.41-.16-1.47.59-2.47 2.03-2.76 1.66-.32 3.33-.67 5-.79 1.97-.14 2.78.57 3.13 2.52.34 1.88.59 3.78.93 5.66.37 2.05.79 4.09 1.2 6.13.25 1.26.48 2.53.25 3.82-.22 1.21-.88 2.12-2.01 2.54-1.01.38-2.1.6-3.17.82-1.75.37-3.49.8-5.31.74zM239.88 382.51c-1.71-.06-3.33-.56-4.93-1.11-2.19-.76-4.36-1.57-6.56-2.31-.78-.26-1.61-.41-2.42-.54-1.16-.18-2-1.1-2.08-2.33-.07-1.13.18-2.22.52-3.28.46-1.4.94-2.79 1.45-4.17.55-1.48.62-3.06.94-4.58.68-3.21 1.54-6.39 2.31-9.59.4-1.69.81-3.38 1.13-5.09.22-1.15.24-2.34.45-3.49.27-1.44.72-2.83 1.79-3.91.89-.91 1.99-1.29 3.22-1 3.95.94 7.9 1.87 11.65 3.46.53.22 1.05.5 1.54.8.68.41.98 1.18.79 1.95-.39 1.58-.78 3.16-1.22 4.73-.59 2.12-1.58 2.76-3.72 2.29-1.14-.25-2.26-.63-3.36-1.04-1.2-.45-2.04-.09-2.37 1.14-.09.35-.19.7-.26 1.05-.19.92.27 1.65 1.18 1.88 1.15.29 2.32.56 3.46.87.63.17 1.26.38 1.87.63 1.53.66 2.03 1.51 1.65 3.14-.49 2.14-1.09 4.25-1.68 6.36-.23.83-.99 1.24-1.92 1-1.01-.26-1.99-.66-2.98-1-.81-.28-1.63-.55-2.44-.84-.36-.13-.58 0-.69.35-.14.45-.3.89-.42 1.35-.28 1.08.09 1.91 1.07 2.45 1.05.58 2.22.75 3.38.96.62.11 1.24.2 1.85.34.82.18 1.31.71 1.2 1.54-.12.92-.39 1.83-.68 2.72-.3.92-.7 1.81-1.05 2.72-.11.29-.18.6-.24.91-.18 1.08-.71 1.58-1.81 1.67-.18-.01-.4-.03-.62-.03zM188.2 379.35c-3.18-.1-6.36-.17-9.54-.33-1.37-.07-2.75-.2-4.05-.74-.92-.38-1.39-1.09-1.42-1.99-.07-1.7-.07-3.42.04-5.12.2-2.99.5-5.97.78-8.95.12-1.29.26-2.59.41-3.88.23-1.92.34-3.84.28-5.77-.08-2.59-.14-5.18-.15-7.77 0-.71.16-1.43.32-2.13.32-1.45 1.36-2.24 2.73-2.45 1.37-.22 2.78-.22 4.17-.29 1.85-.08 3.69-.01 5.53.27 1.31.21 2.1.98 2.24 2.31.22 2.04.04 4.08-.19 6.1-.28 2.4-.59 4.79-.93 7.18-.32 2.22-.69 4.43-1.04 6.64-.21 1.3-.48 2.59-.62 3.9-.11 1.02.26 1.95 1.12 2.55.35.25.87.33 1.32.35 1.09.05 2.16.11 3.18.52 1.23.49 2.08 2.07 1.85 3.36-.24 1.37-.46 2.75-.63 4.13-.15 1.26-.96 2.06-2.24 2.08-1.05.02-2.1 0-3.15 0-.01.02-.01.03-.01.03zM261.04 332.77c.81.08 1.35.12 1.88.19 2.36.28 4.73.58 7.11.49.28-.01.56.01.85.01 1.18.02 1.71.92 1.21 1.99-.68 1.45-1.66 2.69-2.59 3.97-1.01 1.4-1.93 2.86-2.55 4.48-.43 1.12-.67 2.26-.49 3.45.06.38.18.76.28 1.13.66 2.3 1.99 4.24 3.32 6.18.84 1.22 1.6 2.51 2.29 3.83 1.2 2.31.77 4.43-.76 6.49-.96 1.29-1.71 2.73-2.49 4.14-1.08 1.93-2.24 3.75-4.4 4.65-.59.25-1.19.27-1.84.12-.97-.22-1.96-.44-2.95-.5-2.28-.12-4.57-.12-6.85-.22-.95-.04-1.78-.41-2.21-1.34-.06-.13-.02-.35.04-.5.59-1.43 1.83-2.32 2.86-3.38.7-.72 1.47-1.36 2.21-2.04 1.14-1.05 2.07-2.27 2.71-3.69.73-1.62.51-3.22-.19-4.78-.79-1.77-2.05-3.22-3.15-4.78-1.04-1.49-2.07-2.99-2.67-4.74-.59-1.74-.49-3.48-.06-5.24.53-2.19 1.6-4.11 2.91-5.91.5-.68.91-1.45 1.51-2.02 1.21-1.13 2.63-1.85 4.02-1.98zM250.35 324.21c-.05 1.87-.09 3.73-.15 5.6-.02.7-.05 1.41-.14 2.11-.13 1.03-1.15 2.12-2.36 2.09-2.16-.05-4.33.05-6.48-.34-.55-.1-1.12-.21-1.64-.41-1.12-.42-1.56-1.35-1.63-2.48-.04-.69-.03-1.38.04-2.07.44-3.9.87-7.8.79-11.73-.03-1.23-.04-2.49-.26-3.7-.23-1.31-1.18-2.05-2.46-2.36-1.19-.29-2.39-.27-3.6-.15-.28.03-.56-.02-.84-.05-.35-.04-.53-.27-.65-.59-.36-.95-.37-1.94-.33-2.93.06-1.58.2-3.16.29-4.74.02-.25.01-.5-.01-.75-.07-.85.38-1.33 1.24-1.33.78 0 1.57.05 2.35.02 3.32-.12 6.64-.3 9.97-.38 3.04-.08 6.09-.13 9.13-.06 1.46.03 2.95.2 4.34.75.21.08.46.27.54.47.17.43.36.91.33 1.35-.14 2.05-.32 4.1-.54 6.14-.05.48-.27.96-.49 1.4-.31.65-.9.95-1.59 1-.62.05-1.25.03-1.88.02-1.43-.01-2.61 1.07-3 2.45-.89 3.17-.89 6.41-.9 9.66 0 .33-.03.66-.05.99-.01.02-.01.02-.02.02zM205.97 313.11c-.03 2.45-.41 4.82-1.52 7.03-1.97 3.93-5.22 6.17-9.5 6.85-4.44.71-8.51-.31-12-3.17-3.59-2.94-5.05-6.87-4.86-11.42.24-5.85 4.08-10.33 9.94-11.71 3.83-.9 7.57-.6 11.1 1.17 4.61 2.29 6.85 6.1 6.84 11.25zm-10.5.35c0-.16.01-.31 0-.47-.12-1.99-1.27-3.41-3.02-3.77-2.37-.47-3.94.23-4.89 2.21-.65 1.34-.83 2.76-.5 4.22.36 1.58 1.18 2.79 2.85 3.16 1.73.38 3.21-.1 4.31-1.53.86-1.12 1.24-2.41 1.25-3.82zM204.74 332.96c.27-1.4.47-2.81.81-4.18.47-1.91 1.03-3.79 1.57-5.68.43-1.49.92-2.95 1.34-4.44.32-1.14.56-2.31.83-3.46.1-.41.22-.82.29-1.23.26-1.49.5-2.99.76-4.48.22-1.24.41-2.5.72-3.72.46-1.81 2.17-3.08 3.95-3.02 1.01.03 1.81.54 2.4 1.3.69.88 1.29 1.84 1.94 2.76.38.53.79 1.04 1.17 1.57.36.49.69 1.01 1.05 1.49.62.8 1.25 1.6 1.89 2.38.62.76 1.25 1.51 1.89 2.27.61.72 1.22 1.43 1.83 2.14.6.71 1.21 1.42 1.8 2.15.89 1.09 1.82 2.14 2.64 3.28 1.12 1.58 2.18 3.2 3.2 4.85.43.68.63 1.47.01 2.18-.19.23-.46.47-.74.53-1.99.48-4 .91-6 1.36-.98.22-1.86-.06-2.66-.62-1.28-.89-2.32-2-3.19-3.29-.39-.57-.76-1.15-1.17-1.71-.56-.75-1.6-1.04-2.55-.74-.72.22-1.2.93-1.28 1.85-.04.45-.1.9-.19 1.35-.26 1.3-.57 2.6-.8 3.91-.21 1.19-1.03 1.75-2.08 1.96-1.7.35-3.42.59-5.14.85-.9.14-1.81.2-2.71.32-.83.11-1.32-.24-1.44-1.06-.04-.28-.04-.56-.06-.84a.16.16 0 00-.08-.03zM142.42 309.82c-.31-.09-.64-.14-.94-.26-2.16-.89-3.86-2.33-5.31-4.15-1.36-1.7-2.31-3.57-2.93-5.64-.24-.81.02-1.49.73-1.95.1-.07.2-.15.28-.24.37-.36.66-.35 1.07-.04 1.51 1.14 3.1 2.05 5.11 1.92 1.2-.08 2.42-.05 3.62-.03.4.01.82.1 1.19.25 1.09.44 1.46 1.54.9 2.56-.95 1.73-1.63 3.56-1.95 5.51-.05.28-.13.55-.21.82-.23.89-.62 1.19-1.56 1.25zM266.5 306.38c-1.16.03-2.16-.52-2.25-1.72-.07-.97-.23-1.93-.33-2.89-.09-.81-.37-1.54-.8-2.23-.56-.89-.56-1.73.08-2.27.36-.3.82-.57 1.27-.64 1.19-.18 2.4-.3 3.6-.35 1.63-.07 3-.65 4.22-1.71a2.4 2.4 0 011.07-.53c1.08-.23 2.03.7 1.82 1.78-.77 3.89-2.64 7.11-5.87 9.47-.9.65-1.86 1.17-2.81 1.09zM263.63 320.41c-.01 2.58-1.65 4.28-4.1 4.27-2.48-.01-4.34-1.85-4.35-4.29 0-2.25 1.8-3.9 4.25-3.88 2.48 0 4.21 1.61 4.2 3.9zM186.21 332.69c-.04 1.44-.61 2.8-2.2 3.48-1.67.72-3.28.47-4.65-.72-1.25-1.09-1.57-2.52-1.14-4.11.28-1.03.97-1.74 1.93-2.17 1.42-.63 2.84-.59 4.21.13 1.28.67 1.87 1.76 1.85 3.39zM208.91 299.84c-.01 1.62-1.1 2.7-2.69 2.7-1.64-.01-2.87-1.21-2.85-2.8.02-1.42 1.2-2.46 2.78-2.46 1.65.01 2.77 1.05 2.76 2.56zM235.38 335.63c-.01 1.64-1.11 2.73-2.72 2.71-1.62-.02-2.83-1.22-2.81-2.79.01-1.44 1.21-2.49 2.82-2.47 1.61.02 2.72 1.05 2.71 2.55z" />
            <g>
              <path
                className="st3"
                d="M261.91 346.56c.03-2.33.56-4.24 1.52-6.01.56-1.02 1.24-2 1.98-2.9.64-.79 1.52-.86 2.18-.36.71.54.8 1.4.16 2.15-.82.96-1.5 2.01-2 3.17-1.13 2.6-1.24 5.15.32 7.65.31.5.58 1.04.78 1.6.29.79-.01 1.55-.69 1.89-.64.32-1.42.15-1.85-.55-.95-1.55-1.92-3.1-2.2-4.95-.09-.67-.15-1.32-.2-1.69zM203.39 312.81c.03 1.33-1.06 2.16-2.09 1.63-.58-.3-.84-.82-.9-1.45-.14-1.63-.59-3.17-1.42-4.58-.64-1.08-1.51-1.9-2.67-2.42-.39-.17-.8-.43-1.04-.76-.65-.88.05-2.17 1.17-2.13.58.02 1.2.22 1.73.5 1.85.96 3.1 2.51 3.96 4.38.71 1.53 1.13 3.17 1.26 4.83zM187.78 346.99c-.11 1.32-.26 3.21-.44 5.1-.04.37-.19.77-.4 1.08-.33.48-.84.72-1.44.56-.61-.16-1-.58-1.1-1.21-.05-.28-.04-.56-.02-.84.15-1.81.34-3.62.46-5.43.04-.6-.05-1.22-.16-1.81-.04-.21-.29-.44-.51-.56-.75-.41-1.12-1.02-.95-1.7.17-.72.84-1.18 1.7-1.11 1.23.1 1.98.84 2.45 1.93.46 1.09.44 2.26.41 3.99zM222.3 314.18c-.07.63-.46 1.21-1.01 1.42-.57.22-1.23.06-1.64-.49-.5-.68-.93-1.41-1.41-2.11-1.4-2.04-2.83-4.06-4.53-5.87-.64-.68-.68-1.43-.13-2.06.53-.61 1.43-.7 2.12-.1.6.52 1.15 1.11 1.62 1.75 1.54 2.11 3.04 4.25 4.54 6.39.2.32.29.72.44 1.07zM219.83 349.72c.21-.46.51-1.11.81-1.75.74-1.62 1.48-3.24 2.24-4.86.14-.29.3-.59.51-.84.46-.53 1.13-.66 1.7-.37.59.3.95.95.77 1.61-.19.67-.46 1.33-.75 1.97-.75 1.62-1.52 3.23-2.3 4.83-.14.29-.36.56-.6.78-.43.39-.94.5-1.48.25-.58-.27-.87-.75-.9-1.62zM204.76 344.92c-.01.85-.53 1.51-1.25 1.61-.71.1-1.41-.36-1.62-1.14-.31-1.12-.56-2.25-.85-3.37-.13-.5-.31-.99-.47-1.48-.29-.86-.17-1.53.37-1.99.81-.69 1.98-.4 2.34.71.56 1.76.98 3.56 1.46 5.34.03.13.02.26.02.32zM155.58 315.88c-.01-.79.49-1.42 1.24-1.55.68-.12 1.38.31 1.65 1.12.42 1.28 1.22 2.28 2.18 3.19.2.19.41.39.58.62.48.63.44 1.34-.08 1.88-.5.52-1.27.62-1.89.19-1.16-.8-2.03-1.86-2.75-3.05-.73-1.21-.92-1.77-.93-2.4zM139.48 303.31c-1.4-.05-2.7-.43-3.91-1.12-.8-.45-1.11-1.26-.78-1.94.39-.8 1.19-1.11 2.06-.71 1.07.49 2.16.79 3.36.73.81-.04 1.44.59 1.51 1.33.07.71-.44 1.37-1.22 1.56-.33.09-.67.11-1.02.15zM165.86 296.88c.65.01 1.2.24 1.66.68.99.94 1.45 2.14 1.55 3.48.05.64-.28 1.12-.84 1.41-.48.25-1.01.24-1.41-.14-.3-.29-.49-.7-.7-1.08-.08-.14-.07-.33-.12-.5-.13-.48-.34-.82-.92-.91-.63-.09-1.09-.74-1.1-1.36-.01-.65.48-1.27 1.18-1.47.23-.06.47-.07.7-.11zM256.73 304.36c-.25.93-.44 1.88-.75 2.79-.29.83-1.16 1.18-1.91.9-.71-.26-1.1-1.1-.85-1.91.3-.95.52-1.88.27-2.9-.18-.74.39-1.47 1.09-1.64.71-.18 1.47.25 1.75 1.01.07.17.12.36.15.54.06.39.1.78.14 1.16.04.03.08.04.11.05zM169.94 309.9c.8.02 1.44.46 1.88 1.18.56.9.87 1.91 1 2.96.15 1.18-.98 2.04-2 1.57-.5-.23-.77-.67-.94-1.17-.06-.18-.11-.36-.15-.54-.12-.6-.38-1.04-.97-1.33-.55-.27-.74-.95-.57-1.51.22-.69.89-1.16 1.75-1.16zM267.26 297.21c.6-.14 1.22-.24 1.81-.43 1.07-.34 1.86-.05 2.2.88.19.52-.02 1.27-.58 1.6-1.35.8-2.82 1.12-4.37.72-.85-.22-1.31-.98-1.18-1.68.15-.76.81-1.23 1.72-1.2.13 0 .25.01.38.02.01.03.01.06.02.09zM248.31 347.35c-.12.93-.14 1.82-.67 2.57-.4.57-.98.78-1.55.61-.57-.17-1.04-.78-1.05-1.42 0-.26.08-.52.1-.79.04-.42.12-.84.09-1.25-.06-.85.36-1.58 1.08-1.75.77-.18 1.62.34 1.85 1.16.09.3.11.61.15.87zM164.57 351.58c-.01 1.08-.56 1.75-1.26 1.85-.69.1-1.39-.38-1.6-1.1-.13-.45-.27-.9-.38-1.35-.2-.77.17-1.54.87-1.83.67-.28 1.47-.01 1.82.73.27.62.43 1.32.55 1.7zM245.33 361.94c-.14.37-.23.76-.42 1.08-.3.52-.92.76-1.46.63-.62-.16-.99-.57-1.13-1.19-.05-.23-.08-.46-.17-.68-.38-.98-.15-1.73.68-2.11.72-.34 1.72.08 2.11.93.18.41.25.87.39 1.34zM192.72 372.68c-.16.38-.25.81-.49 1.13-.61.83-1.8.69-2.31-.23-.19-.36-.36-.73-.55-1.08-.31-.59-.27-1.13.14-1.62a1.54 1.54 0 011.71-.44c.88.35 1.4 1.16 1.5 2.24zM160.42 337.37c-.01.54-.28 1.01-.84 1.28-.55.27-1.15.18-1.59-.3-.36-.4-.71-.84-.95-1.32-.27-.55-.07-1.15.37-1.53.49-.42 1.05-.49 1.61-.2.79.4 1.38 1.25 1.4 2.07zM165.13 364.32c0-.68.39-1.28.96-1.48.55-.2 1.14-.03 1.57.45.62.69.7 1.73.2 2.38-.54.69-1.42.77-2.06.16-.44-.42-.63-.96-.67-1.51zM240.81 376.75c-.75 0-1.5-.85-1.5-1.69 0-.83.65-1.51 1.43-1.5.8.01 1.52.78 1.53 1.62-.01.77-.75 1.57-1.46 1.57zM234.15 335.22c0 .73-.65 1.38-1.38 1.38-.73 0-1.39-.66-1.38-1.39 0-.71.64-1.35 1.36-1.36.73-.01 1.39.64 1.4 1.37zM184.14 331.33c0 .73-.67 1.39-1.39 1.38-.71-.01-1.35-.65-1.36-1.36-.01-.74.63-1.4 1.36-1.4.74-.01 1.39.65 1.39 1.38zM202.17 318.37c-.73-.01-1.38-.68-1.36-1.41.02-.71.66-1.35 1.38-1.35.73 0 1.4.66 1.39 1.38-.01.74-.68 1.39-1.41 1.38zM206.47 300.74c-.72 0-1.38-.66-1.38-1.39.01-.73.67-1.39 1.39-1.38.71.01 1.34.65 1.35 1.37.01.74-.63 1.39-1.36 1.4zM218.95 355.37c-.74.01-1.38-.62-1.39-1.37 0-.74.64-1.39 1.37-1.39.71 0 1.35.63 1.36 1.35.03.75-.59 1.4-1.34 1.41zM173.9 318.1c.01.74-.64 1.39-1.38 1.38-.73 0-1.39-.67-1.39-1.38 0-.7.65-1.34 1.36-1.36.75-.01 1.41.63 1.41 1.36zM223.07 319.48c-.74 0-1.38-.65-1.37-1.38.01-.74.66-1.37 1.4-1.36.73.01 1.34.63 1.35 1.36 0 .74-.64 1.38-1.38 1.38zM260 317.59c.74 0 1.39.64 1.39 1.38 0 .73-.65 1.37-1.39 1.37-.71 0-1.35-.64-1.36-1.35-.02-.74.62-1.4 1.36-1.4zM268.93 356.24c-.01.73-.62 1.35-1.35 1.36-.74 0-1.39-.63-1.39-1.37-.01-.73.65-1.39 1.38-1.39.74.01 1.37.65 1.36 1.4z"
              />
            </g>
          </g>
          <g id="_x33_">
            <path className="st1" d="M363.52 405L363.52 436.52" />
            <path className="st1" d="M363.52 470.48L363.52 502" />
            <path className="st1" d="M332 451.08L352.61 451.08" />
            <path className="st1" d="M378.08 451.08L398.69 451.08" />
          </g>
          <g id="_x32_">
            <path className="st1" d="M347.31 18L347.31 35.88" />
            <path className="st1" d="M347.31 55.12L347.31 73" />
            <path className="st1" d="M327.44 45.12L339.12 45.12" />
            <path className="st1" d="M355.56 45.12L367.25 45.12" />
          </g>
          <g id="_x31_">
            <path className="st1" d="M58 170L58 196" />
            <path className="st1" d="M58 224L58 250" />
            <path className="st1" d="M32 208L49 208" />
            <path className="st1" d="M70 208L87 208" />
          </g>
        </g>
      </switch>
    </svg>
        </div>
        <div className="sect-title">
          <span className="text">
            <em>`INSTRUCTIONS´</em>
          </span>
          <div className="fold" />
        </div>
        <div className="accordion">
          <dl>
            <dt>
              <a
                href={"#accordion1"}
                aria-expanded="false"
                aria-controls="accordion1"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 130 130"
                    xmlSpace="preserve"
                  >
                    <switch>
                      <g>
                        <circle
                          cx="64.79"
                          cy="65.15"
                          r={52}
                          style={{ fill: "#98dcfd" }}
                        />
                        <circle
                          cx="64.79"
                          cy="65.15"
                          r="53.5"
                          style={{
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: 10,
                            strokeMiterlimit: 10
                          }}
                        />
                        <circle
                          transform="rotate(-45.001 64.787 65.15)"
                          cx="64.79"
                          cy="65.15"
                          style={{
                            fill: "none",
                            stroke: "#8ffec6",
                            strokeWidth: 8,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeDasharray: "23.754,23.754"
                          }}
                          r="60.5"
                        />
                        <circle
                          cx="107.12"
                          cy="22.96"
                          r="18.95"
                          style={{ fill: "currentColor" }}
                        />
                        <circle
                          cx="106.8"
                          cy="23.65"
                          r="19.5"
                          style={{
                            fill: "none",
                            stroke: "#5cc7fd",
                            strokeWidth: 7,
                            strokeMiterlimit: 10
                          }}
                        />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">BUY SOL FROM AN EXCHANGE</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordion1"
              aria-hidden="true"
            >
              <p>
                Buy <b>SOL (Solana)</b> from your favorite crypto exchange. If you
                plan on converting another crypto into SOL, the easiest way is using an exchange. Here are a few suggestions:
                <br />
                <br />
                <b>USA BUYERS : Binance.us, Coinbase, FTX.us, Gate.io, Kraken</b>
                <br />
                <b>GLOBAL BUYERS : Binance, Bitfinex, FTX, Gate.io, Huobi</b>
              </p>
            </dd>
            <dt>
              <a
                href={"#accordion2"}
                aria-expanded="false"
                aria-controls="accordion2"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 130 130"
                    xmlSpace="preserve"
                  >
                    <switch>
                      <g>
                        <circle
                          cx="64.79"
                          cy="65.15"
                          r={52}
                          style={{ fill: "#8affcd" }}
                        />
                        <circle
                          cx="64.79"
                          cy="65.15"
                          r="53.5"
                          style={{
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: 10,
                            strokeMiterlimit: 10
                          }}
                        />
                        <circle
                          transform="rotate(-45.001 64.787 65.15)"
                          cx="64.79"
                          cy="65.15"
                          style={{
                            fill: "none",
                            stroke: "#6d53ff",
                            strokeWidth: 8,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeDasharray: "23.754,23.754"
                          }}
                          r="60.5"
                        />
                        <circle
                          cx="107.12"
                          cy="22.96"
                          r="18.95"
                          style={{ fill: "currentColor" }}
                        />
                        <circle
                          cx="106.8"
                          cy="23.65"
                          r="19.5"
                          style={{
                            fill: "none",
                            stroke: "#8affcd",
                            strokeWidth: 7,
                            strokeMiterlimit: 10
                          }}
                        />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">DOWNLOAD AND INSTALL A SOL WALLET</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordion2"
              aria-hidden="true"
            >
              <p>
                Download a Solana wallet.
                <br />
                <br />
                <b>For Desktop, use Phantom</b> on your browser.
                <br />
                <b>For mobile, use Solflare.</b>
              </p>
            </dd>
            <dt>
              <a
                href={"#accordion3"}
                aria-expanded="false"
                aria-controls="accordion3"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 130 130"
                    xmlSpace="preserve"
                  >
                    <switch>
                      <g>
                        <circle
                          cx="64.79"
                          cy="65.15"
                          r={52}
                          style={{ fill: "#ffffb4" }}
                        />
                        <circle
                          cx="64.79"
                          cy="65.15"
                          r="53.5"
                          style={{
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: 10,
                            strokeMiterlimit: 10
                          }}
                        />
                        <circle
                          transform="rotate(-45.001 64.787 65.15)"
                          cx="64.79"
                          cy="65.15"
                          style={{
                            fill: "none",
                            stroke: "#ffffb4",
                            strokeWidth: 8,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeDasharray: "23.754,23.754"
                          }}
                          r="60.5"
                        />
                        <circle
                          cx="107.12"
                          cy="22.96"
                          r="18.95"
                          style={{ fill: "currentColor" }}
                        />
                        <circle
                          cx="106.8"
                          cy="23.65"
                          r="19.5"
                          style={{
                            fill: "none",
                            stroke: "#ffdd8f",
                            strokeWidth: 7,
                            strokeMiterlimit: 10
                          }}
                        />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">TRANSFER FROM EXCHANGE TO WALLET</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordion3"
              aria-hidden="true"
            >
              <p>
                Transfer funds from your exchange to your wallet. Always transfer
                a bit more than what you plan on spending to pay for gas. Solana
                is practically free but there is still a small gas fee.
                <br />
                <br />
                We recommend you transfer an additional <b>
                  +0.05 SOL per NFT
                </b>{" "}
                to pay for minting fees. Yes, they are that low on Solana.
              </p>
            </dd>
            <dt>
              <a
                href={"#accordion4"}
                aria-expanded="false"
                aria-controls="accordion4"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 130 130"
                    xmlSpace="preserve"
                  >
                    <switch>
                      <g>
                        <circle
                          cx="64.79"
                          cy="65.15"
                          r={52}
                          style={{ fill: "#ffccff" }}
                        />
                        <circle
                          cx="64.79"
                          cy="65.15"
                          r="53.5"
                          style={{
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: 10,
                            strokeMiterlimit: 10
                          }}
                        />
                        <circle
                          transform="rotate(-45.001 64.787 65.15)"
                          cx="64.79"
                          cy="65.15"
                          style={{
                            fill: "none",
                            stroke: "#8bffc5",
                            strokeWidth: 8,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeDasharray: "23.754,23.754"
                          }}
                          r="60.5"
                        />
                        <circle
                          cx="107.12"
                          cy="22.96"
                          r="18.95"
                          style={{ fill: "currentColor" }}
                        />
                        <circle
                          cx="106.8"
                          cy="23.65"
                          r="19.5"
                          style={{
                            fill: "none",
                            stroke: "#ff9ec5",
                            strokeWidth: 7,
                            strokeMiterlimit: 10
                          }}
                        />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">MINT YOUR G.O.A.T ELVES</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordion4"
              aria-hidden="true"
            >
              <p>
                <b>On April 24th 2022, 7 P.M UTC</b>, come to our website and
                mint your own G.O.A.T. Elves.
                <br />
                There will be a MINT button clearly visible on the home page — you
                won’t miss it.
                <br />
                <br />
                To find when it will be available for your timezone, go to this page and enter your city:
                <br />
                <a href={"https://savvytime.com/converter/utc/apr-24-2022/7pm"} target={"_blank"} rel="noreferrer">
                  <i>https://savvytime.com/converter/utc/apr-24-2022/7pm</i>
                </a>
                <br />
                <br />
                <b>
                  Important: the only place to mint is on our website (bookmark it
                  now).
                </b>
              </p>
            </dd>
          </dl>
        </div>
      </div>
    </section>
    <section className="goat-roadmap" id="roadmap">
      <div className="object coin wow animate__slideInUp">
        <img src="assets/images/roadmap/goat_roadmap_3.svg" alt="" />
      </div>
      <div className="container">
        <div className="object goathead wow animate__fadeInLeft">
          <img src="assets/images/roadmap/goat_roadmap_1.svg" alt="" />
        </div>
        <div className="sect-title">
          <span className="text">
            <em>`G.O.A.T ROADMAP´</em>
          </span>
          <div className="fold" />
        </div>
        {/* section objects */}
        <div className="object flowers wow animate__fadeInRight">
          <img src="assets/images/roadmap/goat_roadmap_2.svg" alt="" />
        </div>
        <div className="object eye wow animate__fadeInLeft">
          <img src="assets/images/roadmap/goat_roadmap_4.svg" alt="" />
        </div>
        <div className="object squares wow animate__fadeInLeft">
          <img src="assets/images/roadmap/goat_roadmap_5.svg" alt="" />
        </div>
        <div className="object prismasquare wow animate__fadeInRight">
          <img src="assets/images/roadmap/goat_roadmap_6.svg" alt="" />
        </div>
        <div className="object planet wow animate__fadeInUp">
          <img src="assets/images/roadmap/goat_roadmap_7.svg" alt="" />
        </div>
        <div className="object gamepad wow animate__fadeInDown">
          <img src="assets/images/roadmap/goat_roadmap_8-2.svg" alt="" />
        </div>
        
        {/* #region timeline */}
        <div className="timeline">
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>FOCUS ON ART QUALITY</h4>
              <p>
                NFTs are immutable and forever. We only have one chance to do it
                right, so we obsess over quality and review all details to ensure
                the perfect mint of all 9,999 G.O.A.T. Elves of course. To create
                an ecosystem for the NFT market.
              </p>
              <div className="number">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 173.63 171.52"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.385 91.133)"
                        cx="80.39"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm1"
                        gradientUnits="userSpaceOnUse"
                        x1="-602.424"
                        y1="-555.955"
                        x2="-487.511"
                        y2="-555.955"
                        gradientTransform="rotate(90 -535.387 81.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="102.16"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm1)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="102.63"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="148.94"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="148.58"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>GROWING THE COMMUNITY</h4>
              <p>
                G.O.A.T. Elves team will work strategically to grow the community
                and spread awareness. Events, Partnerships and giveaways will be
                organized.
              </p>
              <div className="number number-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160.8 171.53"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.398 91.133)"
                        cx="80.4"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm2"
                        gradientUnits="userSpaceOnUse"
                        x1="-2443.412"
                        y1="-1824.955"
                        x2="-2328.499"
                        y2="-1824.955"
                        gradientTransform="rotate(90 -2107.375 350.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="68.17"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm2)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="68.64"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="114.95"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="114.6"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>SUCCESSFULL LAUNCH</h4>
              <p>
                We are working hard to ensure a smooth mint. There are no
                whitelists or pre-sales, giving everyone the same chances. Take
                notice: Our website is the only place to mint!
              </p>
              <div className="number">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 173.63 171.52"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.385 91.133)"
                        cx="80.39"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm3"
                        gradientUnits="userSpaceOnUse"
                        x1="-602.424"
                        y1="-555.955"
                        x2="-487.511"
                        y2="-555.955"
                        gradientTransform="rotate(90 -535.387 81.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="102.16"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm3)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="102.63"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="148.94"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="148.58"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>MARKETPLACE LISTINGS</h4>
              <p>
                We wanted to list on <b>ALL Solana Marketplaces</b>, including but
                not limited to&nbsp;
                <b>
                  Solanart, Magic Eden, SolSea, FTX, Alpha Art, Digital Eyes, etc.
                </b>
              </p>
              <div className="number number-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160.8 171.53"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.398 91.133)"
                        cx="80.4"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm2"
                        gradientUnits="userSpaceOnUse"
                        x1="-2443.412"
                        y1="-1824.955"
                        x2="-2328.499"
                        y2="-1824.955"
                        gradientTransform="rotate(90 -2107.375 350.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="68.17"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm2)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="68.64"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="114.95"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="114.6"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="object vr wow animate__fadeInRight">
              <img loading="lazy" src="assets/images/roadmap/goat_roadmap_9.png" alt="" />
            </div>
            <div className="timeline-card">
              <h4>3D METAVERSE project, “The G.O.A.T.VERSE”</h4>
              <p>
                3D characters will be produced for <b>“The G.O.A.T.VERSE”</b>.
                This project will be released following to G.O.A.T ELVES. Anyone who mints a G.O.A.T ELVES will be whitelisted in the 3D project.
              </p>
              <div className="number">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 173.63 171.52"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.385 91.133)"
                        cx="80.39"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm5"
                        gradientUnits="userSpaceOnUse"
                        x1="-602.424"
                        y1="-555.955"
                        x2="-487.511"
                        y2="-555.955"
                        gradientTransform="rotate(90 -535.387 81.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="102.16"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm5)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="102.63"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="148.94"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="148.58"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>SWEEP THE FLOOR INITIATIVE</h4>
              <p>
                In this buy-back process, we will use our Treasury to buy any
                G.O.A.T. ELVES sold below mint price on any secondary marketplace.
                The price on mint day will be the cheapest one.
              </p>
              <div className="number number-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160.8 171.53"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.398 91.133)"
                        cx="80.4"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm2"
                        gradientUnits="userSpaceOnUse"
                        x1="-2443.412"
                        y1="-1824.955"
                        x2="-2328.499"
                        y2="-1824.955"
                        gradientTransform="rotate(90 -2107.375 350.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="68.17"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm2)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="68.64"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="114.95"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="114.6"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>RELEASE OF RARITY TABLE</h4>
              <p>
                We worked hard on the rarity table to ensure correct distrubution of
                rare traits. We also have a more granular rarity compared to other
                projects. This is because of the quality and quantity of beautiful
                traits we created
                <br /> — over 200.
              </p>
              <div className="number number-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160.8 171.53"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.398 91.133)"
                        cx="80.4"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm2"
                        gradientUnits="userSpaceOnUse"
                        x1="-2443.412"
                        y1="-1824.955"
                        x2="-2328.499"
                        y2="-1824.955"
                        gradientTransform="rotate(90 -2107.375 350.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="68.17"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm2)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="68.64"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="114.95"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="114.6"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>AIRDROP OF OUR HOLDLERS!</h4>
              <p>
                For those who buy goat elves and keep them in their wallet, we
                will{" "}
                <b>Airdrop our next 3D METAVERSE project, “The G.O.A.T.VERSE”.</b>
              </p>
              <div className="number number-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160.8 171.53"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.398 91.133)"
                        cx="80.4"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm2"
                        gradientUnits="userSpaceOnUse"
                        x1="-2443.412"
                        y1="-1824.955"
                        x2="-2328.499"
                        y2="-1824.955"
                        gradientTransform="rotate(90 -2107.375 350.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="68.17"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm2)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="68.64"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="114.95"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="114.6"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>
                EARLY INVESTMENT OPPORTUNITIES FOR NEXT 3D METAVERSE project, “The
                G.O.A.T.VERSE”
              </h4>
              <p>
                <b>G.O.A.T Club</b> members will have access to early investment
                in our next <b>3D METAVERSE project, “The G.O.A.T.VERSE”</b>{" "}
                getting started. Discussions will happen in exclusive channels
                where proof of ownership is required to join.
              </p>
              <div className="number number-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160.8 171.53"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.398 91.133)"
                        cx="80.4"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm2"
                        gradientUnits="userSpaceOnUse"
                        x1="-2443.412"
                        y1="-1824.955"
                        x2="-2328.499"
                        y2="-1824.955"
                        gradientTransform="rotate(90 -2107.375 350.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="68.17"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm2)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="68.64"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="114.95"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="114.6"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>G.O.A.T. ELVES AROUND THE WORLD</h4>
              <p>
                Our Treasury will sponsor small events around the world for the
                NFT holders. Likely an excellent ROI for everyone as the publicity
                will increase demand for G.O.A.T. Elves on marketplaces attracting
                even more investors.
              </p>
              <div className="number number-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160.8 171.53"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.398 91.133)"
                        cx="80.4"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm2"
                        gradientUnits="userSpaceOnUse"
                        x1="-2443.412"
                        y1="-1824.955"
                        x2="-2328.499"
                        y2="-1824.955"
                        gradientTransform="rotate(90 -2107.375 350.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="68.17"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm2)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="68.64"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="114.95"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="114.6"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>PLAY-TO-EARN (P2E) GAME</h4>
              <p>
                We will create a P2E NFT game which you will be able to use your
                G.O.A.T Elves in it.
              </p>
              <div className="number number-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160.8 171.53"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.398 91.133)"
                        cx="80.4"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm2"
                        gradientUnits="userSpaceOnUse"
                        x1="-2443.412"
                        y1="-1824.955"
                        x2="-2328.499"
                        y2="-1824.955"
                        gradientTransform="rotate(90 -2107.375 350.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="68.17"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm2)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="68.64"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="114.95"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="114.6"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-card">
              <h4>SPECIAL IN-GAME ABILITIES</h4>
              <p>
                They will gain in-game advantages based on the items that your
                G.O.A.T. Elves wear and carry.
              </p>
              <div className="number number-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160.8 171.53"
                  xmlSpace="preserve"
                >
                  <switch>
                    <g>
                      <circle
                        transform="rotate(-45.001 80.398 91.133)"
                        cx="80.4"
                        cy="91.13"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 8,
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeDasharray: "23.9957,23.9957"
                        }}
                        r="76.38"
                      />
                      <linearGradient
                        id="tm2"
                        gradientUnits="userSpaceOnUse"
                        x1="-2443.412"
                        y1="-1824.955"
                        x2="-2328.499"
                        y2="-1824.955"
                        gradientTransform="rotate(90 -2107.375 350.59)"
                      >
                        <stop offset={0} style={{ stopColor: "#89ffc7" }} />
                        <stop offset=".263" style={{ stopColor: "#82ffd0" }} />
                        <stop offset=".7" style={{ stopColor: "#70ffea" }} />
                        <stop offset=".926" style={{ stopColor: "#64fffa" }} />
                      </linearGradient>
                      <circle
                        cx="68.17"
                        cy="72.01"
                        r="57.46"
                        style={{
                          fill: "url(#tm2)",
                          stroke: "url(#SVGID_2_)",
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="68.64"
                        cy="72.46"
                        r="59.11"
                        style={{
                          fill: "none",
                          stroke: "#9c8aff",
                          strokeWidth: 10,
                          strokeMiterlimit: 10
                        }}
                      />
                      <circle
                        cx="114.95"
                        cy="25.4"
                        r="20.94"
                        style={{ fill: "#9c8aff" }}
                      />
                      <circle
                        cx="114.6"
                        cy="25.05"
                        r="21.55"
                        style={{
                          fill: "none",
                          stroke: "#89ffc7",
                          strokeWidth: 7,
                          strokeMiterlimit: 10
                        }}
                      />
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
          </div>
        </div>
        {/* #endregion timeline */}
        <a
          href={"https://discord.com/invite/goatelves"}
          target="_blank"
          rel="noreferrer"
          className="contact-cta wow animate__fadeInUp"
        >
          <span className="text">
            <em>`CONTACT US AND STAY IN G.O.A.T!´</em>
          </span>
          <div className="fold" />
        </a>
      </div>
    </section>
    <section className="team" id="team">
      <div className="container">
        <div className="object brain wow animate__fadeInLeft">
          <img src="assets/images/goat_team.svg" alt="" />
        </div>
        <div className="sect-title">
          <span className="text">
            <em>`G.O.A.T TEAM´</em>
          </span>
          <div className="fold" />
        </div>
        <div className="team-images">
          <div className="team-item wow animate__fadeInUp">
            <img loading="lazy" src="assets/images/characters/team/1.png" alt="" />
            <h3>ALINA_BEE</h3>
            <p>Project Manager</p>
          </div>
          <div className="team-item wow animate__fadeInUp">
            <img loading="lazy" src="assets/images/characters/team/2.png" alt="" />
            <h3>APHEXQUEEN</h3>
            <p>Concept Creation &amp; Art Lead</p>
          </div>
          <div className="team-item wow animate__fadeInUp">
            <img loading="lazy" src="assets/images/characters/team/3.png" alt="" />
            <h3>OXGR</h3>
            <p>Smart Contract &amp; Minting Supporter</p>
          </div>
          <div className="team-item wow animate__fadeInUp">
            <img loading="lazy" src="assets/images/characters/team/4.png" alt="" />
            <h3>ELF_DA_SHELF</h3>
            <p>Community &amp; Marketing Manager</p>
          </div>
          <div className="team-item wow animate__fadeInUp">
            <img loading="lazy" src="assets/images/characters/team/5.png" alt="" />
            <h3>ELF_BUGG</h3>
            <p>Web Developer</p>
          </div>
          {/* <div className="team-item wow animate__fadeInUp">
            <img loading="lazy" src="assets/images/characters/4.png" alt="" />
            <h3>GOD FATHER</h3>
            <p>Investor</p>
          </div> */}
        </div>
      </div>
    </section>
    <section className="instructions token" id="token">
      <div className="container">
        <div className="object wallet wow animate__fadeInRight">
          <img src="assets/images/token_1.svg" alt="" />
        </div>
         
        <div className="sect-title">
          <span className="text">
            <em>`G.O.A.T. ELF TOKEN´</em>
          </span>
          <div className="fold" />
        </div>
        <div className="accordion">
          <dl>
            <dt>
              <a
                href={"#accordion1_goat"}
                aria-expanded="false"
                aria-controls="accordion1_goat"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .token .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#c8acff" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#c8acff" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">WHAT IS THE G.O.A.T. ELF TOKEN</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordion1_goat"
              aria-hidden="true"
            >
              <p>
                <b>GOAT ELF TOKEN (GOATET)</b> is a Solana governance token inside <b>the G.O.A.T.VERSE.</b><br />
                Players will be able to earn <b>$GOATET</b> by playing games within <b>the G.O.A.T.VERSE.</b>
              </p>
            </dd>
            <dt>
              <a
                href={"#accordion2_goat"}
                aria-expanded="false"
                aria-controls="accordion2_goat"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .token .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#aeffff" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#aeffff" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">HOW DO I GET G.O.A.T. ELF TOKEN?</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordion2_goat"
              aria-hidden="true"
            >
              <p>
                At first, G.O.A.T. Elves will be airdropped to <b>NFT holdlers</b>. More will be earned as a reward from staking and also competitions, missions and events in our <b>Play-to-Earn (P2E) game.</b>
              </p>
            </dd>
            <dt>
              <a
                href={"#accordion3_goat"}
                aria-expanded="false"
                aria-controls="accordion3_goat"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .token .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#ffffb4" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#ffffb4" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">HOW CAN I SPEND MY G.O.A.T ELF TOKENS?</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordion3_goat"
              aria-hidden="true"
            >
              <p>
                You can benefit from stake rewards (many options), and you can also use them in your character development. In the project, there will be more opportunities for you to spend your token, sales pressure (very important for us) will be reduced. A sustainable and permanent system will be created.
              </p>
            </dd>
            <dt>
              <a
                href={"#accordion4_goat"}
                aria-expanded="false"
                aria-controls="accordion4_goat"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .token .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#ffccff" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#ffccff" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">WHERE CAN I SWAP OTHER TOKENS?</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordion4_goat"
              aria-hidden="true"
            >
              <p>
                Liquidity pools will be created on <b>Raydium</b> and <b>Saber</b>, swapping will occur mostly on these two platforms.
              </p>
            </dd>
            <dt>
              <a
                href={"#accordion5_goat"}
                aria-expanded="false"
                aria-controls="accordion5_goat"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .token .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#c8acff" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#c8acff" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">HOW TO STORE G.O.A.T. ELF TOKEN?</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordion5_goat"
              aria-hidden="true"
            >
              <p>
                It will be a token on the <b>Solana network</b>, so any Solana wallet will do the trick.
              </p>
            </dd>
          </dl>
        </div>
      </div>
    </section>
    <section className="faqs" id="faqs">
      <div className="container">
        <div className="object goathead wow animate__fadeInLeft">
          <img src="assets/images/faqs.svg" alt="" />
        </div>
        <div className="sect-title">
          <span className="text">
            <em>`FAQ'S´</em>
          </span>
          <div className="fold" />
        </div>
        <div className="accordion">
          <dl>
            <dt>
              <a
                href={"#accordionfaq1"}
                aria-expanded="false"
                aria-controls="accordionfaq1"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .faqs .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#ffb7a7" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#ffb7a7" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">WHEN IS THE MINT DAY?</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordionfaq1"
              aria-hidden="true"
            >
              <p>
                <b>On April 24th 2022, 7 P.M UTC</b> Know the exact time in your city,
                go to this page and enter your city;
                <br />{" "}
                <a href={"https://savvytime.com/converter/utc/apr-24-2022/7pm"} target={"_blank"} rel="noreferrer">
                  <b>
                    <i>https://savvytime.com/converter/utc/apr-24-2022/7pm</i>
                  </b>
                </a>
              </p>
            </dd>

            <dt>
              <a
                href={"#accordionfaq2"}
                aria-expanded="false"
                aria-controls="accordionfaq2"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .faqs .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#ffffb4" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#ffffb4" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">WHAT WILL BE THE PRICE?</span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordionfaq2"
              aria-hidden="true"
            >

              {/* <p>
                Each cards will cost <b><Price candyMachine={candyMachine} /></b>.<br />
                <b>
                  <i>
                    -Check HOW TO MINT for more information on the entire process
                    of minting.
                  </i>
                </b>
              </p> */}

              <p>
                The price is 0.69 Sol, however we will organize a questionnaire that will continue for one month from discord. <b>We will determine the price together with you again! 
                Also, don't forget to join our discord and G.O.A.T ELVES community.</b> You'll receive many advantages from there (such as giveaways, competitions and so on).
                <br/><br/>
                <a href='https://discord.com/invite/goatelves' target={"_blank"} rel="noreferrer"><b>discord.gg/goatelves</b></a>
              </p>
              
              {/* <p>
              We have prepared a survey for you. Join the Discord and fill out the survey.
              <br />
              The price will be determined based on the survey results.
                <br /><br />
                <a href='https://discord.com/invite/goatelves' target={"_blank"} rel="noreferrer"><b>Click to join the Discord</b></a>
              </p>  */}

            </dd>
            <dt>
              <a
                href={"#accordionfaq3"}
                aria-expanded="false"
                aria-controls="accordionfaq3"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .faqs .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#aeffff" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#aeffff" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">
                  HOW MANY G.O.A.T ELVES WILL BE RELEASE?
                </span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordionfaq3"
              aria-hidden="true"
            >
              <p>
                There will only be <b>10,000 G.O.A.T. Elves.</b> Each one will be
                truly unique and exclusive and you will own all the rights to it.
                Owning a G.O.A.T. Elves will come with several benefits, such as
                using one in <b>The G.O.A.T.VERSE</b> and in the own{" "}
                <b>P2E game</b> and finally accessing our prestigious{" "}
                <b>G.O.A.T.Club.</b> Read more about it in G.O.A.T Roadmap.
              </p>
            </dd>
            <dt>
              <a
                href={"#accordionfaq4"}
                aria-expanded="false"
                aria-controls="accordionfaq4"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .faqs .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#96dcff" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#96dcff" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">
                  HOW MANY TRAITS DO G.O.A.T ELVES HAVE?
                </span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordionfaq4"
              aria-hidden="true"
            >
              <p>
                Our G.O.A.T Elves have a total of <b>400 possible traits</b> with{" "}
                <b>17 total different categories</b> (background, wing, body,
                tattoo, cloth, necklace, earring, eye, eyebrow, eyewear, mouth,
                mouthwear, mustache, hat and handfan). To say that G.O.A.T. Elves
                will be completely unique is an understatement.
              </p>
            </dd>
            <dt>
              <a
                href={"#accordionfaq5"}
                aria-expanded="false"
                aria-controls="accordionfaq5"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .faqs .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#c8acff" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#c8acff" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">
                  ARE THERE SECONDARY SALE ROYALITIES?
                </span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordionfaq5"
              aria-hidden="true"
            >
              <p>
                Royalties are set at <b>5%</b>. We will be contributing 10% of
                this back into the community vault for future{" "}
                <b>G.O.A.T Elves Expansions</b> (The G.O.A.T.VERSE and The P2E
                game). Read more about it in G.O.A.T Roadmap.
              </p>
            </dd>
            <dt>
              <a
                href={"#accordionfaq6"}
                aria-expanded="false"
                aria-controls="accordionfaq6"
                className="accordion-title accordionTitle js-accordionTrigger"
              >
                <span className="number">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x={0}
                    y={0}
                    viewBox="0 0 85 84"
                    xmlSpace="preserve"
                  >
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                            .faqs .st2 {\n                                                fill: none;\n                                                stroke: #000;\n                                                stroke-width: 8;\n                                                stroke-linecap: round;\n                                                stroke-linejoin: round;\n                                                stroke-miterlimit: 10\n                                            }\n                                        "
                      }}
                    />
                    <switch>
                      <g>
                        <path
                          style={{ fill: "#ffccff" }}
                          d="m4 40 39 40 38-39L42 4z"
                        />
                        <path
                          style={{ fill: "#ffccff" }}
                          d="m4 40 39 40 38-39-38 9z"
                        />
                        <path
                          className="st2"
                          d="m4 40 39 40 38-39L42 4zM42.5 6.64v70.57"
                        />
                        <path className="st2" d="m6 40 36.5 8.35L81 41" />
                      </g>
                    </switch>
                  </svg>
                </span>
                <span className="title">
                  WHEN I WILL GET MY G.O.A.T AFTER THE MINT?
                </span>
              </a>
            </dt>
            <dd
              className="accordion-content accordionItem is-collapsed"
              id="accordionfaq6"
              aria-hidden="true"
            >
              <p>
                Your Elf will be sent to your wallet right after the minting which
                might take few minutes.
                <br /> You can learn more about your rights as G.O.A.T Elves
                holder in G.O.A.T Roadmap.
              </p>
            </dd>
          </dl>
        </div>
      </div>
    </section>
    <section className="footer">
      <div className="container">
        <div className="ftleft">
          <div className="ftlogo">
            <svg viewBox="0 0 490 315" fill="none">
              <path
                d="M219.985 156.324c6.1 0 12.1 0 18 1.6.4.1.8.3 1.2.4 5 1.2 8.1 4.6 9.4 9.3 1.5 5.6 2.6 11.2 3.6 16.9 1.8 11 3.4 22.1 5.2 33.1.3 2.1 1 4.2 1.8 6.2 1.1 2.6 2.8 2.7 4.5.5 2.7-3.5 4.3-7.6 5.7-11.7 1.3-3.7 2.2-7.4 3.4-11.1 1-2.8 2.3-5.5 3.4-8.2 2.5-6.7 5-13.3 7.5-20 .6-1.6 1.3-3.1 2-4.6 2.1-4.1 5.5-6 10-6.1 6.5-.2 12.9.7 19.4 1.5 2.1.3 4.1.8 5.9 1.9 2.7 1.7 3.9 4.3 3.8 7.5-.3 7.2-3.4 13.6-6.2 20-2.8 6.5-6.2 12.7-9.2 19.1-5.3 10.9-10.6 21.7-15.7 32.7-3.8 8.3-7.2 16.9-11 25.2-1.2 2.7-3.3 5.1-5.2 7.3-.8.9-2.4 1.7-3.7 1.7-9.2.1-18.5-.1-27.6-1.5-4.2-.6-7.3-2.7-8.9-7-1.9-5.2-4.2-10.2-6.1-15.3-3.5-9.4-6.9-18.8-10.1-28.3-3.3-9.8-6.4-19.7-9.2-29.6-3.2-11.1-5.9-22.3-8.8-33.4-.8-3.2.6-5.2 3.7-6.3 4.3-1.9 8.8-1.8 13.2-1.8ZM88.685 146.124c1.3.1 2.6 0 3.9.3 3.1.7 5.3 2.7 6 5.8 1.3 5.8 2.5 11.7 3.4 17.6.9 5.8-1.2 8.9-6.9 10.5-4.1 1.1-8.3 1.8-12.5 2.6-5.2 1-8.1 5.9-6.4 10.9.9 2.6 3.1 4.3 6.3 4.1 3.4-.2 6.8-.8 10.2-1.5 2.9-.5 5.7-1.4 8.5-2 6.6-1.4 10.3.9 11.7 7.5 1 4.9 1.7 9.9 2.6 14.8.3 1.6.7 3.3 1.1 4.9 1 4.6-.6 7.6-5.2 8.6-3.5.8-7 .9-10.6 1.4-1.3.2-2.7.3-4 .7-3.7 1.3-5.8 5.5-4.9 9.3.5 2.1 2.4 3.7 5 3.5 3.5-.2 6.9-.8 10.4-1.5 3.3-.6 6.5-1.5 9.8-2.2 1.1-.2 2.4-.2 3.5-.2 1.4.1 2.5.8 2.8 2.3 1.5 6.6 3.1 13.1 4.5 19.7.2 1.1.3 2.3.3 3.4.2 4.9-1.7 8-6.3 9.5-3.7 1.2-7.6 2-11.5 2.6-6 .9-12 1.3-18 2.4-5.2 1-10.2 2.7-15.3 4-2.9.7-5.8 1.2-8.8.5-3.5-.8-5.7-2.8-6.2-6.4-2.3-17.9-7.9-34.9-13.2-52-4-12.9-8-25.9-11.7-38.9-2.3-8.3-3.8-16.7-4.2-25.3-.2-4.6 2.6-7.8 7.1-8.6 11.1-2.1 22.1-4.4 33.2-6.5 5-.9 10.1-1.5 15.2-2.3.2.4.2.4.2.5ZM113.285 135.624c-20.3-.4-35.9-9.5-47.6-25.9-6.5-9.1-10.4-19.3-11.9-30.3-.9-7-1.7-14.1-.3-21.1 2-10.1 7.6-18 15.4-24.4 8.8-7.2 19-11.9 30-14.8 6.2-1.7 12.5-2.8 18.8-3.8 5.3-.9 9.2 2.3 10.1 8.3.7 4.4.9 8.8 1.4 13.2.3 2.2.6 4.5 1.1 6.7.6 2.8-.2 5.3-2.6 6.9-2.7 1.8-5.9 2.3-9.1 2.7-4.9.7-9.9.8-14.6 2.1-6.8 1.7-12.3 5.5-14.2 12.8-1.4 5-.2 9.9 1.8 14.5 3.4 7.9 8.7 14.2 15.7 19.2.5.3 1 .6 1.6.8 2.3.6 4.2-1.2 3.6-3.5-1.4-5.3-2.9-10.6-4.2-16-.9-3.9-1.7-7.8-2.1-11.8-.5-5.1 2-8.5 7-9.5 5.7-1.1 11.5-2.3 17.2-2.7 6.8-.5 9.6 2 10.8 8.7 1.2 6.5 2 13 3.2 19.5 1.3 7.1 2.7 14.1 4.1 21.1.9 4.4 1.7 8.7.9 13.2-.8 4.2-3 7.3-6.9 8.8-3.5 1.3-7.2 2.1-10.9 2.8-6 1.3-12 2.7-18.3 2.5ZM367.585 314.024c-5.9-.2-11.5-1.9-17-3.8-7.5-2.6-15-5.4-22.6-7.9-2.7-.9-5.5-1.4-8.3-1.9-4-.6-6.9-3.8-7.2-8-.2-3.9.6-7.6 1.8-11.3 1.6-4.8 3.2-9.6 5-14.4 1.9-5.1 2.1-10.5 3.2-15.8 2.4-11.1 5.3-22 8-33 1.4-5.8 2.8-11.7 3.9-17.5.7-4 .8-8.1 1.6-12 .9-5 2.5-9.7 6.2-13.5 3.1-3.1 6.9-4.5 11.1-3.4 13.6 3.2 27.2 6.4 40.1 11.9 1.8.8 3.6 1.7 5.3 2.8 2.3 1.4 3.4 4.1 2.7 6.7-1.4 5.4-2.7 10.9-4.2 16.3-2 7.3-5.4 9.5-12.8 7.9-3.9-.9-7.8-2.2-11.6-3.6-4.1-1.6-7-.3-8.2 3.9l-.9 3.6c-.7 3.2.9 5.7 4.1 6.5 4 1 8 1.9 11.9 3 2.2.6 4.4 1.3 6.4 2.2 5.3 2.3 7 5.2 5.7 10.8-1.7 7.4-3.7 14.6-5.8 21.9-.8 2.9-3.4 4.3-6.6 3.5-3.5-.9-6.8-2.3-10.3-3.5-2.8-1-5.6-1.9-8.4-2.9-1.2-.4-2 0-2.4 1.2-.5 1.5-1 3.1-1.4 4.6-.9 3.7.3 6.6 3.7 8.4 3.6 2 7.6 2.6 11.6 3.3 2.1.4 4.3.7 6.4 1.2 2.8.6 4.5 2.4 4.1 5.3-.4 3.2-1.3 6.3-2.3 9.4-1 3.2-2.4 6.2-3.6 9.4-.4 1-.6 2.1-.8 3.1-.6 3.7-2.4 5.4-6.2 5.7-.6-.1-1.4-.1-2.2-.1ZM189.585 303.124c-11-.4-21.9-.6-32.9-1.1-4.7-.2-9.5-.7-14-2.5-3.2-1.3-4.8-3.8-4.9-6.8-.2-5.9-.3-11.8.1-17.6.7-10.3 1.7-20.5 2.7-30.8.4-4.5.9-8.9 1.4-13.4.8-6.6 1.2-13.2 1-19.9-.3-8.9-.5-17.8-.5-26.7 0-2.4.6-4.9 1.1-7.3 1.1-5 4.7-7.7 9.4-8.5 4.7-.7 9.6-.8 14.4-1 6.4-.3 12.7 0 19.1.9 4.5.7 7.2 3.4 7.7 8 .8 7 .2 14-.7 21-1 8.3-2 16.5-3.2 24.7-1.1 7.6-2.4 15.3-3.6 22.9-.7 4.5-1.7 8.9-2.1 13.4-.4 3.5.9 6.7 3.9 8.8 1.2.8 3 1.1 4.5 1.2 3.7.2 7.4.4 11 1.8 4.2 1.7 7.2 7.1 6.4 11.6-.8 4.7-1.6 9.5-2.2 14.2-.5 4.3-3.3 7.1-7.7 7.2-3.6-.1-7.2-.2-10.9-.1 0 0 0-.1 0 0ZM440.485 142.624c2.8.3 4.6.4 6.5.6 8.1 1 16.3 2 24.5 1.7h2.9c4.1.1 5.9 3.2 4.2 6.9-2.3 5-5.7 9.3-8.9 13.7-3.5 4.8-6.7 9.8-8.8 15.4-1.5 3.8-2.3 7.8-1.7 11.9.2 1.3.6 2.6 1 3.9 2.3 7.9 6.8 14.6 11.4 21.3 2.9 4.2 5.5 8.6 7.9 13.2 4.1 7.9 2.7 15.3-2.6 22.3-3.3 4.4-5.9 9.4-8.6 14.3-3.7 6.6-7.7 12.9-15.2 16-2 .8-4.1.9-6.3.4-3.3-.8-6.7-1.5-10.2-1.7-7.9-.4-15.7-.4-23.6-.8-3.3-.1-6.1-1.4-7.6-4.6-.2-.5-.1-1.2.1-1.7 2-4.9 6.3-8 9.9-11.7 2.4-2.5 5.1-4.7 7.6-7 3.9-3.6 7.1-7.8 9.4-12.7 2.5-5.6 1.8-11.1-.6-16.5-2.7-6.1-7.1-11.1-10.8-16.5-3.6-5.1-7.1-10.3-9.2-16.3-2-6-1.7-12-.2-18 1.8-7.6 5.5-14.2 10-20.4 1.7-2.3 3.1-5 5.2-7 4.1-3.7 8.9-6.2 13.7-6.7ZM403.685 113.124c-.2 6.4-.3 12.9-.5 19.3-.1 2.4-.2 4.9-.5 7.3-.4 3.5-3.9 7.3-8.1 7.2-7.5-.2-14.9.2-22.3-1.2-1.9-.3-3.8-.7-5.7-1.4-3.9-1.5-5.4-4.7-5.6-8.5-.1-2.4-.1-4.8.2-7.1 1.5-13.4 3-26.9 2.7-40.4-.1-4.3-.1-8.6-.9-12.7-.8-4.5-4.1-7-8.5-8.1-4.1-1-8.2-.9-12.4-.5-1 .1-1.9-.1-2.9-.2-1.2-.2-1.8-.9-2.3-2-1.2-3.3-1.3-6.7-1.1-10.1.2-5.4.7-10.9 1-16.3.1-.9 0-1.7 0-2.6-.2-2.9 1.3-4.6 4.3-4.6 2.7 0 5.4.2 8.1.1 11.4-.4 22.9-1 34.3-1.3 10.5-.3 21-.5 31.5-.2 5 .1 10.2.7 14.9 2.6.7.3 1.6.9 1.8 1.6.6 1.5 1.2 3.1 1.1 4.7-.5 7.1-1.1 14.1-1.9 21.1-.2 1.7-.9 3.3-1.7 4.8-1.1 2.3-3.1 3.3-5.5 3.5-2.1.2-4.3.1-6.5.1-4.9 0-9 3.7-10.3 8.4-3.1 10.9-3.1 22.1-3.1 33.3.1 1 0 2.1-.1 3.2 0 0 .1 0 0 0ZM250.785 74.924c-.1 8.4-1.4 16.6-5.2 24.2-6.8 13.5-18 21.2-32.7 23.6-15.3 2.4-29.3-1.1-41.3-10.9-12.4-10.1-17.4-23.7-16.8-39.3.8-20.2 14-35.6 34.3-40.3 13.2-3.1 26.1-2.1 38.2 4 15.9 7.9 23.6 21 23.5 38.7Zm-36.1 1.2v-1.6c-.4-6.9-4.4-11.8-10.4-13-8.2-1.6-13.6.8-16.9 7.6-2.2 4.6-2.9 9.5-1.7 14.5 1.2 5.5 4.1 9.6 9.8 10.9 6 1.3 11-.4 14.8-5.3 3-3.8 4.3-8.2 4.4-13.1ZM246.585 143.324c.9-4.8 1.6-9.7 2.8-14.4 1.6-6.6 3.5-13.1 5.4-19.6 1.5-5.1 3.2-10.2 4.6-15.3 1.1-3.9 1.9-7.9 2.9-11.9.3-1.4.8-2.8 1-4.2.9-5.1 1.7-10.3 2.6-15.4.8-4.3 1.4-8.6 2.5-12.8 1.6-6.2 7.5-10.6 13.6-10.4 3.5.1 6.2 1.9 8.3 4.5 2.4 3 4.4 6.3 6.7 9.5 1.3 1.8 2.7 3.6 4 5.4 1.2 1.7 2.4 3.5 3.6 5.1 2.1 2.8 4.3 5.5 6.5 8.2 2.1 2.6 4.3 5.2 6.5 7.8 2.1 2.5 4.2 4.9 6.3 7.4 2.1 2.5 4.2 4.9 6.2 7.4 3.1 3.7 6.3 7.4 9.1 11.3 3.9 5.4 7.5 11 11 16.7 1.5 2.3 2.2 5.1 0 7.5-.7.8-1.6 1.6-2.5 1.8-6.9 1.6-13.8 3.1-20.7 4.7-3.4.7-6.4-.2-9.2-2.1-4.4-3.1-8-6.9-11-11.3-1.3-2-2.6-4-4-5.9-1.9-2.6-5.5-3.6-8.8-2.6-2.5.8-4.1 3.2-4.4 6.4-.1 1.6-.4 3.1-.7 4.6-.9 4.5-2 8.9-2.8 13.5-.7 4.1-3.6 6-7.2 6.8-5.9 1.2-11.8 2-17.7 2.9-3.1.5-6.2.7-9.3 1.1-2.9.4-4.6-.8-4.9-3.7-.1-1-.1-1.9-.2-2.9 0-.1-.1-.1-.2-.1ZM31.885 63.624c-1.1-.3-2.2-.5-3.2-.9-7.4-3.1-13.3-8-18.3-14.3-4.7-5.8-8-12.3-10.1-19.4-.8-2.8.1-5.1 2.5-6.7.4-.2.7-.5 1-.8 1.3-1.2 2.3-1.2 3.7-.1 5.2 3.9 10.7 7.1 17.6 6.6 4.1-.3 8.3-.2 12.5-.1 1.4 0 2.8.3 4.1.8 3.8 1.5 5 5.3 3.1 8.8-3.3 6-5.6 12.2-6.7 19-.2 1-.5 1.9-.7 2.8-.9 3.1-2.2 4.1-5.5 4.3ZM459.285 51.724c-4 .1-7.4-1.8-7.8-5.9-.2-3.3-.8-6.6-1.1-10-.3-2.8-1.3-5.3-2.8-7.7-1.9-3.1-1.9-6 .3-7.8 1.2-1 2.8-2 4.4-2.2 4.1-.6 8.3-1 12.4-1.2 5.6-.2 10.3-2.2 14.5-5.9 1-.9 2.4-1.6 3.7-1.8 3.7-.8 7 2.4 6.3 6.1-2.7 13.4-9.1 24.5-20.2 32.6-3.1 2.3-6.4 4.1-9.7 3.8ZM449.485 100.024c0 8.9-5.7 14.7-14.1 14.7-8.5 0-15-6.4-15-14.8 0-7.7 6.2-13.4 14.6-13.4 8.5.1 14.5 5.7 14.5 13.5ZM182.785 142.424c-.2 5-2.1 9.7-7.6 12-5.8 2.5-11.3 1.6-16-2.5-4.3-3.7-5.4-8.7-3.9-14.1 1-3.5 3.3-6 6.7-7.5 4.9-2.2 9.8-2 14.5.4 4.3 2.3 6.3 6.1 6.3 11.7ZM260.985 29.224c0 5.6-3.8 9.3-9.3 9.3-5.7 0-9.9-4.2-9.8-9.7.1-4.9 4.1-8.5 9.6-8.5 5.7.1 9.5 3.7 9.5 8.9ZM352.085 152.524c0 5.6-3.8 9.4-9.4 9.3-5.6-.1-9.7-4.2-9.7-9.6 0-5 4.2-8.6 9.7-8.5 5.7.1 9.5 3.6 9.4 8.8Z"
                fill="#5543DB"
              />
              <path
                d="M219.985 147.224c6.1 0 12.1 0 18 1.6.4.1.8.3 1.2.4 5 1.2 8.1 4.6 9.4 9.3 1.5 5.6 2.6 11.2 3.6 16.9 1.8 11 3.4 22.1 5.2 33.1.3 2.1 1 4.2 1.8 6.2 1.1 2.6 2.8 2.7 4.5.5 2.7-3.5 4.3-7.6 5.7-11.7 1.3-3.7 2.2-7.4 3.4-11.1 1-2.8 2.3-5.5 3.4-8.2 2.5-6.7 5-13.3 7.5-20 .6-1.6 1.3-3.1 2-4.6 2.1-4.1 5.5-6 10-6.1 6.5-.2 12.9.7 19.4 1.5 2.1.3 4.1.8 5.9 1.9 2.7 1.7 3.9 4.3 3.8 7.5-.3 7.2-3.4 13.6-6.2 20-2.8 6.5-6.2 12.7-9.2 19.1-5.3 10.9-10.6 21.7-15.7 32.7-3.8 8.3-7.2 16.9-11 25.2-1.2 2.7-3.3 5.1-5.2 7.3-.8.9-2.4 1.7-3.7 1.7-9.2.1-18.5-.1-27.6-1.5-4.2-.6-7.3-2.7-8.9-7-1.9-5.2-4.2-10.2-6.1-15.3-3.5-9.4-6.9-18.8-10.1-28.3-3.3-9.8-6.4-19.7-9.2-29.6-3.2-11.1-5.9-22.3-8.8-33.4-.8-3.2.6-5.2 3.7-6.3 4.3-1.9 8.8-1.8 13.2-1.8ZM88.685 137.024c1.3.1 2.6 0 3.9.3 3.1.7 5.3 2.7 6 5.8 1.3 5.8 2.5 11.7 3.4 17.6.9 5.8-1.2 8.9-6.9 10.5-4.1 1.1-8.3 1.8-12.5 2.6-5.2 1-8.1 5.9-6.4 10.9.9 2.6 3.1 4.3 6.3 4.1 3.4-.2 6.8-.8 10.2-1.5 2.9-.5 5.7-1.4 8.5-2 6.6-1.4 10.3.9 11.7 7.5 1 4.9 1.7 9.9 2.6 14.8.3 1.6.7 3.3 1.1 4.9 1 4.6-.6 7.6-5.2 8.6-3.5.8-7 .9-10.6 1.4-1.3.2-2.7.3-4 .7-3.7 1.3-5.8 5.5-4.9 9.3.5 2.1 2.4 3.7 5 3.5 3.5-.2 6.9-.8 10.4-1.5 3.3-.6 6.5-1.5 9.8-2.2 1.1-.2 2.4-.2 3.5-.2 1.4.1 2.5.8 2.8 2.3 1.5 6.6 3.1 13.1 4.5 19.7.2 1.1.3 2.3.3 3.4.2 4.9-1.7 8-6.3 9.5-3.7 1.2-7.6 2-11.5 2.6-6 .9-12 1.3-18 2.4-5.2 1-10.2 2.7-15.3 4-2.9.7-5.8 1.2-8.8.5-3.5-.8-5.7-2.8-6.2-6.4-2.3-17.9-7.9-34.9-13.2-52-4-12.9-8-25.9-11.7-38.9-2.3-8.3-3.8-16.7-4.2-25.3-.2-4.6 2.6-7.8 7.1-8.6 11.1-2.1 22.1-4.4 33.2-6.5 5-.9 10.1-1.5 15.2-2.3.2.4.2.5.2.5ZM113.285 126.624c-20.3-.4-35.9-9.5-47.6-25.9-6.5-9.1-10.4-19.3-11.9-30.3-.9-7-1.7-14.1-.3-21.1 2-10.1 7.6-18 15.4-24.4 8.8-7.2 19-11.9 30-14.8 6.2-1.7 12.5-2.8 18.8-3.8 5.3-.9 9.2 2.3 10.1 8.3.7 4.4.9 8.8 1.4 13.2.3 2.2.6 4.5 1.1 6.7.6 2.8-.2 5.3-2.6 6.9-2.7 1.8-5.9 2.3-9.1 2.7-4.9.7-9.9.8-14.6 2.1-6.8 1.7-12.3 5.5-14.2 12.8-1.4 5-.2 9.9 1.8 14.5 3.4 7.9 8.7 14.2 15.7 19.2.5.3 1 .6 1.6.8 2.3.6 4.2-1.2 3.6-3.5-1.4-5.3-2.9-10.6-4.2-16-.9-3.9-1.7-7.8-2.1-11.8-.5-5.1 2-8.5 7-9.5 5.7-1.1 11.5-2.3 17.2-2.7 6.8-.5 9.6 2 10.8 8.7 1.2 6.5 2 13 3.2 19.5 1.3 7.1 2.7 14.1 4.1 21.1.9 4.4 1.7 8.7.9 13.2-.8 4.2-3 7.3-6.9 8.8-3.5 1.3-7.2 2.1-10.9 2.8-6 1.2-12 2.7-18.3 2.5ZM367.585 304.924c-5.9-.2-11.5-1.9-17-3.8-7.5-2.6-15-5.4-22.6-7.9-2.7-.9-5.5-1.4-8.3-1.9-4-.6-6.9-3.8-7.2-8-.2-3.9.6-7.6 1.8-11.3 1.6-4.8 3.2-9.6 5-14.4 1.9-5.1 2.1-10.5 3.2-15.8 2.4-11.1 5.3-22 8-33 1.4-5.8 2.8-11.7 3.9-17.5.7-4 .8-8.1 1.6-12 .9-5 2.5-9.7 6.2-13.5 3.1-3.1 6.9-4.5 11.1-3.4 13.6 3.2 27.2 6.4 40.1 11.9 1.8.8 3.6 1.7 5.3 2.8 2.3 1.4 3.4 4.1 2.7 6.7-1.4 5.4-2.7 10.9-4.2 16.3-2 7.3-5.4 9.5-12.8 7.9-3.9-.9-7.8-2.2-11.6-3.6-4.1-1.6-7-.3-8.2 3.9l-.9 3.6c-.7 3.2.9 5.7 4.1 6.5 4 1 8 1.9 11.9 3 2.2.6 4.4 1.3 6.4 2.2 5.3 2.3 7 5.2 5.7 10.8-1.7 7.4-3.7 14.6-5.8 21.9-.8 2.9-3.4 4.3-6.6 3.5-3.5-.9-6.8-2.3-10.3-3.5-2.8-1-5.6-1.9-8.4-2.9-1.2-.4-2 0-2.4 1.2-.5 1.5-1 3.1-1.4 4.6-.9 3.7.3 6.6 3.7 8.4 3.6 2 7.6 2.6 11.6 3.3 2.1.4 4.3.7 6.4 1.2 2.8.6 4.5 2.4 4.1 5.3-.4 3.2-1.3 6.3-2.3 9.4-1 3.2-2.4 6.2-3.6 9.4-.4 1-.6 2.1-.8 3.1-.6 3.7-2.4 5.4-6.2 5.7-.6-.1-1.4-.1-2.2-.1ZM189.585 294.024c-11-.4-21.9-.6-32.9-1.1-4.7-.2-9.5-.7-14-2.5-3.2-1.3-4.8-3.8-4.9-6.8-.2-5.9-.3-11.8.1-17.6.7-10.3 1.7-20.6 2.7-30.8.4-4.5.9-8.9 1.4-13.4.8-6.6 1.2-13.2 1-19.9-.3-8.9-.5-17.8-.5-26.7 0-2.4.6-4.9 1.1-7.3 1.1-5 4.7-7.7 9.4-8.5 4.7-.7 9.6-.8 14.4-1 6.4-.3 12.7 0 19.1.9 4.5.7 7.2 3.4 7.7 8 .8 7 .2 14-.7 21-1 8.3-2 16.5-3.2 24.7-1.1 7.6-2.4 15.3-3.6 22.9-.7 4.5-1.7 8.9-2.1 13.4-.4 3.5.9 6.7 3.9 8.8 1.2.8 3 1.1 4.5 1.2 3.7.2 7.4.4 11 1.8 4.2 1.7 7.2 7.1 6.4 11.6-.8 4.7-1.6 9.5-2.2 14.2-.5 4.3-3.3 7.1-7.7 7.2-3.6-.1-7.2-.2-10.9-.1ZM440.485 133.524c2.8.3 4.6.4 6.5.6 8.1 1 16.3 2 24.5 1.7h2.9c4.1.1 5.9 3.2 4.2 6.9-2.3 5-5.7 9.3-8.9 13.7-3.5 4.8-6.7 9.8-8.8 15.4-1.5 3.8-2.3 7.8-1.7 11.9.2 1.3.6 2.6 1 3.9 2.3 7.9 6.8 14.6 11.4 21.3 2.9 4.2 5.5 8.6 7.9 13.2 4.1 7.9 2.7 15.3-2.6 22.3-3.3 4.4-5.9 9.4-8.6 14.3-3.7 6.6-7.7 12.9-15.2 16-2 .8-4.1.9-6.3.4-3.3-.8-6.7-1.5-10.2-1.7-7.9-.4-15.7-.4-23.6-.8-3.3-.1-6.1-1.4-7.6-4.6-.2-.5-.1-1.2.1-1.7 2-4.9 6.3-8 9.9-11.7 2.4-2.5 5.1-4.7 7.6-7 3.9-3.6 7.1-7.8 9.4-12.7 2.5-5.6 1.8-11.1-.6-16.5-2.7-6.1-7.1-11.1-10.8-16.5-3.6-5.1-7.1-10.3-9.2-16.3-2-6-1.7-12-.2-18 1.8-7.6 5.5-14.2 10-20.4 1.7-2.3 3.1-5 5.2-7 4.1-3.7 8.9-6.2 13.7-6.7ZM403.685 104.124c-.2 6.4-.3 12.9-.5 19.3-.1 2.4-.2 4.9-.5 7.3-.4 3.5-3.9 7.3-8.1 7.2-7.5-.2-14.9.2-22.3-1.2-1.9-.3-3.8-.7-5.7-1.4-3.9-1.5-5.4-4.7-5.6-8.5-.1-2.4-.1-4.8.2-7.1 1.5-13.4 3-26.9 2.7-40.4-.1-4.3-.1-8.6-.9-12.7-.8-4.5-4.1-7-8.5-8.1-4.1-1-8.2-.9-12.4-.5-1 .1-1.9-.1-2.9-.2-1.2-.2-1.8-.9-2.3-2-1.2-3.3-1.3-6.7-1.1-10.1.2-5.4.7-10.9 1-16.3.1-.9 0-1.7 0-2.6-.2-2.9 1.3-4.6 4.3-4.6 2.7 0 5.4.2 8.1.1 11.4-.4 22.9-1 34.3-1.3 10.5-.3 21-.5 31.5-.2 5 .1 10.2.7 14.9 2.6.7.3 1.6.9 1.8 1.6.6 1.5 1.2 3.1 1.1 4.7-.5 7.1-1.1 14.1-1.9 21.1-.2 1.7-.9 3.3-1.7 4.8-1.1 2.3-3.1 3.3-5.5 3.5-2.1.2-4.3.1-6.5.1-4.9 0-9 3.7-10.3 8.4-3.1 10.9-3.1 22.1-3.1 33.3.1.9 0 2-.1 3.2 0 0 .1 0 0 0ZM250.785 65.824c-.1 8.4-1.4 16.6-5.2 24.2-6.8 13.5-18 21.2-32.7 23.6-15.3 2.4-29.3-1.1-41.3-10.9-12.4-10.1-17.4-23.7-16.8-39.3.8-20.2 14-35.6 34.3-40.3 13.2-3.1 26.1-2.1 38.2 4 15.9 7.9 23.6 21 23.5 38.7Zm-36.1 1.2v-1.6c-.4-6.9-4.4-11.8-10.4-13-8.2-1.6-13.6.8-16.9 7.6-2.2 4.6-2.9 9.5-1.7 14.5 1.2 5.5 4.1 9.6 9.8 10.9 6 1.3 11-.4 14.8-5.3 3-3.8 4.3-8.2 4.4-13.1ZM246.585 134.224c.9-4.8 1.6-9.7 2.8-14.4 1.6-6.6 3.5-13.1 5.4-19.6 1.5-5.1 3.2-10.2 4.6-15.3 1.1-3.9 1.9-7.9 2.9-11.9.3-1.4.8-2.8 1-4.2.9-5.1 1.7-10.3 2.6-15.4.8-4.3 1.4-8.6 2.5-12.8 1.6-6.2 7.5-10.6 13.6-10.4 3.5.1 6.2 1.9 8.3 4.5 2.4 3 4.4 6.3 6.7 9.5 1.3 1.8 2.7 3.6 4 5.4 1.2 1.7 2.4 3.5 3.6 5.1 2.1 2.8 4.3 5.5 6.5 8.2 2.1 2.6 4.3 5.2 6.5 7.8 2.1 2.5 4.2 4.9 6.3 7.4 2.1 2.5 4.2 4.9 6.2 7.4 3.1 3.7 6.3 7.4 9.1 11.3 3.9 5.4 7.5 11 11 16.7 1.5 2.3 2.2 5.1 0 7.5-.7.8-1.6 1.6-2.5 1.8-6.9 1.6-13.8 3.1-20.7 4.7-3.4.7-6.4-.2-9.2-2.1-4.4-3.1-8-6.9-11-11.3-1.3-2-2.6-4-4-5.9-1.9-2.6-5.5-3.6-8.8-2.6-2.5.8-4.1 3.2-4.4 6.4-.1 1.6-.4 3.1-.7 4.6-.9 4.5-2 8.9-2.8 13.5-.7 4.1-3.6 6-7.2 6.8-5.9 1.2-11.8 2-17.7 2.9-3.1.5-6.2.7-9.3 1.1-2.9.4-4.6-.8-4.9-3.7-.1-1-.1-1.9-.2-2.9l-.2-.1ZM31.885 54.524c-1.1-.3-2.2-.5-3.2-.9-7.4-3.1-13.3-8-18.3-14.3-4.7-5.8-8-12.3-10.1-19.4-.8-2.8.1-5.1 2.5-6.7.4-.2.7-.5 1-.8 1.3-1.2 2.3-1.2 3.7-.1 5.2 3.9 10.7 7.1 17.6 6.6 4.1-.3 8.3-.2 12.5-.1 1.4 0 2.8.3 4.1.8 3.8 1.5 5 5.3 3.1 8.8-3.3 6-5.6 12.2-6.7 19-.2 1-.5 1.9-.7 2.8-.9 3.1-2.2 4.1-5.5 4.3ZM459.285 42.624c-4 .1-7.4-1.8-7.8-5.9-.2-3.3-.8-6.6-1.1-10-.3-2.8-1.3-5.3-2.8-7.7-1.9-3.1-1.9-6 .3-7.8 1.2-1 2.8-2 4.4-2.2 4.1-.6 8.3-1 12.4-1.2 5.6-.2 10.3-2.2 14.5-5.9 1-.9 2.4-1.6 3.7-1.8 3.7-.8 7 2.4 6.3 6.1-2.7 13.4-9.1 24.5-20.2 32.6-3.1 2.3-6.4 4.1-9.7 3.8ZM449.485 91.024c0 8.9-5.7 14.7-14.1 14.7-8.5 0-15-6.4-15-14.8 0-7.7 6.2-13.4 14.6-13.4 8.5 0 14.5 5.6 14.5 13.5ZM182.785 133.324c-.2 5-2.1 9.7-7.6 12-5.8 2.5-11.3 1.6-16-2.5-4.3-3.7-5.4-8.7-3.9-14.1 1-3.5 3.3-6 6.7-7.5 4.9-2.2 9.8-2 14.5.4 4.3 2.3 6.3 6.1 6.3 11.7ZM260.985 20.124c0 5.6-3.8 9.3-9.3 9.3-5.7 0-9.9-4.2-9.8-9.7.1-4.9 4.1-8.5 9.6-8.5 5.7.1 9.5 3.7 9.5 8.9ZM352.085 143.424c0 5.6-3.8 9.4-9.4 9.3-5.6-.1-9.7-4.2-9.7-9.6 0-5 4.2-8.6 9.7-8.5 5.7.1 9.5 3.6 9.4 8.8Z"
                fill="#B0FEFE"
              />
              <path
                d="M443.585 181.124c.1-8 1.9-14.6 5.2-20.7 1.9-3.5 4.3-6.9 6.8-10 2.2-2.7 5.2-3 7.5-1.3 2.5 1.9 2.8 4.8.6 7.4-2.8 3.3-5.2 6.9-6.9 10.9-3.9 9-4.3 17.7 1.1 26.3 1.1 1.7 2 3.6 2.7 5.5 1 2.7 0 5.3-2.4 6.5-2.2 1.1-4.9.5-6.4-1.9-3.3-5.3-6.6-10.7-7.6-17-.3-2.2-.5-4.5-.6-5.7ZM241.985 64.824c.1 4.6-3.7 7.4-7.2 5.6-2-1-2.9-2.8-3.1-5-.5-5.6-2-10.9-4.9-15.8-2.2-3.7-5.2-6.6-9.2-8.3-1.3-.6-2.7-1.5-3.6-2.6-2.2-3 .2-7.5 4-7.4 2 .1 4.1.8 6 1.7 6.4 3.3 10.7 8.7 13.6 15.1 2.5 5.3 3.9 11 4.4 16.7ZM188.185 182.524c-.4 4.6-.9 11.1-1.5 17.6-.1 1.3-.6 2.7-1.4 3.7-1.1 1.7-2.9 2.5-5 1.9-2.1-.6-3.4-2-3.8-4.2-.2-.9-.1-1.9-.1-2.9.5-6.2 1.2-12.5 1.6-18.7.1-2.1-.2-4.2-.6-6.2-.1-.7-1-1.5-1.7-1.9-2.6-1.4-3.9-3.5-3.3-5.9.6-2.5 2.9-4.1 5.8-3.8 4.2.4 6.8 2.9 8.4 6.6 1.7 3.9 1.7 7.9 1.6 13.8ZM307.085 69.524c-.2 2.2-1.6 4.2-3.5 4.9-2 .8-4.2.2-5.6-1.7-1.7-2.3-3.2-4.9-4.9-7.3-4.8-7-9.8-14-15.6-20.2-2.2-2.3-2.4-4.9-.5-7.1 1.8-2.1 4.9-2.4 7.3-.3 2.1 1.8 4 3.8 5.6 6 5.3 7.3 10.5 14.6 15.6 22 .8 1.1 1.1 2.5 1.6 3.7ZM298.585 191.924c.7-1.6 1.8-3.8 2.8-6 2.6-5.6 5.1-11.2 7.7-16.7.5-1 1-2 1.8-2.9 1.6-1.8 3.9-2.3 5.8-1.3 2 1 3.3 3.3 2.6 5.6-.6 2.3-1.6 4.6-2.6 6.8-2.6 5.6-5.2 11.1-7.9 16.6-.5 1-1.2 1.9-2.1 2.7-1.5 1.4-3.3 1.7-5.1.9-1.9-1-2.9-2.7-3-5.7ZM246.685 175.424c0 2.9-1.8 5.2-4.3 5.5-2.4.4-4.9-1.2-5.6-3.9-1.1-3.9-1.9-7.8-2.9-11.6-.5-1.7-1.1-3.4-1.6-5.1-1-3-.6-5.3 1.3-6.9 2.8-2.4 6.8-1.4 8.1 2.5 1.9 6.1 3.4 12.3 5 18.4v1.1ZM77.285 75.424c0-2.7 1.7-4.9 4.3-5.3 2.3-.4 4.7 1.1 5.7 3.8 1.5 4.4 4.2 7.8 7.5 11 .7.7 1.4 1.3 2 2.1 1.6 2.2 1.5 4.6-.3 6.5-1.7 1.8-4.4 2.1-6.5.7-4-2.7-7-6.4-9.5-10.5-2.5-4.2-3.2-6.2-3.2-8.3ZM21.785 32.124c-4.8-.2-9.3-1.5-13.5-3.8-2.8-1.6-3.8-4.3-2.7-6.7 1.3-2.7 4.1-3.8 7.1-2.5 3.7 1.7 7.4 2.7 11.6 2.5 2.8-.1 5 2 5.2 4.6.2 2.4-1.5 4.7-4.2 5.4-1.1.3-2.3.3-3.5.5ZM112.685 9.924c2.2 0 4.1.8 5.7 2.3 3.4 3.3 5 7.4 5.3 12 .2 2.2-1 3.9-2.9 4.9-1.7.9-3.5.8-4.8-.5-1-1-1.7-2.4-2.4-3.7-.3-.5-.3-1.2-.4-1.7-.5-1.6-1.2-2.8-3.2-3.1-2.2-.3-3.7-2.6-3.8-4.7 0-2.2 1.7-4.4 4.1-5.1.8-.2 1.6-.2 2.4-.4ZM425.685 35.724c-.8 3.2-1.5 6.5-2.6 9.6-1 2.8-4 4.1-6.6 3.1-2.4-.9-3.8-3.8-2.9-6.6 1-3.3 1.8-6.5.9-10-.6-2.5 1.3-5 3.8-5.6 2.5-.6 5.1.9 6 3.5.2.6.4 1.2.5 1.9.2 1.3.3 2.7.5 4 .1 0 .3.1.4.1ZM126.685 54.824c2.8.1 5 1.6 6.5 4.1 1.9 3.1 3 6.6 3.5 10.2.5 4.1-3.4 7-6.9 5.4-1.7-.8-2.7-2.3-3.2-4-.2-.6-.4-1.2-.5-1.9-.4-2.1-1.3-3.6-3.4-4.6-1.9-.9-2.5-3.3-2-5.2.7-2.4 3.1-4 6-4ZM461.985 11.124c2.1-.5 4.2-.8 6.2-1.5 3.7-1.2 6.4-.2 7.6 3 .7 1.8-.1 4.4-2 5.5-4.7 2.8-9.7 3.9-15.1 2.5-2.9-.8-4.5-3.4-4.1-5.8.5-2.6 2.8-4.2 5.9-4.1.4 0 .9 0 1.3.1.1 0 .1.2.2.3ZM396.685 183.824c-.4 3.2-.5 6.3-2.3 8.9-1.4 2-3.4 2.7-5.4 2.1-2-.6-3.6-2.7-3.6-4.9 0-.9.3-1.8.4-2.7.1-1.4.4-2.9.3-4.3-.2-2.9 1.2-5.4 3.7-6 2.6-.6 5.6 1.2 6.4 4 .3.9.3 2 .5 2.9ZM108.185 198.324c0 3.7-1.9 6-4.3 6.4-2.4.3-4.8-1.3-5.5-3.8-.5-1.5-.9-3.1-1.3-4.7-.7-2.7.6-5.3 3-6.3 2.3-1 5.1 0 6.3 2.5.9 2.2 1.4 4.6 1.8 5.9ZM386.385 234.024c-.5 1.3-.8 2.6-1.5 3.7-1 1.8-3.2 2.6-5 2.2-2.1-.5-3.4-2-3.9-4.1-.2-.8-.3-1.6-.6-2.3-1.3-3.4-.5-5.9 2.3-7.3 2.5-1.2 5.9.3 7.3 3.2.7 1.4 1 3 1.4 4.6ZM205.185 271.024c-.5 1.3-.9 2.8-1.7 3.9-2.1 2.8-6.2 2.4-7.9-.8-.7-1.2-1.2-2.5-1.9-3.7-1.1-2-.9-3.9.5-5.6 1.4-1.7 3.8-2.3 5.9-1.5 3 1.2 4.8 4 5.1 7.7ZM93.885 149.424c0 1.8-1 3.5-2.9 4.4-1.9.9-4 .6-5.5-1-1.3-1.4-2.5-2.9-3.3-4.5-.9-1.9-.2-4 1.3-5.3 1.7-1.4 3.6-1.7 5.6-.7 2.7 1.3 4.8 4.3 4.8 7.1ZM110.185 242.224c0-2.4 1.3-4.4 3.3-5.1 1.9-.7 3.9-.1 5.4 1.6 2.1 2.4 2.4 6 .7 8.2-1.8 2.4-4.9 2.6-7.1.6-1.6-1.5-2.2-3.4-2.3-5.3ZM370.785 285.124c-2.6 0-5.2-2.9-5.2-5.8s2.2-5.2 4.9-5.2 5.2 2.7 5.3 5.6c.1 2.6-2.5 5.4-5 5.4ZM347.885 142.024c0 2.5-2.2 4.8-4.8 4.8-2.5 0-4.8-2.3-4.8-4.8s2.2-4.6 4.7-4.7c2.6-.1 4.9 2.2 4.9 4.7ZM175.685 128.624c0 2.5-2.3 4.8-4.8 4.8-2.4 0-4.6-2.2-4.7-4.7 0-2.5 2.2-4.8 4.7-4.8 2.5-.1 4.8 2.2 4.8 4.7ZM237.785 84.024c-2.5 0-4.8-2.3-4.7-4.8.1-2.5 2.3-4.6 4.7-4.6 2.5 0 4.8 2.3 4.8 4.8 0 2.3-2.3 4.6-4.8 4.6ZM252.485 23.224c-2.5 0-4.8-2.3-4.8-4.8s2.3-4.8 4.8-4.7c2.4 0 4.6 2.2 4.6 4.7.2 2.5-2 4.8-4.6 4.8ZM295.585 211.424c-2.5 0-4.8-2.1-4.8-4.7 0-2.5 2.2-4.8 4.7-4.8s4.6 2.2 4.7 4.6c.1 2.6-2.1 4.9-4.6 4.9ZM140.385 83.024c0 2.5-2.2 4.8-4.7 4.8s-4.8-2.3-4.8-4.8c0-2.4 2.2-4.6 4.7-4.7 2.5 0 4.8 2.2 4.8 4.7ZM309.685 87.824c-2.5 0-4.8-2.2-4.7-4.8 0-2.5 2.3-4.7 4.8-4.7s4.6 2.2 4.7 4.7c0 2.6-2.2 4.8-4.8 4.8ZM436.985 81.324c2.6 0 4.8 2.2 4.8 4.7s-2.2 4.7-4.8 4.7c-2.4 0-4.6-2.2-4.7-4.7-.1-2.5 2.1-4.7 4.7-4.7ZM467.685 214.424c0 2.5-2.1 4.7-4.6 4.7-2.6 0-4.8-2.2-4.8-4.7s2.2-4.8 4.7-4.8c2.6 0 4.8 2.2 4.7 4.8Z"
                fill="#fff"
              />
            </svg>
          </div>
          <p>
            Thank you for being with us.
            <br />
            Join our communities and keep track of the latest news.
            <br />
            <strong>© 2022 G.O.A.T Elves Project, ALL RIGHTS RESERVED</strong>
          </p>
        </div>
        <div className="ftright">
          <a
            href={"https://discord.com/invite/goatelves"}
            target="_blank"
            rel="noreferrer"
            className="discord"
          >
            <img src="assets/images/footer/discord.svg" alt="" />
          </a>
          <a
            href={"https://twitter.com/goatelves"}
            target="_blank"
            rel="noreferrer"
            className="twitter"
          >
            <img src="assets/images/footer/twitter.svg" alt="" />
          </a>
          <a
            href={"https://www.instagram.com/goat.elves/"}
            target="_blank"
            rel="noreferrer"
            className="instagram"
          >
            <img src="assets/images/footer/instagram.svg" alt="" />
          </a>
          {/* <a href={"https://telegram.me"} target="_blank" rel="noreferrer" className="telegram">
            <img src="assets/images/footer/telegram.svg" alt="" />
          </a> */}

          <a href={"https://raritysniper.com/"} style={{position: "absolute", left: "-100%", opacity: 0, visibility: "hidden", width: 0, height: 0}}>NFT Rarity</a>
        </div>
      </div>
    </section>
  </div>
  
  );
  
};

export default Home;

